import { useEffect, useMemo, useRef, useState } from "react";
import { dmd_utils } from "../utils/frfr-dmd-utils";
import { json_utils } from "../utils/frfr-json-utils";
import { rapidozi_dummy_utils, rapidozi_dummysmarty_utils, smartydummy_backend_special_instance } from "../utils/frfr-rapidozi-dummy-utils";
import { _zzyourmap_ajax } from "../utils/zz/zz-yourmap-ajax-adapter";
import Btn from "./Btn";
import CardCollapsible from "./CardCollapsible";
import JSDisplayValue from "./JSDisplayValue";
import JSUniValueEditor from "./JSUniValueEditor";
import Komentar from "./Komentar";
import UniBtn, { UniBtnPack, UniBtnSoftDeleteToggle } from "./UniBtn";
import UniImage from "./UniImage";
import ViewGeneratorSimpleV3 from "./ViewGeneratorSimpleV3";
import { frfr_res_utils } from '../utils/frfr-res-utils';
import { js_utils } from "../utils/frfr-js-utils";
import { _zzyourmap_formDefinition_destination_formPart_main_img, _zzyourmap_formDefinition_formPart_editing, _zzyourmap_formDefinition_smestaj_formPart_gallery, _zzyourmap_formDefinition_smestaj_formPart_kontakt, _zzyourmap_formDefinition_smestaj_formPart_main_img, _zzyourmap_formDefinition_smestaj_formPart_marker, _zzyourmap_formDefinition_smestaj_formPart_parent_destinacija_id, _zzyourmap_formDefinition_ymthing_prefilter_vr_tablename } from "../utils/zz/zz-yourmap-admin-form-utils";
import FormGenerator from "./FormGenerator";
import { _zzyourmap_formDefinition_destination, _zzyourmap_preset_destination, _zzyourmap_prepare_entbox_for_submit_destination, _zzyourmap_preset_smestaj, _zzyourmap_prepare_entbox_for_submit_smestaj, _zzyourmap_formDefinition_ostalo_v1, _zzyourmap_preset_ostalo_v1, _zzyourmap_prepare_entbox_for_submit_ostalo_v1, _zzyourmap_formDefinition_adminLogin, _zzyourmap_formDefinition_smestaj_formPart_checks } from "../utils/zz/zz-yourmap-admin-form-utils";
import YourmapImageLibraryV4 from "./YourmapImageLibraryV4";
import { useHandleInputChange } from "../hooks/useHandleInputChange";
import UniSpinnerClassic from "./UniSpinnerClassic";
import YourmapLeafletContainerUniversal from "./YourmapLeafletContainerUniversal";
import UniLimiter from "./UniLimiter";
import YourmapEditorjsDemoV1 from "./YourmapEditorjsDemoV1";
import YourmapMapPageWrapper from "./YourmapMapPageWrapper";
import UniIndent from "./UniIndent";
import { _zzyourmap_extract_map_props_1_for_smestaj_position_picker, _zzyourmap_extract_smestaj_map_marker_item_props } from "../utils/zz/zz-yourmap-map-utils";
import { _zzyourmap_convert_layer_title_to_layer_key } from "../utils/zz/zz-yourmap-layer-utils";
import FrfrAlienEditorjsRendererV1 from "./FrfrAlienEditorjsRendererV1";
import HelpWidget from "./HelpWidget";
import YourmapEditorjsV2 from "./YourmapEditorjsV2";
import { _zzyourmap_img_url_full_from_parts } from "../utils/zz/zz-yourmap-image-utils";
import { _zzyourmap_extract_editorjs_renderable_data, _zzyourmap_update_special_blog_post_data } from "../utils/zz/zz-yourmap-blog-post-utils";
import YourmapDocs from "./YourmapDocs";
import { Easy69_v1 } from "../utils/frfr-easy69-utils";
import FormFieldGenerator from "./FormFieldGenerator";
import ViewGeneratorSimpleV4 from "./ViewGeneratorSimpleV4";
import FilterChipGroup from "./FilterChipGroup";
import FilterSelect from "./FilterSelect";
import { app_build_version_id_zzyourmap, _zzyourmap_config } from "../utils/zz/zz-yourmap-config";
import XLSX from 'xlsx';
// import { app_build_version_id } from "../index.js"; // Use ../ to get up from components folder

// ── vr_tablename chip options for Djuture filter bar ──────────────
const _YMTHING_VR_TABLENAME_CHIPS = [
  { label: 'All', value: '' },
  { label: 'Smeštaj', value: 'ym_table_smestaj' },
  { label: 'Restoran', value: 'ym_table_restoran' },
  { label: 'Aktivnosti', value: 'ym_table_aktivnost' },
  { label: 'Prodavnice', value: 'ym_table_prodavnica' },
  { label: 'Servis', value: 'ym_table_servis' },
  { label: 'Znamenitosti', value: 'ym_table_znamenitost' },
  { label: 'Znamenitosti', value: 'ym_table_znamenitosti' },
  { label: 'Ostalo', value: 'ym_table_ostalo_v2' },
  { label: 'Blog', value: 'ym_table_ostalo_v1' },
  { label: 'Ignored', value: 'ym_table_ignored' },
];

const _ymthing_format_vr_tablename_for_display = (rawValue, valueToLabelMap) => {
  if (typeof rawValue !== 'string') {
    return rawValue;
  }
  const normalized = rawValue.trim();
  if (normalized === '') {
    return '';
  }
  if (valueToLabelMap && typeof valueToLabelMap === 'object' && typeof valueToLabelMap[normalized] === 'string') {
    return valueToLabelMap[normalized];
  }
  return normalized.replace(/^ym_table_/i, '');
};

const _YMTHING_TAB_OPTIONS_FOR_DISPLAY_ORDER = [
  { key: 'smestaji', title: 'Smeštaji', icon: 'fa fa-bed' },
  { key: 'restorani', title: 'Restorani', icon: 'fa fa-cutlery' },
  { key: 'servisi', title: 'Servisi', icon: 'fa fa-map-pin' },
  { key: 'prodavnice', title: 'Prodavnice', icon: 'fa fa-shopping-bag' },
  { key: 'aktivnosti', title: 'Aktivnosti', icon: 'fa fa-street-view' },
  { key: 'znamenitosti', title: 'Znamenitosti', icon: 'fa fa-tree' },
  { key: 'ostalo', title: 'Ostalo', icon: 'fa fa-sticky-note-o' },
  { key: 'map_legend', title: 'Legenda mape', icon: 'fa fa-list-ol' },
];

const _YM_MARKER_BULK_ANIMATION_OPTIONS = [
  { label: 'Ne menjaj', value: 'keep' },
  { label: 'Bez animacije', value: 'clear' },
  { label: 'Skok', value: 'bounce' },
  { label: 'Blagi skok', value: 'bounce_10' },
  { label: 'Pulsiranje', value: 'pulse' },
  { label: 'Lepršanje', value: 'float' },
  { label: 'Njihanje', value: 'wiggle' },
  { label: 'Drmanje 1', value: 'shake_1' },
  { label: 'Drmanje 2', value: 'shake_2' },
];

const _YM_MARKER_BULK_ZOOM_OPTIONS = [
  { label: 'Ne menjaj', value: 'keep' },
  { label: 'Isključi zoom', value: 'disable' },
  { label: 'Prati zoom mape', value: 'follow' },
  { label: 'Stepenasti zoom markera', value: 'step' },
];

const _YM_MARKER_BULK_ENABLED_OPTIONS = [
  { label: 'Ne menjaj', value: 'keep' },
  { label: 'Uključi marker', value: 'enable' },
  { label: 'Isključi marker', value: 'disable' },
];

const _parse_map_legend_order_json_safe = (raw) => {
  if (typeof raw !== 'string' || raw.trim() === '') {
    return {};
  }
  try {
    const parsed = JSON.parse(raw);
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      return parsed;
    }
  } catch (err) {
    console.warn('map_legend_order_json parse failed', err);
  }
  return {};
};

const _YMTHING_IMPORT_EXPORT_COLUMNS = [
  { key: 'of_id', title: 'of_id', editable: false, wch: 10 },
  { key: 'destination_id', title: 'destination_id', editable: false, wch: 14 },
  { key: 'destination_title', title: 'destination_title', editable: false, wch: 28 },
  { key: 'subdestination_id', title: 'subdestination_id', editable: false, wch: 16 },
  { key: 'subdestination_title', title: 'subdestination_title', editable: false, wch: 28 },
  { key: '_routing_tab', title: 'tab', editable: false, wch: 16 },
  { key: 'smestaj_naslov', title: 'smestaj_naslov', editable: true, wch: 28 },
  { key: 'smestaj_podnaslov', title: 'smestaj_podnaslov', editable: true, wch: 32 },
  { key: 'smestaj_opis', title: 'smestaj_opis', editable: true, wch: 50 },
  { key: 'smestaj_adresa', title: 'smestaj_adresa', editable: true, wch: 28 },
  { key: 'telefon', title: 'telefon', editable: true, wch: 18 },
  { key: 'telefon2', title: 'telefon2', editable: true, wch: 18 },
  { key: 'mobilni', title: 'mobilni', editable: true, wch: 18 },
  { key: 'mobilni2', title: 'mobilni2', editable: true, wch: 18 },
  { key: 'email', title: 'email', editable: true, wch: 28 },
   { key: 'email2', title: 'email2', editable: true, wch: 28 },
  { key: 'websajt', title: 'websajt', editable: true, wch: 28 },
  { key: 'kontakt_instagram_url', title: 'kontakt_instagram_url', editable: true, wch: 28 },
  { key: 'google_maps_iframe_src', title: 'google_maps_iframe_src', editable: true, wch: 40 },
  { key: 'geo_uri', title: 'geo_uri', editable: true, wch: 24 },
  { key: 'komentar', title: 'komentar', editable: true, wch: 24 },
];

const _YMTHING_FULL_BACKUP_COLUMNS = [
  { key: 'of_id', title: 'of_id', wch: 10 },
  { key: 'vr_tablename', title: 'vr_tablename', wch: 22 },
  { key: 'destination_id', title: 'destination_id', wch: 14 },
  { key: 'destination_title', title: 'destination_title', wch: 28 },
  { key: 'subdestination_id', title: 'subdestination_id', wch: 16 },
  { key: 'subdestination_title', title: 'subdestination_title', wch: 28 },
  { key: 'tab', title: 'tab', wch: 16 },
  { key: 'backup_data_json', title: 'backup_data_json', wch: 120 },
];

const _ymthing_import_export_editable_keys = _YMTHING_IMPORT_EXPORT_COLUMNS
  .filter((column) => column.editable === true)
  .map((column) => column.key);

const _ymthing_import_export_column_title_map = _YMTHING_IMPORT_EXPORT_COLUMNS.reduce((acc, column) => {
  acc[column.key] = column.title;
  return acc;
}, {});

const _ymthing_import_export_column_aliases = {
  smestaj_naslov: ['smestaj_naslov', 'naslov', 'title'],
  smestaj_podnaslov: ['smestaj_podnaslov', 'podnaslov', 'subtitle'],
  smestaj_opis: ['smestaj_opis', 'opis', 'description'],
  smestaj_adresa: ['smestaj_adresa', 'adresa', 'address'],
  email: ['email', 'e-mail', 'mail'],
  email2: ['email2', 'email_2', 'e-mail2', 'mail2'],
};

const _ymthing_import_export_normalize_column_name = (value) => {
  return _ymthing_import_export_normalize_text(value)
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '_');
};

const _ymthing_import_export_read_value_from_row = (row, key) => {
  if (!row || typeof row !== 'object') {
    return { found: false, value: '' };
  }

  if (Object.prototype.hasOwnProperty.call(row, key)) {
    return { found: true, value: row[key] };
  }

  const normalizedMap = {};
  Object.keys(row).forEach((rowKey) => {
    normalizedMap[_ymthing_import_export_normalize_column_name(rowKey)] = rowKey;
  });

  const normalizedCandidates = [
    key,
    _ymthing_import_export_column_title_map[key],
    ...(_ymthing_import_export_column_aliases[key] || []),
  ].map((candidate) => _ymthing_import_export_normalize_column_name(candidate));

  for (let i = 0; i < normalizedCandidates.length; i += 1) {
    const normalizedCandidate = normalizedCandidates[i];
    const matchedRowKey = normalizedMap[normalizedCandidate];
    if (typeof matchedRowKey === 'string') {
      return { found: true, value: row[matchedRowKey] };
    }
  }

  return { found: false, value: '' };
};

const _ymthing_import_export_normalize_text = (value) => {
  if (value === null || typeof value === 'undefined') {
    return '';
  }
  return String(value);
};

const _ymthing_import_export_phone_keys = ['telefon', 'telefon2', 'mobilni', 'mobilni2'];

const _ymthing_import_export_normalize_for_compare = (value, key) => {
  let normalized = _ymthing_import_export_normalize_text(value)
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n')
    .trim();

  if (key === 'email' || key === 'email2') {
    normalized = normalized.toLowerCase();
  }

  if (_ymthing_import_export_phone_keys.includes(key)) {
    const digits = normalized.replace(/[^\d]/g, '');
    if (digits.length >= 6) {
      return digits;
    }
  }

  return normalized;
};

const _ymthing_import_export_make_row_digest = (source) => {
  return _ymthing_import_export_editable_keys
    .map((key) => key + ':' + _ymthing_import_export_normalize_for_compare(source?.[key], key))
    .join('||');
};

const _ymthing_import_export_prepare_entbox_for_submit = (nextEntity, currentEntity) => {
  const vrTablename = nextEntity?.vr_tablename || currentEntity?.vr_tablename;
  const galleryArr = Array.isArray(nextEntity?.gallery_img_arr) ? nextEntity.gallery_img_arr : [];

  if (nextEntity?.destinacija_tip === 'DESTINATION' || nextEntity?.destinacija_tip === 'SUBDESTINATION') {
    const destinationPrepared = _zzyourmap_prepare_entbox_for_submit_destination(nextEntity);
    if (destinationPrepared !== false) {
      return destinationPrepared;
    }
  }

  if (vrTablename === 'ym_table_ostalo_v1' || vrTablename === 'ym_table_ostalo_v2') {
    return _zzyourmap_prepare_entbox_for_submit_ostalo_v1(nextEntity, {});
  }

  return _zzyourmap_prepare_entbox_for_submit_smestaj(nextEntity, galleryArr);
};

const _ymthing_import_export_make_full_backup_data_json = (entity) => {
  const prepared_entbox = _ymthing_import_export_prepare_entbox_for_submit(entity, entity);
  if (!prepared_entbox || typeof prepared_entbox !== 'object') {
    return json_utils.js_to_always_json({});
  }
  const data_for_json = { ...prepared_entbox };
  delete data_for_json.vr_tablename;
  return json_utils.js_to_always_json(data_for_json);
};

const _ymthing_import_export_make_sheet_name = (destinationTitle, destinationId) => {
  const raw = (destinationTitle || ('Destinacija ' + destinationId)).replace(/[/:?*]|\[|\]/g, ' ').trim();
  const compact = raw.replace(/\s+/g, ' ');
  const prefix = String(destinationId || '0');
  return (prefix + ' - ' + compact).slice(0, 31);
};


//
const YourmapAdminMapDemoV1 = (props) => {
  const {
    setUniModalPortableContent,
    setUniModalPortableClose,
  } = props.appPack;
  // console.log('geouri za canada bariff je: geo:51.2,-159.6?z=2');
  const [imgSrcBlob, setImgSrcBlob] = useState(null);
  //
  // let _img_url = '/static/img/photoshop-checkboard-pattern-20px-flipped.png';
  let _img_url = '/static/img/frfr-image-placeholder-xgradient-1024x1024px.png';
  // let _img_url = 'https://ymdemo2.applabz.work/uploads/2025-11-30_img_692d30f4d7f74.jpg'; // mapa bajina basta uploadovana
  const [markers, setMarkers] = useState([]);
  const [newMarkerState, setNewMarkerState] = useState({
    left: 0,
    bottom: 0,
    // marker_img_src: _img_url,
    marker_img_src: null,
    tooltip_text: 'Naslov u popupu',
    iconAnchor: [10, 10],
    img_class: "ym-script__marker__icon-img ym-script__marker__icon-bounce-2",
  });

  const cbPickSingleImage_admin = (imglib_item, imglib_item_key, img_url) => {
    console.log('* * * * * PICK', imglib_item, imglib_item_key, img_url);
    let img_filename = null;
    let img_folder = null;
    if (js_utils.is_string_not_empty(imglib_item?.img_filename)) {
      img_filename = imglib_item?.img_filename;
      if (js_utils.is_string_not_empty(imglib_item?.img_folder)) {
        img_folder = imglib_item?.img_folder;
      }
    }
    //
    const src = _zzyourmap_img_url_full_from_parts(img_filename, img_folder);
    //
    setImgSrcBlob(src);
    setNewMarkerState(newMarkerState => {
      return {
        ...newMarkerState,
        // bottom: Number.parseInt(bottom),
        // left: Number.parseInt(left),
        // size: 40,
        w: 40,
        h: 40,
        marker_img_src: src,
      };
    });
    setUniModalPortableClose();
  };

  const _cbClickLatLng = (bottom, left) => {
    console.log(bottom, left, typeof bottom, typeof left);
    setNewMarkerState(newMarkerState => {
      return {
        ...newMarkerState,
        bottom: Number.parseInt(bottom),
        left: Number.parseInt(left),
        // size: 40,
        w: 40,
        h: 40,
        marker_img_src: newMarkerState.marker_img_src,
      };
    });
  };


  const handleAddMarker = () => {
    /*
    setNewMarkerState(state => {
      return {
        ...state,
        markers_arr: [...state.markers_arr, {
          bottom: state.bottom,
          left: state.left,

        }],
      };
    });
    */
    setMarkers(markers => {
      return [...markers, {
        ...newMarkerState,
        // marker_img_src: imgSrcBlob,
      }];
    });
  };

  // demo mapa ym-demo-mapa.jpg 6050x3050px
  const demo_map_img_url = _zzyourmap_config.demo_map_img_url_full;

  let options = {
    enableClickLatLng: true, // enable pick lat lng coordinates
    _cbClickLatLng,
    markers_arr: markers,
    // demo-mapa
    map_img_url: demo_map_img_url,
    w: 6050,
    h: 4301,
  };

  return (
    <>
      <section className="yourmap__section yourmap__section--map222">
        <div className="inner">
          <div>
            <Komentar>
              <p>- Za koordinate na mapi koristimo 'left' i 'bottom'<br />to su brojevi koliko pixela od levog ruba slike odnosno od dna slike.</p>
              <p>primeri url do slike:</p>
              <p>/static/img/frfr-image-placeholder-xgradient-1024x1024px.png</p>
              <p>/static/img/banner-placeholder-250x250.png</p>
              <p>/static/img/photoshop-checkboard-pattern-20px.png</p>
            </Komentar>
            {/*
            state:
            <JSDisplayValue val={newMarkerState} />
            */}
            markers state:
            <JSDisplayValue val={markers} />
            new marker state:
            <div className="uu-text-nowrap">
              <JSUniValueEditor val={newMarkerState} cbSetVal={setNewMarkerState} />
            </div>
            <div className="uu-gap-standalone-1rem"></div>
            <div className="uu-vector uu-vector--col uu-gaps-m-1rem">
              <div>
                <UniBtn
                  inline
                  wide
                  circle
                  i="fa fa-picture-o"
                  title="Pick/Choose/Upload Image Icon"
                  handleClick={() => {
                    setUniModalPortableContent({
                      options: {
                        large: true,
                      },
                      jsx: (
                        <>
                          <YourmapImageLibraryV4
                            appPack={props.appPack}
                            cbPickSingleImage={cbPickSingleImage_admin}
                            enableSelectSingular={true}
                          />
                        </>
                      ),
                    });
                  }}
                />
              </div>
              <div>
                marker icon preview:
                <div className="uu-vector">
                  <UniImage src={newMarkerState.marker_img_src} extraClass="yourmap__theme__image-lib-figure" />
                </div>
              </div>
              <div>
                <UniBtn
                  disabled={newMarkerState.marker_img_src ? false : true}
                  inline
                  circle
                  wide
                  i="fa fa-plus"
                  title="Add marker on map"
                  handleClick={handleAddMarker}
                />
              </div>
            </div>
            <p>...open/close to refresh</p>
          </div>
        </div>

        <CardCollapsible fullWidth title="* DEMO Map Preview">
          <section className="yourmap__section yourmap__section--map">
            <div className="inner">
              <div className="yourmap__map">
                <YourmapMapPageWrapper
                  mapFetching={false}
                >
                  <YourmapLeafletContainerUniversal ll={[51.2, -159.6]} options={options} />
                </YourmapMapPageWrapper>

                {/*
                <MapContainer center={[51.505, -0.09]} zoom={13} scrollWheelZoom={false}>
                  <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  />
                  <Marker position={[51.505, -0.09]}>
                    <Popup>
                      A pretty CSS3 popup. <br /> Easily customizable.
                    </Popup>
                  </Marker>
                </MapContainer>
                */}
              </div>
            </div>
          </section>
        </CardCollapsible>
      </section>
    </>
  );
};


// ---------- Yourmap ADMIN PANEL


//
const FormPartDestinationMainImg = (props) => {
  const {
    formPart_pack,
  } = props;
  const {
    state,
    setState,
    handleChange,
    setUniModalPortableContent_2,
    setUniModalPortableClose_2,
    cbPickSingleImage,
    cbPickSingleImage_2,
    cbPickMultipleImages,
    subformGalleryArr,
    options,
  } = formPart_pack;
  //
  return (
    <>
      <div className="uu-gap-standalone-05rem"></div>
      <div>
        <FormGenerator
          formDefinition={_zzyourmap_formDefinition_destination_formPart_main_img()}
          formState={state}
          formErrors={{}}
          handleChange={handleChange}
        />
      </div>
      <div className="uu-gap-standalone-05rem"></div>
      <div>
        <span>Pick main image </span>
        <UniBtn
          inline
          wide
          circle
          size={24}
          i="fa fa-picture-o"
          title="Pick/Upload Image"
          handleClick={() => {
            setUniModalPortableContent_2({
              options: {
                large: true,
                zIndex: 9999,
              },
              jsx: (
                <>
                  <YourmapImageLibraryV4
                    appPack={props.appPack}
                    cbDialogCancel={setUniModalPortableClose_2}
                    cbPickSingleImage={cbPickSingleImage}
                    enableSelectSingular={true}
                  />
                </>
              ),
            });
          }}
        />
      </div>
    </>
  );
};


// ── Reusable accordion section for admin entity forms ─────────────
const AdminFormSection = ({ title, icon, children, initialOpened = true }) => {
  const [opened, setOpened] = useState(initialOpened);
  return (
    <div className={"ym-adm-form-section" + (opened ? " ym-adm-form-section--open" : "")}>
      <button
        className="ym-adm-form-section__toggle"
        type="button"
        onClick={() => setOpened(v => !v)}
        aria-expanded={opened}
      >
        {icon && <i className={`fa ${icon} ym-adm-form-section__icon`} aria-hidden="true" />}
        <span className="ym-adm-form-section__label">{title}</span>
        <span className="ym-adm-form-section__badge">{opened ? 'otvoreno' : 'zatvoreno'}</span>
        <i className="fa fa-chevron-down ym-adm-form-section__chevron" aria-hidden="true" />
      </button>
      {opened && (
        <div className="ym-adm-form-section__body">
          {children}
        </div>
      )}
    </div>
  );
};


//
const YourmapFormDestination = (props) => {
  // const cbDialogSubmit = props.cbDialogSubmit;
  // const cbDialogCancel = props.cbDialogCancel;
  const {
    cbDialogSubmit,
    cbDialogCancel,
  } = props;
  const {
    options_adm_parent_of_destination,
    setUniModalPortableContent,
    setUniModalPortableClose,
    setUniModalPortableContent_2,
    setUniModalPortableClose_2,
  } = props.appPack;
  //
  let initialState;
  let formDefinition;
  let editMode = false;
  if (props.mode === 'EDIT') {
    editMode = true;
    initialState = props.editorData;
    // formDefinition = [..._zzyourmap_formDefinition_formPart_editing, ..._zzyourmap_formDefinition_destination];
  } else {
    initialState = { ..._zzyourmap_preset_destination };
    // formDefinition = _zzyourmap_formDefinition_destination;
  }
  const [state, handleChange, setState] = useHandleInputChange(initialState);
  if (editMode) {
    formDefinition = [..._zzyourmap_formDefinition_formPart_editing, ..._zzyourmap_formDefinition_destination(state, options_adm_parent_of_destination)];
  } else {
    formDefinition = _zzyourmap_formDefinition_destination(state, options_adm_parent_of_destination);
  }
  let _show_pickers = false;
  let _show_main_img_pickers = false;
  let _show_map_pickers = false;
  if (state?.destinacija_tip === "DESTINATION") {
    _show_main_img_pickers = true;
  }
  if (state?.destinacija_tip === "DESTINATION" || state?.destinacija_tip === "SUBDESTINATION") {
    _show_map_pickers = true;
    _show_pickers = true;
  }

  //
  const cbPickSingleImage = (imglib_item, imglib_item_key, img_url) => {
    console.log('* * * * * PICK', imglib_item, imglib_item_key, img_url);
    let img_filename = null;
    let img_folder = null;
    if (js_utils.is_string_not_empty(imglib_item?.img_filename)) {
      img_filename = imglib_item?.img_filename;
      if (js_utils.is_string_not_empty(imglib_item?.img_folder)) {
        img_folder = imglib_item?.img_folder;
      }
    }
    setState(state => {
      return {
        ...state,
        destinacija_main_img_filename: img_filename,
        destinacija_main_img_folder: img_folder,
      };
    });
  };
  const cbPickSingleImage_2 = (imglib_item, imglib_item_key, img_url) => {
    console.log('* * * * * PICK 2', imglib_item, imglib_item_key, img_url);
    let img_filename = null;
    let img_folder = null;
    if (js_utils.is_string_not_empty(imglib_item?.img_filename)) {
      img_filename = imglib_item?.img_filename;
      if (js_utils.is_string_not_empty(imglib_item?.img_folder)) {
        img_folder = imglib_item?.img_folder;
      }
    }
    setState(state => {
      return {
        ...state,
        destinacija_map_img_filename: img_filename,
        destinacija_map_img_folder: img_folder,
      };
    });
  };
  //
  const formPart_pack = {
    state,
    setState,
    handleChange,
    setUniModalPortableContent_2,
    setUniModalPortableClose_2,
    cbPickSingleImage,
    cbPickSingleImage_2,
    // cbPickMultipleImages,
    // subformGalleryArr,
    // options,
  };
  //
  return (
    <div className="ym-adm-form-modal yourmap-theme__scope-admin-panel">
      {/* Sticky header */}
      <div className="ym-adm-form-modal__header">
        <h3 className="ym-adm-form-modal__title">
          {editMode ? 'Izmeni destinaciju' : 'Dodaj novu destinaciju'}
        </h3>
        <button
          className="ym-adm-form-modal__close"
          type="button"
          onClick={() => { cbDialogCancel(); }}
          aria-label="Zatvori"
        >
          <i className="fa fa-times" aria-hidden="true" />
        </button>
      </div>

      {/* Scrollable body */}
      <div className="ym-adm-form-modal__body">
        <AdminFormSection title="Osnovno" icon="fa-map-o" initialOpened={true}>
          <Komentar extraClass="uu-max-w-360px yourmap__dev-komentar-in-form">
            Ukoliko je u pitanju poddestinacija, polja '<b>destinacija_naslov</b>' i '<b>destinacija_slug</b>' ostavite prazno. U svim ostalim slučajevima, sva teksulana polja bi trebalo popuniti.
          </Komentar>
          <FormGenerator
            formDefinition={formDefinition}
            formState={state}
            formErrors={{}}
            handleChange={handleChange}
          />
        </AdminFormSection>

        {_show_map_pickers === true && (
          <AdminFormSection title="Slika mape" icon="fa-picture-o" initialOpened={true}>
            <div className="uu-gap-standalone-05rem"></div>
            <div>
              <span>Pick map image </span>
              <UniBtn
                inline
                wide
                circle
                size={24}
                i="fa fa-picture-o"
                title="Pick/Upload Image"
                handleClick={() => {
                  setUniModalPortableContent_2({
                    options: {
                      large: true,
                      zIndex: 9999,
                    },
                    jsx: (
                      <>
                        <YourmapImageLibraryV4
                          appPack={props.appPack}
                          cbDialogCancel={setUniModalPortableClose_2}
                          cbPickSingleImage={cbPickSingleImage_2}
                          enableSelectSingular={true}
                        />
                      </>
                    ),
                  });
                }}
              />
            </div>
          </AdminFormSection>
        )}

        {_show_main_img_pickers === true && (
          <AdminFormSection title="Glavna slika" icon="fa-picture-o" initialOpened={false}>
            <FormPartDestinationMainImg appPack={props.appPack} formPart_pack={formPart_pack} />
          </AdminFormSection>
        )}
      </div>

      {/* Sticky footer */}
      <div className="ym-adm-form-modal__footer">
        <UniBtn
          disabled={false}
          inline
          wide
          outline
          circle_EX
          i="fa fa-times"
          title="Otkaži"
          handleClick={() => { cbDialogCancel(); }}
        />
        <UniBtn
          disabled={_show_pickers !== true}
          inline
          wide
          circle_EX
          i="fa fa-paper-plane"
          title="Sačuvaj"
          handleClick={() => {
            // cbDialogSubmit(state);
            const prepared_entbox = _zzyourmap_prepare_entbox_for_submit_destination(state);
            if (editMode) { // EDIT
              const payload = { of_id: state.of_id };
              cbDialogSubmit(prepared_entbox, payload);
            } else { // ADD
              cbDialogSubmit(prepared_entbox);
            }
            // cbDialogCancel();
          }}
        />
      </div>
    </div>
  );
};


//
const FormPartKontakt = (props) => {
  const {
    formPart_pack,
  } = props;
  const {
    state,
    setState,
    handleChange,
    setUniModalPortableContent_2,
    setUniModalPortableClose_2,
    cbPickSingleImage,
    cbPickSingleImage_2,
    cbPickMultipleImages,
    subformGalleryArr,
    options,
  } = formPart_pack;
  //
  return (
    <>
      <div className="uu-gap-standalone-05rem"></div>
      <div>
        <FormGenerator
          formDefinition={_zzyourmap_formDefinition_smestaj_formPart_kontakt()}
          formState={state}
          formErrors={{}}
          handleChange={handleChange}
        />
      </div>
      <div className="uu-gap-standalone-05rem"></div>
      <div>
        <span><a target="_blank" rel="noopener noreferrer" href="https://www.openstreetmap.org/?#map=17/43.285457/20.809350">* Find Geo URI here</a></span>
      </div>
    </>
  );
};


//
const FormPartChecks = (props) => {
  const {
    formPart_pack,
  } = props;
  const {
    state,
    setState,
    handleChange,
    setUniModalPortableContent_2,
    setUniModalPortableClose_2,
    cbPickSingleImage,
    cbPickSingleImage_2,
    cbPickMultipleImages,
    subformGalleryArr,
    options,
  } = formPart_pack;
  //
  return (
    <>
      <div className="uu-gap-standalone-05rem"></div>
      <div className="ym-adm-checks-grid">
        <FormGenerator
          formDefinition={_zzyourmap_formDefinition_smestaj_formPart_checks()}
          formState={state}
          formErrors={{}}
          handleChange={handleChange}
        />
      </div>
    </>
  );
};


//
const FormPartMainImg = (props) => {
  const {
    formPart_pack,
  } = props;
  const {
    state,
    setState,
    handleChange,
    setUniModalPortableContent_2,
    setUniModalPortableClose_2,
    cbPickSingleImage,
    cbPickSingleImage_2,
    cbPickMultipleImages,
    subformGalleryArr,
    options,
  } = formPart_pack;
  //
  return (
    <>
      <div className="uu-gap-standalone-05rem"></div>
      <div>
        <FormGenerator
          formDefinition={_zzyourmap_formDefinition_smestaj_formPart_main_img()}
          formState={state}
          formErrors={{}}
          handleChange={handleChange}
        />
      </div>
      <div className="uu-gap-standalone-05rem"></div>
      <div><span>Pick main image </span>
        <UniBtn
          inline
          wide
          circle
          size={24}
          i="fa fa-picture-o"
          title="Pick/Upload Image"
          handleClick={() => {
            setUniModalPortableContent_2({
              options: {
                large: true,
                zIndex: 9999,
              },
              jsx: (
                <>
                  <YourmapImageLibraryV4
                    appPack={props.appPack}
                    cbDialogCancel={setUniModalPortableClose_2}
                    cbPickSingleImage={cbPickSingleImage}
                    enableSelectSingular={true}
                  />
                </>
              ),
            });
          }}
        />
      </div>
    </>
  );
};


//
const FormPartGallery = (props) => {
  const {
    formPart_pack,
  } = props;
  const {
    state,
    setState,
    handleChange,
    setUniModalPortableContent_2,
    setUniModalPortableClose_2,
    cbPickSingleImage,
    cbPickSingleImage_2,
    cbPickMultipleImages,
    subformGalleryArr,
    setSubformGalleryArr,
    options,
  } = formPart_pack;
  //
  const adm_slide_img_src_arr = [];
  if (Easy69_v1.is_array(subformGalleryArr)) {
    subformGalleryArr.forEach(gallery_img => {
      adm_slide_img_src_arr.push({
        src: _zzyourmap_img_url_full_from_parts(gallery_img, 'uploads'),
        img_filename: gallery_img,
      });
    });
  }
  //
  return (
    <>
      <div className="uu-gap-standalone-05rem"></div>
      <div>
        <FormGenerator
          formDefinition={_zzyourmap_formDefinition_smestaj_formPart_gallery()}
          formState={state}
          formErrors={{}}
          handleChange={handleChange}
        />
      </div>
      <div className="uu-gap-standalone-05rem"></div>
      <div className="uu-text-nowrap uu-pl-16px">
        <div className="yourmap__image-library__admin-gallery">
          {
            adm_slide_img_src_arr.map((gallery_item, index) => {
              // <div>{gallery_item}</div>
              const src = gallery_item.src;
              const img_filename = gallery_item.img_filename;
              return (
                <div className={"yourmap__image-library__admin-gallery__item yourmap__image-library__item"}>
                  <div className="yourmap__image-library__tail">
                    <div className="yourmap__image-library__actions">
                      <div className="uu-vector uu-vector-row uu-gaps-p-05rem uu-vector--items-center">
                        <div>
                          <UniBtnPack pill>
                            <UniBtn
                              wide_NOT
                              circle
                              size={16}
                              i="fa fa-caret-left"
                              title_NOT="EDIT"
                              tooltip="Move left"
                              themeCompoColorBlue
                              handleClick={() => {
                                setSubformGalleryArr(old_arr => {
                                  return js_utils.array_item_move_pure(old_arr, index, -1);
                                });
                              }}
                            />
                            <UniBtn
                              wide_NOT
                              circle
                              size={16}
                              i="fa fa-caret-right"
                              title_NOT="EDIT"
                              tooltip="Move right"
                              themeCompoColorBlue
                              handleClick={() => {
                                setSubformGalleryArr(old_arr => {
                                  return js_utils.array_item_move_pure(old_arr, index, 1);
                                });
                              }}
                            />
                          </UniBtnPack>
                        </div>
                        {
                          true && (
                            <div>
                              <UniBtn
                                circle
                                size={16}
                                i="fa fa-trash"
                                themeCompoColorRed
                                extraClass="yourmap__theme__custom-btn-orange222"
                                handleClick={() => {
                                  setSubformGalleryArr(old_arr => {
                                    return old_arr.filter((item, i) => {
                                      if (i === index) {
                                        return false;
                                      }
                                      return true;
                                    });
                                  });
                                }}
                              />
                            </div>
                          )
                        }
                      </div>
                    </div>
                  </div>
                  <UniImage src={src} extraClass="yourmap__theme__image-lib-figure" />
                  <div className="yourmap__image-library__admin-gallery__item__filename"><a target="_blank" rel="noopener noreferrer" href={src} >{img_filename}</a></div>
                </div>
              );
            })
          }
        </div>
      </div>
      <div className="uu-gap-standalone-05rem"></div>
      <div>
        <span>Pick gallery images </span>
        <UniBtn
          inline
          wide
          circle
          size={24}
          i="fa fa-picture-o"
          title="Pick/Upload gallery Images"
          handleClick={() => {
            setUniModalPortableContent_2({
              options: {
                large: true,
                zIndex: 9999,
              },
              jsx: (
                <>
                  <YourmapImageLibraryV4
                    appPack={props.appPack}
                    cbDialogCancel={setUniModalPortableClose_2}
                    cbPickMultipleImages={cbPickMultipleImages}
                    enableSelectMultiple={true}
                  />
                </>
              ),
            });
          }}
        />
      </div>
    </>
  );
};


//
const WidegtImageWithSizePicker = (props) => {
  const {
    src,
    setState,
    state,
  } = props;
  //
  //
  const [sizePickerOpened, setSizePickerOpened] = useState(true);
  //
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const [loading, setLoading] = useState(true);
  const imgRef = useRef(null);
  let original_aspect_ratio = 0;
  if (dimensions.width > 0 && dimensions.height > 0) {
    original_aspect_ratio = dimensions.width / dimensions.height;
  }

  // Funkcija koja se poziva kada se slika učita
  const handleLoad = (event) => {
    const { naturalWidth, naturalHeight } = event.currentTarget;
    setDimensions({ width: naturalWidth, height: naturalHeight });
    setLoading(false);
  };

  useEffect(() => {
    // Provera da li je slika već učitana iz keša pre nego što se JS pokrenuo
    if (imgRef.current && imgRef.current.complete) {
      setDimensions({
        width: imgRef.current.naturalWidth,
        height: imgRef.current.naturalHeight
      });
      setLoading(false);
    }
  }, [src]);

  // -----
  const {
    smestaj_marker_img_w,
    smestaj_marker_img_h,
    smestaj_marker_img_anchor_left,
    smestaj_marker_img_anchor_top,
  } = state;
  let aspect_ratio = 0;
  if (smestaj_marker_img_w > 0 && smestaj_marker_img_h > 0) {
    aspect_ratio = smestaj_marker_img_w / smestaj_marker_img_h;
  }
  let preview_img_w = 0;
  let preview_img_h = 0;
  if (smestaj_marker_img_w > 0) {
    preview_img_w = smestaj_marker_img_w;
  }
  if (smestaj_marker_img_h > 0) {
    preview_img_h = smestaj_marker_img_h;
  }
  //
  const handleClickPickAnchorPosition = (e) => {
    // Iako postoji i e.nativeEvent.offsetX, on može biti nepouzdan ako kliknete na dete (child) unutar glavnog elementa, jer će tada vratiti poziciju relativno u odnosu na to dete, a ne na roditelja.
    // 1. Dobijanje pozicije i veličine elementa u odnosu na vidljivi prozor (viewport)
    const rect = e.currentTarget.getBoundingClientRect();
    // 2. Oduzimanje pozicije elementa od apsolutne pozicije kursora (clientX/Y)
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    // console.log(`Relativna pozicija -> Levo: ${x}px, Gore: ${y}px`);
    if (x > 0 && y > 0) {
      setState(state => {
        return {
          ...state,
          // smestaj_marker_img_anchor_left: Math.round(x),
          // smestaj_marker_img_anchor_top: Math.round(y),
          smestaj_marker_img_anchor_left: Math.floor(x),
          smestaj_marker_img_anchor_top: Math.floor(y),
        }
      });
    }
  };

  if (sizePickerOpened === false) {
    return (
      <>
        <div>
          <div>
            <span>Marker dimensions </span>
            <UniBtn
              disabled={false}
              inline
              wide
              circle
              size={24}
              i="fa fa-magic"
              title_EX={"Pick marker dimensions"}
              title={"Marker dimensions helper"}
              handleClick={() => { setSizePickerOpened(true); }}
            />
          </div>
        </div>
      </>
    );
  } else {
    return (
      <>
        <div>
          {/*<span>Pick marker dimensions </span>*/}
          <span>Marker dimensions helper: </span>
          {/*<UniBtn
            disabled={false}
            inline
            wide
            circle
            size={24}
            i="fa fa-magic"
            title={"Pick w:" + dimensions.width + " h:" + dimensions.height}
            handleClick={() => {
              setState(state => {
                if (js_utils.is_number(dimensions.width) && js_utils.is_number(dimensions.height)) {
                  return {
                    ...state,
                    smestaj_marker_img_w: dimensions.width,
                    smestaj_marker_img_h: dimensions.height,
                  };
                } else {
                  return state; // return unchanged
                }
              });
              setSizePickerOpened(false);
            }}
          /> */}
          <UniBtn
            disabled={false}
            inline
            wide
            outline
            circle
            size={24}
            i="fa fa-times"
            title_EX="Cancel"
            title="Zatvori"
            titleOnly
            handleClick={() => { setSizePickerOpened(false); }}
          />
        </div>
        <div className="uu-gap-standalone-4px"></div>
        <div className="yourmap__image-library__pick-dimensions">
          {/*preview:*/}
          {/*<UniImage src={preview_src} extraClass="yourmap__theme__image-lib-preview" />*/}
          <div>
            {loading ? <p>loading...</p> : (
              <div className="uu-text-left">
                <div><span className="yourmap__image-library__small">Detected <b>original resolution</b>:</span> <span className="uu-font-number">{dimensions.width} x {dimensions.height} px</span> <UniBtn
                  disabled={false}
                  inline
                  wide
                  circle
                  size={24}
                  i="fa fa-magic"
                  titleOnly
                  title={"Pick"}
                  handleClick={() => {
                    setState(state => {
                      if (js_utils.is_number(dimensions.width) && js_utils.is_number(dimensions.height)) {
                        return {
                          ...state,
                          smestaj_marker_img_w: dimensions.width,
                          smestaj_marker_img_h: dimensions.height,
                        };
                      } else {
                        return state; // return unchanged
                      }
                    });
                    // setSizePickerOpened(false);
                  }}
                /> </div>
                <div><span className="yourmap__image-library__small"><b>Original aspect ratio</b>:</span> <span className="uu-font-number">{original_aspect_ratio.toFixed(3)}</span></div>
                <div><span className="yourmap__image-library__small"><b>New dimensions</b>:</span> <span className="uu-font-number">{/*{'0'} x {'0'} px*/} </span> <UniBtn
                  inline
                  circle
                  size={24}
                  i="fa fa-compress"
                  handleClick={() => {
                    setState(state => {
                      const {
                        smestaj_marker_img_w,
                        smestaj_marker_img_h,
                      } = state;
                      if (smestaj_marker_img_w > 0 && smestaj_marker_img_h > 0 && aspect_ratio > 0) {
                        const resized_h_raw = smestaj_marker_img_h * 0.97;
                        const resized_h = Math.round(resized_h_raw);
                        const resized_w = Math.round(resized_h_raw * aspect_ratio);
                        return {
                          ...state,
                          smestaj_marker_img_w: resized_w,
                          smestaj_marker_img_h: resized_h,
                        };
                      } else {
                        return state; // return unchanged
                      }
                    });
                  }}
                />&nbsp;<UniBtn
                    inline
                    circle
                    size={24}
                    i="fa fa-expand"
                    handleClick={() => {
                      setState(state => {
                        const {
                          smestaj_marker_img_w,
                          smestaj_marker_img_h,
                        } = state;
                        if (smestaj_marker_img_w > 0 && smestaj_marker_img_h > 0 && aspect_ratio > 0) {
                          const aspect_ratio = smestaj_marker_img_w / smestaj_marker_img_h;
                          const resized_h_raw = smestaj_marker_img_h * 1.03;
                          const resized_h = Math.round(resized_h_raw);
                          const resized_w = Math.round(resized_h_raw * aspect_ratio);
                          return {
                            ...state,
                            smestaj_marker_img_w: resized_w,
                            smestaj_marker_img_h: resized_h,
                          };
                        } else {
                          return state; // return unchanged
                        }
                      });
                    }}
                  /> <span className="yourmap__image-library__small"><b>New aspect ratio</b>:</span> <span className="uu-font-number">{aspect_ratio.toFixed(3)}</span></div>
                {/*<div><span className="yourmap__image-library__small"><b>New anchor</b>:</span> <span className="uu-font-number">left:{'0'} top:{'0'}</span></div>*/}
                <div><span className="yourmap__image-library__small">Preview <b>new</b>:</span></div>
              </div>
            )}
          </div>
          <div className="uu-gap-standalone-05rem"></div>
          <div
            className="yourmap__image-library__pick-dimensions__img-container"
            style={{
              width: preview_img_w,
              height: preview_img_h
            }}
            onClick={handleClickPickAnchorPosition}
          >
            <img
              ref={imgRef}
              src={src}
              onLoad={handleLoad}
              alt="Preview"
              style={{ maxWidth: '100%', height: 'auto' }}
            />
            <div className="yourmap__image-library__pick-dimensions__img-container_crosshair-left" style={{ left: smestaj_marker_img_anchor_left }}></div>
            <div className="yourmap__image-library__pick-dimensions__img-container_crosshair-top" style={{ top: smestaj_marker_img_anchor_top }}></div>
          </div>
        </div>
      </>
    );
  }
};


//
const PickMarkerPositionOnMap = (props) => {
  const {
    options,
  } = props;
  //
  const [hideAllMarkers, setHideAllMarkers] = useState(false);
  const [scaleMarkersTo1, setScaleMarkersTo1] = useState(false);
  let cl_map_extraClass = '';
  if (hideAllMarkers === true) {
    cl_map_extraClass += ' yourmap__map-special-filtering__hide-all-markers';
  }
  if (scaleMarkersTo1 === true) {
    cl_map_extraClass += ' yourmap__map-special-scale__scale-1-all-markers';
  }
  //
  return (
    <>
      <div className="unicompo-various-content">
        <h4 className="uu-mt-0">Pick position</h4>
        <div className="uu-vector uu-vector--row">
          <p>Click on any point and coordinates will be copied to form automatically</p>
          <div className="uu-gap-standalone-1rem"></div>
          <FormFieldGenerator
            fieldDefinition={{
              "type": "input_checkbox",
              "params": {
                "label": "Sakrij sve markere",
                "name": "hideAllMarkers"
              }
            }}
            value={hideAllMarkers}
            handleChange={(e) => {
              setHideAllMarkers(state => !state); // toggle
            }}
            fieldError={null}
          />
          <div className="uu-gap-standalone-1rem"></div>
          <FormFieldGenerator
            fieldDefinition={{
              "type": "input_checkbox",
              "params": {
                "label": "Markers scale 1:1",
                "name": "scaleMarkersTo1"
              }
            }}
            value={scaleMarkersTo1}
            handleChange={(e) => {
              setScaleMarkersTo1(state => !state); // toggle
            }}
            fieldError={null}
          />
        </div>
        <div className="yourmap__map-pos-picker">
          <div className={"yourmap__map" + cl_map_extraClass}>
            <YourmapMapPageWrapper
              mapFetching={false}
            >
              <YourmapLeafletContainerUniversal ll={[51.2, -159.6]} options={options} />
            </YourmapMapPageWrapper>
          </div>
        </div>
      </div>
    </>
  );
};
//
const FormPartMarker = (props) => {
  const {
    formPart_pack,
  } = props;
  const {
    state,
    setState,
    handleChange,
    setUniModalPortableContent_2,
    setUniModalPortableClose_2,
    cbPickSingleImage_2,
    // subformGalleryArr,
    // setSubformGalleryArr,
    options,
  } = formPart_pack;
  //
  const {
    smestaj_marker_img_w,
    smestaj_marker_img_h,
  } = state;
  let aspect_ratio = 0;
  if (smestaj_marker_img_w > 0 && smestaj_marker_img_h > 0) {
    aspect_ratio = smestaj_marker_img_w / smestaj_marker_img_h;
  }
  //
  let src = '';
  const img_url_full = _zzyourmap_img_url_full_from_parts(state?.smestaj_marker_img_filename, state?.smestaj_marker_img_folder);
  if (typeof img_url_full === 'string') {
    src = img_url_full;
  }
  //
  return (
    <>
      <div className="uu-gap-standalone-05rem"></div>
      <div>
        <FormGenerator
          formDefinition={_zzyourmap_formDefinition_smestaj_formPart_marker()}
          formState={state}
          formErrors={{}}
          handleChange={handleChange}
        />
        <div className="uu-gap-standalone-05rem"></div>
        <div>
          <span>Pick marker image </span>
          <UniBtn
            inline
            wide
            circle
            size={24}
            i="fa fa-picture-o"
            title="Pick/Upload Image"
            handleClick={() => {
              setUniModalPortableContent_2({
                options: {
                  large: true,
                  zIndex: 9999,
                },
                jsx: (
                  <>
                    <YourmapImageLibraryV4
                      appPack={props.appPack}
                      cbDialogCancel={setUniModalPortableClose_2}
                      cbPickSingleImage={cbPickSingleImage_2}
                      enableSelectSingular={true}
                    />
                  </>
                ),
              });
            }}
          />
        </div>
        <div className="uu-gap-standalone-05rem"></div>
        <WidegtImageWithSizePicker src={src} setState={setState} state={state} />
        <div className="uu-gap-standalone-05rem"></div>
        <div>
          <span>Pick marker position </span>
          <UniBtn
            disabled={false}
            inline
            wide
            circle
            size={24}
            i="fa fa-map-marker"
            title="Pick marker position"
            handleClick={() => {
              // ++++
              setUniModalPortableContent_2({
                options: {
                  large: true,
                  zIndex: 9999,
                },
                jsx: (
                  <PickMarkerPositionOnMap options={options} />
                ),
              });
            }}
          />
        </div>
        <div className="uu-gap-standalone-05rem"></div>
        {/*
        <div><span>* Uvećaj/Smanji marker ali pamti marker aspect ratio pa koriguj: {aspect_ratio.toFixed(3)} </span>
          <UniBtn
            inline
            circle
            size={24}
            i="fa fa-compress"
            handleClick={() => {
              setState(state => {
                const {
                  smestaj_marker_img_w,
                  smestaj_marker_img_h,
                } = state;
                if (smestaj_marker_img_w > 0 && smestaj_marker_img_h > 0 && aspect_ratio > 0) {
                  const resized_h_raw = smestaj_marker_img_h * 0.97;
                  const resized_h = Math.round(resized_h_raw);
                  const resized_w = Math.round(resized_h_raw * aspect_ratio);
                  return {
                    ...state,
                    smestaj_marker_img_w: resized_w,
                    smestaj_marker_img_h: resized_h,
                  };
                } else {
                  return state; // return unchanged
                }
              });
            }}
          />&nbsp;<UniBtn
            inline
            circle
            size={24}
            i="fa fa-expand"
            handleClick={() => {
              setState(state => {
                const {
                  smestaj_marker_img_w,
                  smestaj_marker_img_h,
                } = state;
                if (smestaj_marker_img_w > 0 && smestaj_marker_img_h > 0 && aspect_ratio > 0) {
                  const aspect_ratio = smestaj_marker_img_w / smestaj_marker_img_h;
                  const resized_h_raw = smestaj_marker_img_h * 1.03;
                  const resized_h = Math.round(resized_h_raw);
                  const resized_w = Math.round(resized_h_raw * aspect_ratio);
                  return {
                    ...state,
                    smestaj_marker_img_w: resized_w,
                    smestaj_marker_img_h: resized_h,
                  };
                } else {
                  return state; // return unchanged
                }
              });
            }}
          />
        </div>
        */}
      </div>
    </>
  );
};


// BLOG (ostalo_v1)
const YourmapFormYmostaloV1 = (props) => {
  // const cbDialogSubmit = props.cbDialogSubmit;
  // const cbDialogCancel = props.cbDialogCancel;
  const {
    cbDialogSubmit,
    cbDialogCancel,
  } = props;
  const {
    destination_entities_adm,
    options_adm_parent_of_destination,
    options_adm_parent_of_smestaj,
    layer_titles_all,
    setUniModalPortableContent,
    setUniModalPortableClose,
    setUniModalPortableContent_2,
    setUniModalPortableClose_2,
  } = props.appPack;
  let _show_blog_post_editor = false;
  //
  let initialState;
  let formDefinition;
  let editMode = false;
  if (props.mode === 'EDIT') {
    editMode = true;
    initialState = props.editorData;
  } else {
    initialState = { ..._zzyourmap_preset_ostalo_v1() };
  }
  const [state, handleChange, setState] = useHandleInputChange(initialState);
  if (editMode) {
    formDefinition = [..._zzyourmap_formDefinition_formPart_editing, ..._zzyourmap_formDefinition_ostalo_v1(state, options_adm_parent_of_smestaj, layer_titles_all)];
  } else {
    formDefinition = _zzyourmap_formDefinition_ostalo_v1(state, options_adm_parent_of_smestaj, layer_titles_all);
  }

  // const [subformGalleryArr, setSubformGalleryArr] = useState(js_utils.fix_always_arr(initialState?.gallery_img_arr));
  //
  const cbPickSingleImage = (imglib_item, imglib_item_key, img_url) => {
    console.log('* * * * * PICK', imglib_item, imglib_item_key, img_url);
    let img_filename = null;
    let img_folder = null;
    if (js_utils.is_string_not_empty(imglib_item?.img_filename)) {
      img_filename = imglib_item?.img_filename;
      if (js_utils.is_string_not_empty(imglib_item?.img_folder)) {
        img_folder = imglib_item?.img_folder;
      }
    }
    setState(state => {
      return {
        ...state,
        smestaj_main_img_filename: img_filename,
        smestaj_main_img_folder: img_folder,
      };
    });
  };
  const cbPickSingleImage_2 = (imglib_item, imglib_item_key, img_url) => {
    console.log('* * * * * PICK 2', imglib_item, imglib_item_key, img_url);
    let img_filename = null;
    let img_folder = null;
    if (js_utils.is_string_not_empty(imglib_item?.img_filename)) {
      img_filename = imglib_item?.img_filename;
      if (js_utils.is_string_not_empty(imglib_item?.img_folder)) {
        img_folder = imglib_item?.img_folder;
      }
    }
    setState(state => {
      return {
        ...state,
        smestaj_marker_img_filename: img_filename,
        smestaj_marker_img_folder: img_folder,
      };
    });
  };
  /*
  const cbPickMultipleImages = (bingo_items_arr, imglib_item_key, img_url) => {
          console.log('* * * * * PICK 3', bingo_items_arr);
        let updatedSubformArr = [];
    bingo_items_arr.forEach((imglib_item) => {
          let img_filename = null;
        let img_folder = null;
        if (js_utils.is_string_not_empty(imglib_item?.img_filename)) {
          img_filename = imglib_item?.img_filename;
        if (js_utils.is_string_not_empty(imglib_item?.img_folder)) {
          img_folder = imglib_item?.img_folder;
        }
      }
        //
        if (img_filename) {
          updatedSubformArr.push(img_filename);
      }
    });
        console.log('updatedSubformArr', updatedSubformArr);
    setSubformGalleryArr(sub_arr => {
      return updatedSubformArr;
    });
  };
        */
  //
  const _cbClickLatLng = (bottom, left) => {
    console.log('_cbClickLatLng', bottom, left, typeof bottom, typeof left);
    setState(state => {
      return {
        ...state,
        smestaj_marker_img_bottom: Number.parseInt(bottom),
        smestaj_marker_img_left: Number.parseInt(left),
      };
    });
  };
  let options = {
    ..._zzyourmap_extract_map_props_1_for_smestaj_position_picker(state, destination_entities_adm),
    enableClickLatLng: true, // enable pick lat lng coordinates
    _cbClickLatLng,
    // markers_arr: [],
  };
  //
  const formPart_pack = {
    state,
    setState,
    handleChange,
    setUniModalPortableContent_2,
    setUniModalPortableClose_2,
    cbPickSingleImage_2,
    options,
  };
  //
  if (state.smestaj_tab === "NONE") {
    _show_blog_post_editor = false;
  } else {
  }
  if (Easy69_v1.is_value_in_array(state.smestaj_tab, ["SERVISI", "OSTALO"])) {
    _show_blog_post_editor = true;
  } else {
    _show_blog_post_editor = false;
  }
  //
  const _special_blog_post_data = state._special_blog_post_data; // TODO
  let editorjs_renderable_data = _zzyourmap_extract_editorjs_renderable_data(_special_blog_post_data);
  //
  return (
    <div className="ym-adm-form-modal yourmap-theme__scope-admin-panel">
      {/* Sticky header */}
      <div className="ym-adm-form-modal__header">
        <h3 className="ym-adm-form-modal__title">
          {editMode ? 'Izmeni * OSTALO v1' : 'Dodaj novi * OSTALO v1'}
        </h3>
        <button
          className="ym-adm-form-modal__close"
          type="button"
          onClick={() => { cbDialogCancel(); }}
          aria-label="Zatvori"
        >
          <i className="fa fa-times" aria-hidden="true" />
        </button>
      </div>

      {/* Scrollable body */}
      <div className="ym-adm-form-modal__body">
        <AdminFormSection title="Osnovno" icon="fa-map-marker" initialOpened={true}>
          <UniLimiter w={300}>
            <Komentar>
              <p>- Treba razmisliti koji treba da budu nazivi "tabova", "layera" (legende)</p>
              <p>- Treba razmisliti da li da ove stvari mogu da pripadaju samo destinaciji bez specificiranja poddestinacije?</p>
            </Komentar>
          </UniLimiter>
          <HelpWidget>
            <p>- Polje "smestaj_podnalov" je u stvari kratak opis (rečenica) koji se prikazuje na karticama od smeštaja, restorana i ostalog...</p>
            <p>- Polje "smestaj_opis" je malo duži opis (2-3 rečenice) koji se prikazuju u popup-u kada se klikne na marker. Kada je u pitanju blog post, to bi trebalo da se unese "teaser" tekst tj. prve 2-3 rečenice od blog posta.</p>
            <p>- U slučaju kada je "smestaj_opis" izabrano "NONE" onda nema blog posta (ima samo marker), moguće je popuniti samo osnovna polja.</p>
            <p>- U blog editoru, slika se dodaje tako što, negde nadjete kompletan url do slike koja je već na internetu (najbolje u Image Library), zatim uradite <b>Copy</b> pa zatim u blog editoru u novi red uradite <b>Paste</b>. Ako je slika u podržanom formatu blog editor će je sam prepoznati i tretirati kao sliku.</p>
          </HelpWidget>
          <FormGenerator
            formDefinition={formDefinition}
            formState={state}
            formErrors={{}}
            handleChange={handleChange}
          />
        </AdminFormSection>

        <AdminFormSection title="Glavna slika" icon="fa-picture-o" initialOpened={false}>
          <div className="uu-gap-standalone-05rem"></div>
          <div>
            <span>Pick main image </span>
            <UniBtn
              inline
              wide
              circle
              size={24}
              i="fa fa-picture-o"
              title="Pick/Upload Image"
              handleClick={() => {
                setUniModalPortableContent_2({
                  options: {
                    large: true,
                    zIndex: 9999,
                  },
                  jsx: (
                    <>
                      <YourmapImageLibraryV4
                        appPack={props.appPack}
                        cbDialogCancel={setUniModalPortableClose_2}
                        cbPickSingleImage={cbPickSingleImage}
                        enableSelectSingular={true}
                      />
                    </>
                  ),
                });
              }}
            />
          </div>
        </AdminFormSection>

        {state.smestaj_marker_enabled === true && (
          <AdminFormSection title="Marker na mapi" icon="fa-map-marker" initialOpened={false}>
            {/* formPart MARKER */}
            <FormPartMarker appPack={props.appPack} formPart_pack={formPart_pack} />
          </AdminFormSection>
        )}

        {_show_blog_post_editor === true && (
          <AdminFormSection title="Blog post" icon="fa-pencil" initialOpened={false}>
            <CardCollapsible small jsxHeader={<h4>Blog post EDITOR</h4>}>
              {/*<UniSpinnerClassic />*/}
              <YourmapEditorjsV2
                editorjsState={editorjs_renderable_data}
                setEditorjsState={(updatedEditorjsRenderableData) => {
                  setState(state => {
                    return {
                      ...state,
                      /*
                      _special_blog_post_data: {
                        is_editorjs: true,
                        editorjs_data: updatedEditorjsRenderableData,
                      },
                      */
                      _special_blog_post_data: _zzyourmap_update_special_blog_post_data(state._special_blog_post_data, updatedEditorjsRenderableData),
                    };
                  })
                }}
              />
            </CardCollapsible>
            <CardCollapsible small jsxHeader={'Blog post * DEBUG'}>
              <JSDisplayValue val={editorjs_renderable_data} />
            </CardCollapsible>
            <CardCollapsible small jsxHeader={<h4>Blog post PREVIEW</h4>}>
              <>
                <FrfrAlienEditorjsRendererV1 editorjs_renderable_data={editorjs_renderable_data} />
              </>
            </CardCollapsible>
          </AdminFormSection>
        )}
      </div>

      {/* Sticky footer */}
      <div className="ym-adm-form-modal__footer">
        <UniBtn
          disabled={false}
          inline
          wide
          outline
          circle_EX
          i="fa fa-times"
          title="Otkaži"
          handleClick={() => { cbDialogCancel(); }}
        />
        <UniBtn
          disabled={(Easy69_v1.is_value_in_array(state.smestaj_tab, ["SERVISI", "OSTALO", "NONE"]) ? false : true)}
          inline
          wide
          circle_EX
          i="fa fa-paper-plane"
          title="Sačuvaj"
          handleClick={() => {
            // cbDialogSubmit(state);
            const prepared_entbox = _zzyourmap_prepare_entbox_for_submit_ostalo_v1(state, {});
            if (editMode) { // EDIT
              const payload = { of_id: state.of_id };
              cbDialogSubmit(prepared_entbox, payload);
            } else { // ADD
              cbDialogSubmit(prepared_entbox);
            }
            // cbDialogCancel();
          }}
        />
      </div>
    </div>
  );
};


//
const YourmapAdminDestinationList = (props) => {
  /*
        const {
        } = props;
        */
  const {
    appState,
    route_freshness,
    setRouteFreshnesssUpdate,

    setUniModalPortableContent,
    setUniModalPortableClose,

    fetchGetAll,
    tempArr,
    dmd_multitable_rows,
    dmd_multitable_entities,
    current_destination_entity,
    current_smestaj_entity,
    destination_entities,
    destination_entities_fetching,
    destination_entities_adm,
    smestaj_entities,
    smestaj_entities_fetching,
    smestaj_entities_adm,
  } = props.appPack;

  const _test_fetch_create = () => {
    //
    const vr_tablename = 'proba_tablename2';
    const test_data = {
      thisis: 'test_data',
      something: 123,
      other: 'abc',
    };
    const data_json = json_utils.js_to_always_json(test_data);
    const data = {
      vr_tablename,
      data_json,
      note: 'proba_note',
    }
    //
    _zzyourmap_ajax.create(data, vr_tablename)
      .then(response => {
        console.log('response', response);

      })
      .catch(err => {
        console.log('CATCH ERROR in _test_fetch_create', err);
      })
  };

  return (
    <>
      <div className="yourmap__admin-panel">

        <section>
          <div className="inner-admin-panel">

            {/*
            <div>
              <Btn
                disabled={false}
                title={'TEST CREATE'}
                btnColor={'btn--color-mui-indigo'}
                btnSmallWithTitle
                inline
                i='fa fa-pencil'
                tooltip='TEST CREATE'
                handleClick={() => {
                  //
                  // TEST
                  _test_fetch_create();
                }}
              />
              <Btn
                disabled={false}
                title={'TEST GET ALL'}
                btnColor={'btn--color-mui-indigo'}
                btnSmallWithTitle
                inline
                i='fa fa-pencil'
                tooltip='TEST GET ALL'
                handleClick={() => {
                  //
                  // TEST
                  fetchGetAll();
                }}
              />
            </div>
            */}
            {/*
            <h1>YourmapAdminDestinationList destinacije</h1>
            */}

            <ViewGeneratorSimpleV4
              route_freshness={route_freshness}
              rapidoziViewDefinition={{
                cbSubmitEntityCreate: (entbox) => {
                  window.alert('*** (Sumbit CREATE entity) ***');
                },
              }}
              viewDefinition={{
                view_key: 'YourmapAdminDestinationList',
                // table_additional_column_keys: ["client_id", "name", "email", "phone", "is_active"],
                table_additional_column_keys_EX: ["destinacija_tip", "parent_destinacija_id", "destinacija_slug", "destinacija_naslov", "destinacija_poddestinacija_naslov", "_main_img_url", "komentar", "_data_digest_valid"],
                table_additional_column_keys: [
                  {
                    key: "destinacija_tip",
                    title: "Tip",
                    minWidth: 128,
                  },
                  "parent_destinacija_id",
                  {
                    key: "destinacija_slug",
                    title: "Slug"
                  },
                  {
                    key: "destinacija_naslov",
                    title: "Naslov"
                  },
                  "destinacija_poddestinacija_naslov",
                  {
                    key: "_main_img_url",
                    title: "Main img."
                  },
                  "komentar", "_data_digest_valid"],
                cbEntityKeyExtractor: (entity, index) => {
                  // console.log('cbEntityKeyExtractor', entity);
                  // return entity.id;
                  return entity.of_id;
                },
                options: {
                  entity_col_disabled: false,
                },
                cbSubmitCreate: (entbox) => {
                  console.log('SUBMIT entbox', entbox);
                  const vr_tablename = 'ym_table_destination';
                  const data_for_json = {
                    ...entbox,
                  };
                  const data_json = json_utils.js_to_always_json(data_for_json);
                  const entbox_j = {
                    // vr_tablename,
                    data_json,
                    note: 'proba_note ym_table_destination',
                  };
                  console.log('entbox_j', entbox_j);
                  _zzyourmap_ajax.create(entbox_j, vr_tablename)
                    .then(response => {
                      console.log('response', response);
                      if (frfr_res_utils.is_srf(response?.data)) { // SUCCESS
                        const res_payload = frfr_res_utils.srf_extract_payload(response.data);
                        //
                        console.log('succes res_payload', res_payload);
                        // REFRESH
                        fetchGetAll();
                        // CLOSE MODAL
                        setUniModalPortableClose();
                      }
                    })
                    .catch(err => {
                      console.error('ERROR cbSubmitCreate ym_table_destination', err);
                    });

                },
                cbModalCreate: (cbDialogSubmit) => {
                  setUniModalPortableContent({
                    options: {},
                    jsx: (
                      <>
                        <YourmapFormDestination
                          cbDialogSubmit={cbDialogSubmit}
                          cbDialogCancel={setUniModalPortableClose}
                          appPack={props.appPack}
                        />
                      </>
                    ),
                  });
                },
                cbRefresh: () => { fetchGetAll(); },
                cbEntityActionsJsx: (entity, payload) => {
                  // return JSX action buttons
                  return (
                    <>
                      <div className="uu-text-wrap uu-gaps-m-05rem">
                       
                        <UniBtn
                          disabled={false}
                          inline
                          wide
                          circle_EX
                          size={24}
                          i='fa fa-pencil'
                          title={'Edit'}
                          iconOnly
                          tooltip='Edit entity'
                          btnColor_TODO={'btn--color-mui-indigo'}
                          handleClick={() => {
                            setUniModalPortableContent({
                              options: {},
                              jsx: (
                                <>
                                  <YourmapFormDestination
                                    cbDialogSubmit={(entbox, payload) => {
                                      console.log('SUBMIT UPDATE entbox', entbox, payload);
                                      const vr_tablename = 'ym_table_destination';
                                      const data_for_json = {
                                        ...entbox,
                                      };
                                      const data_json = json_utils.js_to_always_json(data_for_json);
                                      const entbox_j = {
                                        // vr_tablename,
                                        data_json,
                                        note: 'proba_note ym_table_destination',
                                      };
                                      console.log('entbox_j', entbox_j);
                                      const of_id = payload.of_id;
                                      _zzyourmap_ajax.create_new_rev(entbox_j, vr_tablename, of_id)
                                        .then(response => {
                                          console.log('response', response);
                                          if (frfr_res_utils.is_srf(response?.data)) { // SUCCESS
                                            const res_payload = frfr_res_utils.srf_extract_payload(response.data);
                                            //
                                            console.log('succes res_payload', res_payload);
                                            // REFRESH
                                            fetchGetAll();
                                            // CLOSE MODAL
                                            setUniModalPortableClose();
                                          }
                                        })
                                        .catch(err => {
                                          console.error('ERROR cbSubmitCreate ym_table_destination', err);
                                        });

                                      ////
                                    }}
                                    cbDialogCancel={setUniModalPortableClose}
                                    appPack={props.appPack}

                                    mode={'EDIT'}
                                    editorData={{ ...entity }}
                                  /*
                                    jsxHeader={<h2 className="heading-on-top">Edit client</h2>}
                                    initialState={{ ...entity }}
                                    formDefinition={_zzsurvey_formDefinitionClient}
                                    fetchingSubmit={appState.fetchingSubmit}
                                    cbSubmit={(entbox) => {
                                      const _entbox = entbox;
                                      if (typeof entbox.email === 'string') {
                                        _entbox.email = entbox.email.trim().toLowerCase();
                                      }
                                      fetchUpdateUniversal(TABLE_CLIENTS, _entbox)
                                    }}
                                    cbCancel={() => { setModalPortableContent(false); }}
                                    */
                                  />
                                </>
                              ),
                            });
                          }}
                        />

                        <UniBtnSoftDeleteToggle
                          flagDeleted={entity?._master_flag_deleted === true}
                          handleDeactivate={() => {
                            if (window.confirm("Da li ste sigurni da želite da deaktivirate entity?")) {
                              const item_key = entity?.of_id;
                              _zzyourmap_ajax.master_update_flagdeleted({ flag_deleted: true }, item_key)
                                .then(response => {
                                  console.log('response', response);
                                  console.log('master_update_flagdeleted successful:', response.data);
                                  if (frfr_res_utils.is_srf(response?.data)) {
                                    const res_payload = frfr_res_utils.srf_extract_payload(response.data);
                                    //
                                    console.log('res_payload', res_payload);
                                    //
                                    // refresh();
                                    fetchGetAll(); // REFRESH
                                  }
                                })
                                .catch(err => {
                                  console.error('ERROR axios master_update_flagdeleted:', err);
                                });
                            }
                          }}
                          handleActivate={() => {
                            if (window.confirm("Da li ste sigurni da želite da aktivirate entity?")) {
                              const item_key = entity?.of_id;
                              _zzyourmap_ajax.master_update_undelete({ flag_deleted: false }, item_key)
                                .then(response => {
                                  console.log('response', response);
                                  console.log('master_update_undelete successful:', response.data);
                                  if (frfr_res_utils.is_srf(response?.data)) {
                                    const res_payload = frfr_res_utils.srf_extract_payload(response.data);
                                    //
                                    console.log('res_payload', res_payload);
                                    //
                                    // refresh();
                                    fetchGetAll(); // REFRESH
                                  }
                                })
                                .catch(err => {
                                  console.error('ERROR axios master_update_undelete:', err);
                                });
                            }
                          }}
                        />
                        {/*
                        <Btn
                          disabled={entity.is_active === false}
                          title={'Deactivate HARD'}
                          btnColor={'btn--red'}
                          btnSmallWithTitle
                          inline
                          i='fa fa-trash'
                          tooltip='Deactivate client'
                          handleClick={() => {
                            if (window.confirm("Da li ste sigurni da želite da obrišete klijenta?")) {
                              // TODO
                              // crudDeleteUniversal();

                            }
                          }}
                        />
                        */}
                      </div>
                    </>
                  );
                },

              }}
              viewArr_EX={'dmd_utils_prepare_smart({}).arr'}
              fetching_EX={true}
              viewArr_EX2={tempArr}
              viewArr_EX3={dmd_utils.dmd_to_always_arr(dmd_multitable_entities)}
              fetching_EX3={dmd_utils.is_fetching(dmd_multitable_entities)}
              viewArr={destination_entities_adm}
              fetching={destination_entities_fetching}
              jsxSpinner_OLD={'<UniSpinnerClassic />'}
            />

          </div>
        </section>
      </div>
    </>
  );
};


// ══════════════════════════════════════════════════════════════════
//  YourmapFormSmestajV2 — Alternative guided wizard create/edit modal
//  Keeps the exact same state shape and submit logic as the original.
//  What changes: the UX — step-by-step wizard, two-column layout,
//  and a deeply redesigned Map & Marker step.
// ══════════════════════════════════════════════════════════════════

// Anchor preset picker — 3×3 visual grid
const _ANCHOR_PRESETS = [
  { label: '↖', position: 'top-left', anchorFn: (w, h) => [0, 0] },
  { label: '↑', position: 'top-center', anchorFn: (w, h) => [Math.round(w / 2), 0] },
  { label: '↗', position: 'top-right', anchorFn: (w, h) => [w, 0] },
  { label: '←', position: 'mid-left', anchorFn: (w, h) => [0, Math.round(h / 2)] },
  { label: '⊙', position: 'center', anchorFn: (w, h) => [Math.round(w / 2), Math.round(h / 2)] },
  { label: '→', position: 'mid-right', anchorFn: (w, h) => [w, Math.round(h / 2)] },
  { label: '↙', position: 'bottom-left', anchorFn: (w, h) => [0, h] },
  { label: '↓', position: 'bottom-center', anchorFn: (w, h) => [Math.round(w / 2), h] },
  { label: '↘', position: 'bottom-right', anchorFn: (w, h) => [w, h] },
];
const _ANCHOR_PRESET_TIPS = {
  'top-left': 'Levo-gore',
  'top-center': 'Gore-centar',
  'top-right': 'Desno-gore',
  'mid-left': 'Levo-sredina',
  'center': 'Centar',
  'mid-right': 'Desno-sredina',
  'bottom-left': 'Levo-dole',
  'bottom-center': 'Dole-centar (tipično za pin ikonu)',
  'bottom-right': 'Desno-dole',
};

const AnchorPresetPicker = ({ anchorLeft, anchorTop, markerW, markerH, onChange }) => {
  const w = Number(markerW) || 40;
  const h = Number(markerH) || 40;

  const getActivePreset = () => {
    const al = Number(anchorLeft);
    const at = Number(anchorTop);
    for (const p of _ANCHOR_PRESETS) {
      const [pl, pt] = p.anchorFn(w, h);
      if (pl === al && pt === at) return p.position;
    }
    return null;
  };
  const activePreset = getActivePreset();

  return (
    <div className="ym-v2-anchor-picker">
      <div className="ym-v2-anchor-picker__label">
        <i className="fa fa-crosshairs" aria-hidden="true" />
        <span>Sidro (Anchor)</span>
        <span className="ym-v2-anchor-picker__sublabel">tačka na ikoni koja se poravnava sa pozicijom na mapi</span>
      </div>
      <div className="ym-v2-anchor-picker__grid">
        {_ANCHOR_PRESETS.map((preset) => {
          const isActive = activePreset === preset.position;
          return (
            <button
              key={preset.position}
              type="button"
              className={'ym-v2-anchor-picker__cell' + (isActive ? ' ym-v2-anchor-picker__cell--active' : '')}
              title={_ANCHOR_PRESET_TIPS[preset.position]}
              onClick={() => {
                const [newLeft, newTop] = preset.anchorFn(w, h);
                onChange(newLeft, newTop);
              }}
            >
              {preset.label}
            </button>
          );
        })}
      </div>
      <div className="ym-v2-anchor-picker__vals">
        <span className="ym-v2-anchor-picker__val-item">
          <span className="ym-v2-anchor-picker__val-key">anchor_left:</span>
          <span className="ym-v2-anchor-picker__val-num">{anchorLeft ?? 0}</span>
        </span>
        <span className="ym-v2-anchor-picker__val-item">
          <span className="ym-v2-anchor-picker__val-key">anchor_top:</span>
          <span className="ym-v2-anchor-picker__val-num">{anchorTop ?? 0}</span>
        </span>
        {activePreset && (
          <span className="ym-v2-anchor-picker__preset-name">{_ANCHOR_PRESET_TIPS[activePreset]}</span>
        )}
      </div>
    </div>
  );
};

// ─────────────────────────────────────────────────────────────────
//  ClickableAnchorPreview — click on marker image to set anchor
// ─────────────────────────────────────────────────────────────────
const ClickableAnchorPreview = ({ markerImgSrc, markerW, markerH, anchorLeft, anchorTop, onChange }) => {
  const MAX_DISPLAY = 260;
  const MIN_INTERACTIVE_SIDE = 120;
  const w = markerW > 0 ? markerW : 80;
  const h = markerH > 0 ? markerH : 80;
  const maxSide = Math.max(w, h);
  const fitScale = Math.min(MAX_DISPLAY / w, MAX_DISPLAY / h);
  const minScaleForInteraction = maxSide > 0 ? (MIN_INTERACTIVE_SIDE / maxSide) : 1;
  // Scale down large icons; scale up very small ones for easier clicking.
  const scale = Math.max(Math.min(fitScale, 3), Math.min(minScaleForInteraction, 3));
  const dispW = Math.round(w * scale);
  const dispH = Math.round(h * scale);
  // Current anchor dot position in display px
  const dotLeftRaw = Math.round((anchorLeft || 0) * scale);
  const dotTopRaw = Math.round((anchorTop || 0) * scale);
  const dotLeft = Math.min(Math.max(dotLeftRaw, 0), Math.max(dispW - 1, 0));
  const dotTop = Math.min(Math.max(dotTopRaw, 0), Math.max(dispH - 1, 0));

  const handleClick = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = Math.min(Math.max(e.clientX - rect.left, 0), rect.width);
    const y = Math.min(Math.max(e.clientY - rect.top, 0), rect.height);
    // Convert back to actual marker coordinates
    const nextLeft = Math.min(Math.max(Math.round(x / scale), 0), w);
    const nextTop = Math.min(Math.max(Math.round(y / scale), 0), h);
    onChange(nextLeft, nextTop);
  };

  return (
    <>
      <div
        className="ym-anchor-click-preview"
        style={{ width: dispW, height: dispH }}
        onClick={handleClick}
        title="Klikni da postaviš sidro"
      >
        <img src={markerImgSrc} alt="marker" className="ym-anchor-click-preview__img" />
        {/* crosshair lines */}
        <div className="ym-anchor-click-preview__line-h" style={{ top: dotTop }} />
        <div className="ym-anchor-click-preview__line-v" style={{ left: dotLeft }} />
        {/* dot */}
        <div
          className="ym-anchor-click-preview__dot"
          style={{ left: dotLeft, top: dotTop }}
        />
      </div>
      <div className="ym-anchor-click-preview__meta">
        Prikaz x{scale.toFixed(2)} za preciznije postavljanje sidra
      </div>
    </>
  );
};

// ─────────────────────────────────────────────────────────────────
//  Helpers: build HTML strings for Leaflet divIcon markers
//  (plain strings, not JSX — used with window.L.divIcon)
// ─────────────────────────────────────────────────────────────────
const _buildPickerActiveMarkerHtml = (src, w, h, aLeft, aTop) => {
  const offsetLeft = 0 - (aLeft || 0);
  const offsetTop = 0 - (aTop || 0);
  const imgW = (w > 0) ? w : 40;
  const imgH = (h > 0) ? h : 40;
  const inner = src
    ? `<img src="${src}" class="ym-script__marker__icon-img ym-picker-active-marker__img" style="width:${imgW}px;height:${imgH}px;" />`
    : `<div class="ym-picker-active-marker__default-pin"></div>`;
  return (
    `<div class="ym-script__marker__v2-center">` +
    `<div class="ym-script__marker__v2-center__offset" style="left:${offsetLeft}px;top:${offsetTop}px;">` +
    `<div class="ym-script__marker__v1-icon-container ym-picker-active-marker">` +
    inner +
    `</div>` +
    `</div>` +
    `</div>`
  );
};

const _buildPickerGhostMarkerHtml = (src, w, h, aLeft, aTop) => {
  const offsetLeft = 0 - (aLeft || 0);
  const offsetTop = 0 - (aTop || 0);
  const imgW = (w > 0) ? w : 40;
  const imgH = (h > 0) ? h : 40;
  const inner = src
    ? `<img src="${src}" class="ym-script__marker__icon-img" style="width:${imgW}px;height:${imgH}px;" />`
    : `<div class="ym-picker-ghost-marker__default-pin"></div>`;
  return (
    `<div class="ym-script__marker__v2-center ym-picker-ghost-marker">` +
    `<div class="ym-script__marker__v2-center__offset" style="left:${offsetLeft}px;top:${offsetTop}px;pointer-events:none;">` +
    `<div class="ym-script__marker__v1-icon-container">` +
    inner +
    `</div>` +
    `</div>` +
    `</div>`
  );
};

// ─────────────────────────────────────────────────────────────────
//  MapPickerPopup — full popup map + anchor + dimensions + confirm
// ─────────────────────────────────────────────────────────────────
const MapPickerPopup = (props) => {
  const {
    options,
    initialLeft,
    initialBottom,
    initialAnchorLeft,
    initialAnchorTop,
    initialW,
    initialH,
    markerImgSrc,
    contextMarkersArr,   // all existing destination markers for context
    onConfirm,           // (left, bottom, aLeft, aTop, w, h) => void
    onCancel,
  } = props;

  const [tempLeft, setTempLeft] = useState(Number(initialLeft) || 0);
  const [tempBottom, setTempBottom] = useState(Number(initialBottom) || 0);
  const [tempAnchorLeft, setTempAnchorLeft] = useState(Number(initialAnchorLeft) || 0);
  const [tempAnchorTop, setTempAnchorTop] = useState(Number(initialAnchorTop) || 0);
  const [tempW, setTempW] = useState(Number(initialW) || 40);
  const [tempH, setTempH] = useState(Number(initialH) || 40);
  const [placed, setPlaced] = useState(
    Number(initialLeft) !== 0 || Number(initialBottom) !== 0
  );
  const [hideMarkers, setHideMarkers] = useState(false);
  const [scaleMarkers, setScaleMarkers] = useState(false);

  // ── Refs for Leaflet marker management (avoid stale closures) ──
  const leafletMarkerRef = useRef(null);
  const ghostMarkerRef = useRef(null);
  // Always-current icon props — read in closures/effects that can't have deps
  const iconPropsRef = useRef({ markerImgSrc, tempW, tempH, tempAnchorLeft, tempAnchorTop });
  iconPropsRef.current = { markerImgSrc, tempW, tempH, tempAnchorLeft, tempAnchorTop };

  // ── Leaflet icon builders (use iconPropsRef.current) ──────────
  const _buildActiveIcon = (p) => {
    if (typeof window.L === 'undefined') return null;
    return window.L.divIcon({
      html: _buildPickerActiveMarkerHtml(p.markerImgSrc, p.tempW, p.tempH, p.tempAnchorLeft, p.tempAnchorTop),
      iconSize: [0, 0],
      iconAnchor: null,
      className: 'ym-picker-active-marker-leaflet',
    });
  };

  const _buildGhostIcon = (p) => {
    if (typeof window.L === 'undefined') return null;
    return window.L.divIcon({
      html: _buildPickerGhostMarkerHtml(p.markerImgSrc, p.tempW, p.tempH, p.tempAnchorLeft, p.tempAnchorTop),
      iconSize: [0, 0],
      iconAnchor: null,
      className: 'ym-picker-ghost-marker-leaflet',
    });
  };

  // ── Effect: ghost hover (mount / unmount only) ─────────────────
  useEffect(() => {
    if (!window.ym_map || typeof window.L === 'undefined') return;

    const onMouseMove = (e) => {
      const icon = _buildGhostIcon(iconPropsRef.current);
      if (!icon) return;
      if (!ghostMarkerRef.current) {
        const gm = window.L.marker(e.latlng, { icon, interactive: false, zIndexOffset: -100 });
        gm.addTo(window.ym_map);
        ghostMarkerRef.current = gm;
      } else {
        ghostMarkerRef.current.setLatLng(e.latlng);
        ghostMarkerRef.current.setIcon(icon); // reflect anchor/image changes
      }
    };

    const onMouseOut = () => {
      if (ghostMarkerRef.current) {
        ghostMarkerRef.current.remove();
        ghostMarkerRef.current = null;
      }
    };

    window.ym_map.on('mousemove', onMouseMove);
    window.ym_map.on('mouseout', onMouseOut);

    return () => {
      window.ym_map.off('mousemove', onMouseMove);
      window.ym_map.off('mouseout', onMouseOut);
      if (ghostMarkerRef.current) {
        ghostMarkerRef.current.remove();
        ghostMarkerRef.current = null;
      }
      if (leafletMarkerRef.current) {
        leafletMarkerRef.current.remove();
        leafletMarkerRef.current = null;
      }
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Effect: place / move the active marker when position changes
  useEffect(() => {
    if (!window.ym_map || typeof window.L === 'undefined') return;

    if (!placed) {
      if (leafletMarkerRef.current) {
        leafletMarkerRef.current.remove();
        leafletMarkerRef.current = null;
      }
      return;
    }

    const icon = _buildActiveIcon(iconPropsRef.current);
    if (!icon) return;

    if (leafletMarkerRef.current) {
      // Already exists — just move it (drag or re-click)
      leafletMarkerRef.current.setLatLng([tempBottom, tempLeft]);
    } else {
      // Create new marker with drag support
      const lm = window.L.marker([tempBottom, tempLeft], { icon, draggable: true });
      lm.on('dragend', (e) => {
        const pos = e.target.getLatLng();
        setTempBottom(Math.round(pos.lat));
        setTempLeft(Math.round(pos.lng));
      });
      lm.addTo(window.ym_map);
      leafletMarkerRef.current = lm;
      // Drop-in animation
      const el = lm.getElement ? lm.getElement() : null;
      if (el) {
        el.classList.add('ym-picker-active-marker--drop');
        setTimeout(() => { if (el) el.classList.remove('ym-picker-active-marker--drop'); }, 700);
      }
    }
  }, [placed, tempLeft, tempBottom]); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Effect: update icon when anchor / dimensions / image change
  useEffect(() => {
    if (!placed || !leafletMarkerRef.current || typeof window.L === 'undefined') return;
    const icon = _buildActiveIcon(iconPropsRef.current);
    if (icon) leafletMarkerRef.current.setIcon(icon);
    // Also refresh ghost immediately if visible
    if (ghostMarkerRef.current) {
      const gicon = _buildGhostIcon(iconPropsRef.current);
      if (gicon) ghostMarkerRef.current.setIcon(gicon);
    }
  }, [placed, markerImgSrc, tempW, tempH, tempAnchorLeft, tempAnchorTop]); // eslint-disable-line react-hooks/exhaustive-deps

  // Override _cbClickLatLng so clicks update local temp state, not parent
  const pickerOptions = {
    ...options,
    // Inject all context markers so the full destination is visible
    markers_arr: Array.isArray(contextMarkersArr) ? contextMarkersArr : (options?.markers_arr || []),
    enableClickLatLng: true,
    disableClickPopup: true, // suppress the built-in coordinate popup
    _cbClickLatLng: (bottom, left) => {
      setTempBottom(Number.parseInt(bottom));
      setTempLeft(Number.parseInt(left));
      setPlaced(true);
    },
  };

  const mapExtraClass =
    (hideMarkers ? ' yourmap__map-special-filtering__hide-all-markers' : '') +
    (scaleMarkers ? ' yourmap__map-special-scale__scale-1-all-markers' : '');

  const handleAnchorChange = (newLeft, newTop) => {
    setTempAnchorLeft(newLeft);
    setTempAnchorTop(newTop);
  };

  // Bridge object so WidegtImageWithSizePicker can read/write our local temp state
  const dimensionsState = {
    smestaj_marker_img_w: tempW,
    smestaj_marker_img_h: tempH,
    smestaj_marker_img_anchor_left: tempAnchorLeft,
    smestaj_marker_img_anchor_top: tempAnchorTop,
  };
  const setDimensionsState = (updater) => {
    const current = {
      smestaj_marker_img_w: tempW,
      smestaj_marker_img_h: tempH,
      smestaj_marker_img_anchor_left: tempAnchorLeft,
      smestaj_marker_img_anchor_top: tempAnchorTop,
    };
    const next = typeof updater === 'function' ? updater(current) : updater;
    if (next.smestaj_marker_img_w !== current.smestaj_marker_img_w) setTempW(next.smestaj_marker_img_w);
    if (next.smestaj_marker_img_h !== current.smestaj_marker_img_h) setTempH(next.smestaj_marker_img_h);
    if (next.smestaj_marker_img_anchor_left !== current.smestaj_marker_img_anchor_left) setTempAnchorLeft(next.smestaj_marker_img_anchor_left);
    if (next.smestaj_marker_img_anchor_top !== current.smestaj_marker_img_anchor_top) setTempAnchorTop(next.smestaj_marker_img_anchor_top);
  };

  return (
    <div className="ym-map-picker-popup yourmap-theme__scope-admin-panel">

      {/* ── Top bar ──────────────────────────────────────────────── */}
      <div className="ym-map-picker-popup__topbar">
        <div className="ym-map-picker-popup__topbar-title">
          <i className="fa fa-map-marker" aria-hidden="true" />
          <span>Postavi marker na mapi</span>
        </div>
        {!placed && (
          <div className="ym-map-picker-popup__topbar-hint">
            <i className="fa fa-hand-o-down" aria-hidden="true" />
            Klikni bilo gde na mapi da postaviš marker
          </div>
        )}
        {placed && (
          <div className="ym-map-picker-popup__topbar-coords">
            <span className="ym-map-picker-popup__coord-key">left&nbsp;</span>
            <span className="ym-map-picker-popup__coord-val">{tempLeft}</span>
            <span className="ym-map-picker-popup__coord-sep">&nbsp;/&nbsp;</span>
            <span className="ym-map-picker-popup__coord-key">bottom&nbsp;</span>
            <span className="ym-map-picker-popup__coord-val">{tempBottom}</span>
            <span className="ym-map-picker-popup__coord-unit">&nbsp;px</span>
          </div>
        )}
        <div className="ym-map-picker-popup__topbar-controls">
          <label className="ym-map-picker-popup__check-label">
            <input type="checkbox" checked={hideMarkers} onChange={e => setHideMarkers(e.target.checked)} />
            <span>Sakrij markere</span>
          </label>
          <label className="ym-map-picker-popup__check-label">
            <input type="checkbox" checked={scaleMarkers} onChange={e => setScaleMarkers(e.target.checked)} />
            <span>Razmera 1:1</span>
          </label>
        </div>
        <button className="ym-map-picker-popup__close-btn" type="button" onClick={onCancel} title="Zatvori">
          <i className="fa fa-times" aria-hidden="true" />
        </button>
      </div>

      {/* ── Main: map + sidebar ──────────────────────────────────── */}
      <div className="ym-map-picker-popup__main">

        {/* Map area — natural yourmap__map-pos-picker sizing (80vw × 70vh) */}
        <div className="ym-map-picker-popup__map-area">
          {!placed && (
            <div className="ym-map-picker-popup__empty-overlay" aria-hidden="true">
              <div className="ym-map-picker-popup__empty-text">
                <i className="fa fa-hand-o-down" aria-hidden="true" />
                <span>Klikni na mapi da postaviš marker</span>
              </div>
            </div>
          )}
          <div className="yourmap__map-pos-picker">
            <div className={'yourmap__map' + mapExtraClass}>
              <YourmapMapPageWrapper mapFetching={false} hideSidebar={true}>
                <YourmapLeafletContainerUniversal ll={[51.2, -159.6]} options={pickerOptions} />
              </YourmapMapPageWrapper>
            </div>
          </div>
        </div>

        {/* Sidebar: anchor + dimensions helper */}
        <div className="ym-map-picker-popup__sidebar">

          {/* Section: Anchor */}
          <div className="ym-map-picker-popup__sidebar-section">
            <div className="ym-map-picker-popup__sidebar-title">
              <i className="fa fa-anchor" aria-hidden="true" /> Sidro (Anchor)
            </div>
            <p className="ym-map-picker-popup__sidebar-desc">
              Tačka na ikoni koja se poravnava sa koordinatom.
              Za pin ikonu odaberi <strong>↓ Dole-centar</strong>,
              za foto ikonu odaberi <strong>⊙ Centar</strong>.
            </p>

            {/* Preset grid */}
            <AnchorPresetPicker
              anchorLeft={tempAnchorLeft}
              anchorTop={tempAnchorTop}
              markerW={tempW || 40}
              markerH={tempH || 40}
              onChange={handleAnchorChange}
            />

            {/* Click-on-image anchor */}
            {markerImgSrc && (
              <div className="ym-map-picker-popup__click-anchor-wrap">
                <div className="ym-map-picker-popup__sidebar-sublabel">
                  <i className="fa fa-mouse-pointer" aria-hidden="true" /> Ili klikni direktno na ikonu:
                </div>
                <ClickableAnchorPreview
                  markerImgSrc={markerImgSrc}
                  markerW={tempW || 40}
                  markerH={tempH || 40}
                  anchorLeft={tempAnchorLeft}
                  anchorTop={tempAnchorTop}
                  onChange={handleAnchorChange}
                />
              </div>
            )}

            {/* Numeric fallback (collapsed) */}
            <details className="ym-v2-advanced-details" style={{ marginTop: 12 }}>
              <summary className="ym-v2-advanced-summary">Ručni unos koordinata sidra</summary>
              <div className="ym-v2-size-row ym-v2-size-row--mt">
                <div className="ym-v2-field-group ym-v2-field-group--compact">
                  <label className="ym-v2-label">anchor_left</label>
                  <input
                    className="ym-v2-input ym-v2-input--number"
                    type="number"
                    value={tempAnchorLeft}
                    onChange={e => setTempAnchorLeft(Number(e.target.value))}
                  />
                </div>
                <div className="ym-v2-field-group ym-v2-field-group--compact">
                  <label className="ym-v2-label">anchor_top</label>
                  <input
                    className="ym-v2-input ym-v2-input--number"
                    type="number"
                    value={tempAnchorTop}
                    onChange={e => setTempAnchorTop(Number(e.target.value))}
                  />
                </div>
              </div>
            </details>
          </div>

          {/* Section: Marker dimensions helper */}
          {markerImgSrc && (
            <div className="ym-map-picker-popup__sidebar-section">
              <div className="ym-map-picker-popup__sidebar-title">
                <i className="fa fa-arrows-alt" aria-hidden="true" /> Dimenzije markera
              </div>
              <p className="ym-map-picker-popup__sidebar-desc">
                Širina i visina ikone u pikselima. Koristi helper za detekciju originalne rezolucije.
              </p>
              <WidegtImageWithSizePicker
                src={markerImgSrc}
                state={dimensionsState}
                setState={setDimensionsState}
              />
            </div>
          )}

          {/* Section: Coordinates (manual fallback) */}
          <div className="ym-map-picker-popup__sidebar-section">
            <div className="ym-map-picker-popup__sidebar-title">
              <i className="fa fa-crosshairs" aria-hidden="true" /> Pozicija (px)
            </div>
            {placed ? (
              <div className="ym-map-picker-popup__coords-block">
                <div className="ym-map-picker-popup__coord-row">
                  <span className="ym-map-picker-popup__coord-key">left</span>
                  <div className="ym-map-picker-popup__coord-stepper">
                    <button type="button" className="ym-map-picker-popup__coord-step-btn" onClick={() => setTempLeft(v => v - 1)}>−</button>
                    <input
                      type="number"
                      className="ym-map-picker-popup__coord-input"
                      value={tempLeft}
                      onChange={e => { const v = parseInt(e.target.value, 10); if (!isNaN(v)) setTempLeft(v); }}
                    />
                    <button type="button" className="ym-map-picker-popup__coord-step-btn" onClick={() => setTempLeft(v => v + 1)}>+</button>
                    <span className="ym-map-picker-popup__coord-unit">px</span>
                  </div>
                </div>
                <div className="ym-map-picker-popup__coord-row">
                  <span className="ym-map-picker-popup__coord-key">bottom</span>
                  <div className="ym-map-picker-popup__coord-stepper">
                    <button type="button" className="ym-map-picker-popup__coord-step-btn" onClick={() => setTempBottom(v => v - 1)}>−</button>
                    <input
                      type="number"
                      className="ym-map-picker-popup__coord-input"
                      value={tempBottom}
                      onChange={e => { const v = parseInt(e.target.value, 10); if (!isNaN(v)) setTempBottom(v); }}
                    />
                    <button type="button" className="ym-map-picker-popup__coord-step-btn" onClick={() => setTempBottom(v => v + 1)}>+</button>
                    <span className="ym-map-picker-popup__coord-unit">px</span>
                  </div>
                </div>
              </div>
            ) : (
              <p className="ym-map-picker-popup__sidebar-desc" style={{ fontStyle: 'italic' }}>
                Klikni na mapu da postaviš marker.
              </p>
            )}
          </div>

        </div>
      </div>

      {/* ── Bottom bar ───────────────────────────────────────────── */}
      <div className="ym-map-picker-popup__bottombar">
        <div className="ym-map-picker-popup__bottombar-left">
          {placed && (
            <button
              type="button"
              className="ym-v2-btn ym-v2-btn--ghost-danger"
              onClick={() => {
                setTempLeft(0); setTempBottom(0); setPlaced(false);
                if (leafletMarkerRef.current) {
                  leafletMarkerRef.current.remove();
                  leafletMarkerRef.current = null;
                }
              }}
            >
              <i className="fa fa-undo" aria-hidden="true" /> Resetuj marker
            </button>
          )}
        </div>
        <div className="ym-map-picker-popup__bottombar-right">
          <button
            type="button"
            className="ym-v2-btn ym-v2-btn--save"
            disabled={!placed}
            onClick={() => onConfirm(tempLeft, tempBottom, tempAnchorLeft, tempAnchorTop, tempW, tempH)}
          >
            <i className="fa fa-check" aria-hidden="true" /> Potvrdi lokaciju
          </button>
        </div>
      </div>

    </div>
  );
};

// Wizard step nav pill
const WizardStepPill = ({ stepIndex, currentStep, label, icon, onClick }) => {
  const isDone = stepIndex < currentStep;
  const isActive = stepIndex === currentStep;
  return (
    <button
      type="button"
      className={
        'ym-v2-wizard__step-pill' +
        (isActive ? ' ym-v2-wizard__step-pill--active' : '') +
        (isDone ? ' ym-v2-wizard__step-pill--done' : '')
      }
      onClick={() => onClick(stepIndex)}
      title={label}
    >
      <span className="ym-v2-wizard__step-pill-num">
        {isDone ? <i className="fa fa-check" aria-hidden="true" /> : stepIndex + 1}
      </span>
      <span className="ym-v2-wizard__step-pill-label">{label}</span>
    </button>
  );
};

//
const YourmapFormSmestajV2 = (props) => {
  const {
    cbDialogSubmit,
    cbDialogCancel,
  } = props;
  const {
    destination_entities_adm,
    options_adm_parent_of_smestaj,
    ymthing_entities_adm,
    layer_titles_all,
    setUniModalPortableContent,
    setUniModalPortableClose,
    setUniModalPortableContent_2,
    setUniModalPortableClose_2,
  } = props.appPack;

  // ── State ──────────────────────────────────────────────────────────
  let initialState;
  let editMode = false;
  if (props.mode === 'EDIT') {
    editMode = true;
    initialState = props.editorData;
  } else {
    initialState = { ..._zzyourmap_preset_smestaj() };
  }
  const [state, handleChange, setState] = useHandleInputChange(initialState);
  const [subformGalleryArr, setSubformGalleryArr] = useState(js_utils.fix_always_arr(initialState?.gallery_img_arr));
  const [step, setStep] = useState(0);
  const [markerPlaced, setMarkerPlaced] = useState(
    editMode ? (Number(initialState?.smestaj_marker_img_left) !== 0 || Number(initialState?.smestaj_marker_img_bottom) !== 0) : false
  );
  const [hideAllMarkersInline, setHideAllMarkersInline] = useState(false);
  const [scaleMarkersTo1Inline, setScaleMarkersTo1Inline] = useState(false);

  const STEPS = [
    { label: 'Osnovno', icon: 'fa-tag' },
    { label: 'Kontakt', icon: 'fa-phone' },
    { label: 'Mediji', icon: 'fa-picture-o' },
    { label: 'Marker & Mapa', icon: 'fa-map-marker' },
    { label: 'Amenities', icon: 'fa-check-square-o' },
  ];

  // ── Image callbacks (identical to YourmapFormRestoran) ─────────────
  const cbPickSingleImage = (imglib_item, imglib_item_key, img_url) => {
    let img_filename = null;
    let img_folder = null;
    if (js_utils.is_string_not_empty(imglib_item?.img_filename)) {
      img_filename = imglib_item.img_filename;
      if (js_utils.is_string_not_empty(imglib_item?.img_folder)) {
        img_folder = imglib_item.img_folder;
      }
    }
    setState(s => ({ ...s, smestaj_main_img_filename: img_filename, smestaj_main_img_folder: img_folder }));
  };

  const cbPickSingleImage_2 = (imglib_item, imglib_item_key, img_url) => {
    let img_filename = null;
    let img_folder = null;
    if (js_utils.is_string_not_empty(imglib_item?.img_filename)) {
      img_filename = imglib_item.img_filename;
      if (js_utils.is_string_not_empty(imglib_item?.img_folder)) {
        img_folder = imglib_item.img_folder;
      }
    }
    setState(s => ({ ...s, smestaj_marker_img_filename: img_filename, smestaj_marker_img_folder: img_folder }));
  };

  const cbPickMultipleImages = (bingo_items_arr, imglib_item_key, img_url) => {
    const updatedSubformArr = [];
    bingo_items_arr.forEach((imglib_item) => {
      if (js_utils.is_string_not_empty(imglib_item?.img_filename)) {
        updatedSubformArr.push(imglib_item.img_filename);
      }
    });
    setSubformGalleryArr(sub_arr => [...sub_arr, ...updatedSubformArr]);
  };

  // ── Map click callback ─────────────────────────────────────────────
  const _cbClickLatLng = (bottom, left) => {
    setState(s => ({
      ...s,
      smestaj_marker_img_bottom: Number.parseInt(bottom),
      smestaj_marker_img_left: Number.parseInt(left),
    }));
    setMarkerPlaced(true);
  };

  const mapOptions = {
    ..._zzyourmap_extract_map_props_1_for_smestaj_position_picker(state, destination_entities_adm),
    enableClickLatLng: true,
    _cbClickLatLng,
  };

  // ── Derived marker values ──────────────────────────────────────────
  const markerImgSrc = _zzyourmap_img_url_full_from_parts(state?.smestaj_marker_img_filename, state?.smestaj_marker_img_folder);
  const mainImgSrc = _zzyourmap_img_url_full_from_parts(state?.smestaj_main_img_filename, state?.smestaj_main_img_folder);
  const markerAnimationPreviewMeta = (() => {
    const animationKey = state?.smestaj_marker_animacija ?? '';
    if (animationKey === 'bounce') {
      return { label: 'Skok', className: 'ym-script__marker__icon-bounce' };
    }
    if (animationKey === 'bounce_10') {
      return { label: 'Blagi skok', className: 'ym-script__marker__icon-bounce-10' };
    }
    if (animationKey === 'pulse') {
      return { label: 'Pulsiranje', className: 'ym-script__marker__icon-pulse' };
    }
    if (animationKey === 'float') {
      return { label: 'Lepršanje', className: 'ym-script__marker__icon-float' };
    }
    if (animationKey === 'wiggle') {
      return { label: 'Njihanje', className: 'ym-script__marker__icon-wiggle' };
    }
    if (animationKey === 'shake_1') {
      return { label: 'Drmanje 1', className: 'ym-script__marker__icon-shake-1' };
    }
    if (animationKey === 'shake_2') {
      return { label: 'Drmanje 2', className: 'ym-script__marker__icon-shake-2' };
    }
    return { label: 'Bez animacije', className: 'ym-script__marker__icon-default' };
  })();

  // ── Helpers ────────────────────────────────────────────────────────
  const openSingleImagePicker = (cb) => {
    setUniModalPortableContent_2({
      options: { large: true, zIndex: 9999 },
      jsx: (
        <>
          <YourmapImageLibraryV4
            appPack={props.appPack}
            cbDialogCancel={setUniModalPortableClose_2}
            cbPickSingleImage={cb}
            enableSelectSingular={true}
          />
        </>
      ),
    });
  };

  const openMultiImagePicker = (cb) => {
    setUniModalPortableContent_2({
      options: { large: true, zIndex: 9999 },
      jsx: (
        <>
          <YourmapImageLibraryV4
            appPack={props.appPack}
            cbDialogCancel={setUniModalPortableClose_2}
            cbPickMultipleImages={cb}
            enableSelectMultiple={true}
          />
        </>
      ),
    });
  };

  const openMapPickerAdvanced = () => {
    // Build all destination markers as context (so user can see where others are placed)
    const destId = state.parent_destinacija_id;
    const contextMarkersArr = (Array.isArray(ymthing_entities_adm) ? ymthing_entities_adm : [])
      .filter(e => e.parent_destinacija_id === destId && e.smestaj_marker_enabled === true)
      .map(e => _zzyourmap_extract_smestaj_map_marker_item_props(e))
      .filter(Boolean);

    setUniModalPortableContent_2({
      options: { large: true, zIndex: 9999 },
      jsx: (
        <MapPickerPopup
          options={mapOptions}
          initialLeft={state.smestaj_marker_img_left}
          initialBottom={state.smestaj_marker_img_bottom}
          initialAnchorLeft={state.smestaj_marker_img_anchor_left}
          initialAnchorTop={state.smestaj_marker_img_anchor_top}
          initialW={state.smestaj_marker_img_w}
          initialH={state.smestaj_marker_img_h}
          markerImgSrc={markerImgSrc}
          contextMarkersArr={contextMarkersArr}
          onConfirm={(left, bottom, aLeft, aTop, w, h) => {
            setState(s => ({
              ...s,
              smestaj_marker_img_left: left,
              smestaj_marker_img_bottom: bottom,
              smestaj_marker_img_anchor_left: aLeft,
              smestaj_marker_img_anchor_top: aTop,
              smestaj_marker_img_w: w,
              smestaj_marker_img_h: h,
            }));
            setMarkerPlaced(left !== 0 || bottom !== 0);
            setUniModalPortableClose_2();
          }}
          onCancel={setUniModalPortableClose_2}
        />
      ),
    });
  };

  const handleAnchorChange = (newLeft, newTop) => {
    setState(s => ({ ...s, smestaj_marker_img_anchor_left: newLeft, smestaj_marker_img_anchor_top: newTop }));
  };

  // ── Step renderers ─────────────────────────────────────────────────

  const renderStep0 = () => (
    <div className="ym-v2-step">
      <div className="ym-v2-step__intro">
        <span className="ym-v2-step__intro-icon"><i className="fa fa-tag" aria-hidden="true" /></span>
        <span>Unesite osnovne podatke o entitetu.</span>
      </div>
      <div className="ym-v2-two-col">
        {/* Left column */}
        <div className="ym-v2-two-col__left">
          <div className="ym-v2-field-group">
            <label className="ym-v2-label ym-v2-label--required">Tip entiteta (vr_tablename)</label>
            <div className="ym-v2-chip-group">
              {[
                { label: 'Smeštaj', value: 'ym_table_smestaj' },
                { label: 'Restoran', value: 'ym_table_restoran' },
                { label: 'Aktivnosti', value: 'ym_table_aktivnost' },
                { label: 'Prodavnice', value: 'ym_table_prodavnica' },
                { label: 'Servis', value: 'ym_table_servis' },
                { label: 'Znamenitosti', value: 'ym_table_znamenitost' },
                { label: 'Ostalo', value: 'ym_table_ostalo_v2' },
                { label: '*Ignored', value: 'ym_table_ignored' },
              ].map(opt => (
                <button
                  key={opt.value}
                  type="button"
                  className={'ym-v2-chip' + (state.vr_tablename === opt.value ? ' ym-v2-chip--active' : '')}
                  onClick={() => setState(s => ({ ...s, vr_tablename: opt.value }))}
                >
                  {opt.label}
                </button>
              ))}
            </div>
          </div>

          <div className="ym-v2-field-group">
            <label className="ym-v2-label">Destinacija</label>
            <select
              className="ym-v2-select"
              name="parent_destinacija_id"
              value={state.parent_destinacija_id ?? ''}
              onChange={(e) => {
                const v = e.target.value;
                setState(s => ({ ...s, parent_destinacija_id: v === '' ? null : Number(v) }));
              }}
            >
              <option value="">— izaberi destinaciju —</option>
              {(options_adm_parent_of_smestaj || []).map(o => (
                <option key={o.value} value={o.value}>{o.title ?? o.label ?? String(o.value)}</option>
              ))}
            </select>
          </div>

          <div className="ym-v2-field-group">
            <label className="ym-v2-label">Legenda</label>
            <label className="ym-v2-check-item">
              <input
                type="checkbox"
                checked={state.smestaj_layer_is_manual === true}
                onChange={(e) => setState(s => ({ ...s, smestaj_layer_is_manual: e.target.checked }))}
              />
              <span className="ym-v2-check-item__label">Ručno biranje legende</span>
            </label>

            {state.smestaj_layer_is_manual === true && (
              <>
                <div className="uu-gap-standalone-05rem" />
                <div className="ym-v2-chip-group">
                  {[...(layer_titles_all || []), '_alwaysshow'].map(layerTitle => (
                    <button
                      key={layerTitle}
                      type="button"
                      className={'ym-v2-chip' + (state.smestaj_layer === layerTitle ? ' ym-v2-chip--active' : '')}
                      onClick={() => setState(s => ({ ...s, smestaj_layer: layerTitle, smestaj_layer_is_custom: false }))}
                    >
                      {layerTitle}
                    </button>
                  ))}
                </div>

                <div className="uu-gap-standalone-05rem" />
                <label className="ym-v2-check-item">
                  <input
                    type="checkbox"
                    checked={state.smestaj_layer_is_custom === true}
                    onChange={(e) => setState(s => ({
                      ...s,
                      smestaj_layer_is_custom: e.target.checked,
                      smestaj_layer: (e.target.checked === true ? null : s.smestaj_layer),
                    }))}
                  />
                  <span className="ym-v2-check-item__label">Unos nove legende</span>
                </label>
                <div style={{ fontSize: '0.8rem', color: 'hsl(0, 0%, 42%)', marginTop: '4px' }}>
                  Predlog: kratak naziv bez specijalnih znakova.
                </div>

                {state.smestaj_layer_is_custom === true && (
                  <>
                  <div className="uu-gap-standalone-05rem" />
                  <div className="ym-v2-field-group">
                    <label className="ym-v2-label">Naziv novog layer-a</label>
                    <input
                      className="ym-v2-input"
                      type="text"
                      name="smestaj_layer_custom_title"
                      value={state.smestaj_layer_custom_title ?? ''}
                      onChange={handleChange}
                      placeholder="npr. planinski-vodici"
                    />
                  </div>
                  </>
                )}
              </>
            )}
          </div>

          <div className="ym-v2-field-group">
            <label className="ym-v2-label ym-v2-label--required">Naziv</label>
            <input
              className="ym-v2-input"
              type="text"
              name="smestaj_naslov"
              value={state.smestaj_naslov ?? ''}
              onChange={handleChange}
              placeholder=""
            />
          </div>

          <div className="ym-v2-field-group">
            <label className="ym-v2-label">Podnaslov (kratki opis)</label>
            <input
              className="ym-v2-input"
              type="text"
              name="smestaj_podnaslov"
              value={state.smestaj_podnaslov ?? ''}
              onChange={handleChange}
              placeholder=""
            />
          </div>
        </div>

        {/* Right column */}
        <div className="ym-v2-two-col__right">
          <div className="ym-v2-field-group">
            <label className="ym-v2-label">Opis (prikazuje se u popup-u)</label>
            <textarea
              className="ym-v2-textarea"
              name="smestaj_opis"
              value={state.smestaj_opis ?? ''}
              onChange={handleChange}
              rows={4}
              placeholder=""
            />
          </div>

          <div className="ym-v2-field-group">
            <label className="ym-v2-label">Adresa</label>
            <input
              className="ym-v2-input"
              type="text"
              name="smestaj_adresa"
              value={state.smestaj_adresa ?? ''}
              onChange={handleChange}
              placeholder=""
            />
          </div>

          <div className="ym-v2-field-group">
            <label className="ym-v2-label">Komentar (interni, ne prikazuje se)</label>
            <input
              className="ym-v2-input"
              type="text"
              name="komentar"
              value={state.komentar ?? ''}
              onChange={handleChange}
              placeholder="Interni komentar..."
            />
          </div>
        </div>
      </div>
    </div>
  );

  const renderStep1 = () => (
    <div className="ym-v2-step">
      <div className="ym-v2-step__intro">
        <span className="ym-v2-step__intro-icon"><i className="fa fa-phone" aria-hidden="true" /></span>
        <span>Kontakt informacije (opciono).</span>
      </div>
      <div className="ym-v2-two-col">
        <div className="ym-v2-two-col__left">
          {[
            { key: 'telefon', label: 'Telefon', placeholder: '+381 ...' },
            { key: 'telefon2', label: 'Telefon 2', placeholder: '' },
            { key: 'mobilni', label: 'Mobilni', placeholder: '+381 ...' },
            { key: 'mobilni2', label: 'Mobilni 2', placeholder: '' },
            { key: 'email', label: 'E-mail', placeholder: 'email@primer.com', type: 'email' },
            { key: 'email2', label: 'E-mail 2', placeholder: 'email2@primer.com', type: 'email' },
          ].map(f => (
            <div key={f.key} className="ym-v2-field-group">
              <label className="ym-v2-label">{f.label}</label>
              <input
                className="ym-v2-input"
                type={f.type || 'text'}
                name={f.key}
                value={state[f.key] ?? ''}
                onChange={handleChange}
                placeholder={f.placeholder}
              />
            </div>
          ))}
        </div>
        <div className="ym-v2-two-col__right">
          {[
            { key: 'websajt', label: 'Websajt', placeholder: 'https://...' },
            { key: 'kontakt_instagram_url', label: 'Instagram URL', placeholder: 'https://instagram.com/...' },
            { key: 'google_maps_iframe_src', label: 'Google Maps iframe src', placeholder: '' },
            { key: 'geo_uri', label: 'Geo URI', placeholder: 'geo:43.28,20.80?z=17' },
          ].map(f => (
            <div key={f.key} className="ym-v2-field-group">
              <label className="ym-v2-label">{f.label}</label>
              <input
                className="ym-v2-input"
                type="text"
                name={f.key}
                value={state[f.key] ?? ''}
                onChange={handleChange}
                placeholder={f.placeholder}
              />
            </div>
          ))}
          <div className="ym-v2-hint-box">
            <i className="fa fa-info-circle" aria-hidden="true" />
            <span>Geo URI možeš naći na <a href="https://www.openstreetmap.org/" target="_blank" rel="noopener noreferrer">OpenStreetMap</a> — zoom na lokaciju i kopiraj koordinate iz URL-a.</span>
          </div>
        </div>
      </div>
    </div>
  );

  const renderStep2 = () => (
    <div className="ym-v2-step">
      <div className="ym-v2-step__intro">
        <span className="ym-v2-step__intro-icon"><i className="fa fa-picture-o" aria-hidden="true" /></span>
        <span>Postavi glavnu sliku i galeriju.</span>
      </div>

      {/* Main image */}
      <div className="ym-v2-media-section">
        <div className="ym-v2-media-section__title">Glavna slika</div>
        <div className="ym-v2-media-main">
          <div className="ym-v2-media-main__preview">
            {mainImgSrc ? (
              <img src={mainImgSrc} alt="glavna slika" className="ym-v2-media-main__img" />
            ) : (
              <div className="ym-v2-media-main__empty">
                <i className="fa fa-image" aria-hidden="true" />
                <span>Nema slike</span>
              </div>
            )}
          </div>
          <div className="ym-v2-media-main__actions">
            <button
              type="button"
              className="ym-v2-btn ym-v2-btn--secondary"
              onClick={() => openSingleImagePicker(cbPickSingleImage)}
            >
              <i className="fa fa-picture-o" aria-hidden="true" />
              {mainImgSrc ? 'Zameni sliku' : 'Izaberi sliku'}
            </button>
            {mainImgSrc && (
              <button
                type="button"
                className="ym-v2-btn ym-v2-btn--ghost-danger"
                onClick={() => setState(s => ({ ...s, smestaj_main_img_filename: '', smestaj_main_img_folder: '' }))}
              >
                <i className="fa fa-trash" aria-hidden="true" />
                Ukloni
              </button>
            )}
            {state.smestaj_main_img_filename && (
              <div className="ym-v2-media-main__meta">
                <span className="ym-v2-media-main__filename">{state.smestaj_main_img_filename}</span>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Gallery */}
      <div className="ym-v2-media-section">
        <div className="ym-v2-media-section__title">
          Galerija
          <span className="ym-v2-media-section__count">{subformGalleryArr.length} slika</span>
        </div>
        <div className="ym-v2-gallery-grid">
          {subformGalleryArr.map((filename, idx) => {
            const src = _zzyourmap_img_url_full_from_parts(filename, null);
            return (
              <div key={idx} className="ym-v2-gallery-item">
                <img src={src} alt={filename} className="ym-v2-gallery-item__img" />
                <button
                  type="button"
                  className="ym-v2-gallery-item__remove"
                  title="Ukloni sliku"
                  onClick={() => setSubformGalleryArr(arr => arr.filter((_, i) => i !== idx))}
                >
                  <i className="fa fa-times" aria-hidden="true" />
                </button>
              </div>
            );
          })}
          <button
            type="button"
            className="ym-v2-gallery-add-btn"
            onClick={() => openMultiImagePicker(cbPickMultipleImages)}
          >
            <i className="fa fa-plus" aria-hidden="true" />
            <span>Dodaj slike</span>
          </button>
        </div>
      </div>
    </div>
  );

  const renderStep3 = () => {
    const markerEnabled = state.smestaj_marker_enabled === true;

    return (
      <div className="ym-v2-step">
        <div className="ym-v2-step__intro">
          <span className="ym-v2-step__intro-icon"><i className="fa fa-map-marker" aria-hidden="true" /></span>
          <span>Postavi marker na mapi. Ovo je najvažniji korak — marker određuje gde se pojavljuje na turističkoj mapi.</span>
        </div>

        {/* Enable / disable toggle */}
        <div className="ym-v2-marker-toggle-card">
          <div className="ym-v2-marker-toggle-card__left">
            <div className="ym-v2-marker-toggle-card__icon">
              <i className={`fa ${markerEnabled ? 'fa-map-marker' : 'fa-eye-slash'}`} aria-hidden="true" />
            </div>
            <div>
              <div className="ym-v2-marker-toggle-card__title">Prikaži marker na mapi</div>
              <div className="ym-v2-marker-toggle-card__sub">
                {markerEnabled ? 'Marker je aktivan — pojavljuje se na mapi.' : 'Marker je isključen — entitet neće biti prikazan na mapi.'}
              </div>
            </div>
          </div>
          <label className="ym-v2-toggle">
            <input
              type="checkbox"
              checked={markerEnabled}
              onChange={(e) => setState(s => ({ ...s, smestaj_marker_enabled: e.target.checked }))}
            />
            <span className="ym-v2-toggle__track" />
          </label>
        </div>

        {markerEnabled && (
          <div className="ym-v2-marker-workspace">

            {/* ── Section A: Map ──────────────────────────────────── */}
            <div className="ym-v2-marker-section">
              <div className="ym-v2-marker-section__header">
                <span className="ym-v2-marker-section__num">1</span>
                <span className="ym-v2-marker-section__title">Pozicija na mapi</span>
                {markerPlaced && (
                  <span className="ym-v2-marker-section__badge ym-v2-marker-section__badge--ok">
                    <i className="fa fa-check" /> Postavljeno
                  </span>
                )}
                {!markerPlaced && (
                  <span className="ym-v2-marker-section__badge">
                    <i className="fa fa-info-circle" /> Klikni na mapu
                  </span>
                )}
              </div>

              {/* ── Advanced popup mode only ───────────────────────── */}
              {
                <>
                  {/* Current coordinates readout */}
                  {markerPlaced ? (
                    <div className="ym-v2-coords-card" style={{ margin: '10px 14px 0' }}>
                      <div className="ym-v2-coords-card__item">
                        <span className="ym-v2-coords-card__key">left</span>
                        <span className="ym-v2-coords-card__val">{state.smestaj_marker_img_left}</span>
                        <span className="ym-v2-coords-card__unit">px od levog ruba</span>
                      </div>
                      <div className="ym-v2-coords-card__item">
                        <span className="ym-v2-coords-card__key">bottom</span>
                        <span className="ym-v2-coords-card__val">{state.smestaj_marker_img_bottom}</span>
                        <span className="ym-v2-coords-card__unit">px od dna</span>
                      </div>
                      <button
                        type="button"
                        className="ym-v2-btn ym-v2-btn--ghost-danger ym-v2-btn--sm"
                        onClick={() => {
                          setState(s => ({ ...s, smestaj_marker_img_left: 0, smestaj_marker_img_bottom: 0 }));
                          setMarkerPlaced(false);
                        }}
                      >
                        <i className="fa fa-undo" aria-hidden="true" /> Resetuj poziciju
                      </button>
                    </div>
                  ) : (
                    <div className="ym-v2-map-instruction">
                      <i className="fa fa-hand-o-down" aria-hidden="true" />
                      <span>Otvori napredni odabir da vizuelno postaviš marker i sidro u jednom koraku.</span>
                    </div>
                  )}
                  {/* Open advanced popup button */}
                  <div style={{ padding: '12px 14px 14px' }}>
                    <button
                      type="button"
                      className="ym-v2-btn ym-v2-btn--primary"
                      onClick={openMapPickerAdvanced}
                    >
                      <i className="fa fa-magic" aria-hidden="true" />
                      {markerPlaced ? 'Izmeni poziciju i sidro' : 'Otvori odabir na mapi'}
                    </button>
                  </div>
                </>
              }
            </div>

            {/* ── Section B: Marker icon ──────────────────────────── */}
            <div className="ym-v2-marker-section">
              <div className="ym-v2-marker-section__header">
                <span className="ym-v2-marker-section__num">2</span>
                <span className="ym-v2-marker-section__title">Ikona markera</span>
                {markerImgSrc && <span className="ym-v2-marker-section__badge ym-v2-marker-section__badge--ok"><i className="fa fa-check" /> Slika odabrana</span>}
              </div>

              <div className="ym-v2-marker-icon-row">
                {/* Preview */}
                <div className="ym-v2-marker-icon-preview">
                  {markerImgSrc ? (
                    <img
                      src={markerImgSrc}
                      alt="marker icon"
                      style={{
                        width: state.smestaj_marker_img_w ? `${state.smestaj_marker_img_w}px` : 'auto',
                        height: state.smestaj_marker_img_h ? `${state.smestaj_marker_img_h}px` : 'auto',
                        maxWidth: '100%',
                      }}
                    />
                  ) : (
                    <div className="ym-v2-marker-icon-preview__empty">
                      <i className="fa fa-map-marker" aria-hidden="true" />
                      <span>Nema ikone</span>
                    </div>
                  )}
                </div>

                {/* Controls */}
                <div className="ym-v2-marker-icon-controls">
                  <button
                    type="button"
                    className="ym-v2-btn ym-v2-btn--secondary"
                    onClick={() => openSingleImagePicker(cbPickSingleImage_2)}
                  >
                    <i className="fa fa-picture-o" aria-hidden="true" />
                    {markerImgSrc ? 'Zameni ikonu' : 'Izaberi ikonu'}
                  </button>

                  <div className="ym-v2-size-row">
                    <div className="ym-v2-field-group ym-v2-field-group--compact">
                      <label className="ym-v2-label">Širina (px)</label>
                      <input
                        className="ym-v2-input ym-v2-input--number"
                        type="number"
                        name="smestaj_marker_img_w"
                        value={state.smestaj_marker_img_w ?? 40}
                        onChange={handleChange}
                        min={8}
                        max={200}
                      />
                    </div>
                    <div className="ym-v2-field-group ym-v2-field-group--compact">
                      <label className="ym-v2-label">Visina (px)</label>
                      <input
                        className="ym-v2-input ym-v2-input--number"
                        type="number"
                        name="smestaj_marker_img_h"
                        value={state.smestaj_marker_img_h ?? 40}
                        onChange={handleChange}
                        min={8}
                        max={200}
                      />
                    </div>
                  </div>

                  <div className="ym-v2-marker-options-layout">
                    <fieldset className="ym-v2-option-box ym-v2-option-box--marker-animation">
                      <legend className="ym-v2-option-box__legend">Animacija markera</legend>
                      <div className="ym-v2-option-box__hint">Izaberi animaciju i odmah pogledaj kako marker izgleda u pokretu.</div>
                      <div className="ym-v2-field-group ym-v2-field-group--marker-animation">
                        <select
                          className="ym-v2-select ym-v2-select--compact"
                          name="smestaj_marker_animacija"
                          value={state.smestaj_marker_animacija ?? ''}
                          onChange={handleChange}
                        >
                          <option value="">Bez animacije</option>
                          <option value="bounce">Skok</option>
                          <option value="bounce_10">Blagi skok</option>
                          <option value="pulse">Pulsiranje</option>
                          <option value="float">Lepršanje</option>
                          <option value="wiggle">Njihanje</option>
                          <option value="shake_1">Drmanje 1</option>
                          <option value="shake_2">Drmanje 2</option>
                        </select>

                        <div className="ym-v2-marker-animation-preview ym-v2-marker-animation-preview--compact">
                          <div className="ym-v2-marker-animation-preview__head">
                            <span className="ym-v2-marker-animation-preview__title">Live preview</span>
                            <span className="ym-v2-marker-animation-preview__name">{markerAnimationPreviewMeta.label}</span>
                          </div>
                          <div className="ym-v2-marker-animation-preview__stage">
                            {markerImgSrc ? (
                              <img
                                src={markerImgSrc}
                                alt="marker animation preview"
                                className={`ym-script__marker__icon-img ${markerAnimationPreviewMeta.className} ym-v2-marker-animation-preview__img`}
                                style={{
                                  width: state.smestaj_marker_img_w ? `${state.smestaj_marker_img_w}px` : '40px',
                                  height: state.smestaj_marker_img_h ? `${state.smestaj_marker_img_h}px` : '40px',
                                  maxWidth: '72px',
                                  maxHeight: '72px',
                                }}
                              />
                            ) : (
                              <div className={`ym-v2-marker-animation-preview__fallback ${markerAnimationPreviewMeta.className}`}>
                                <i className="fa fa-map-marker" aria-hidden="true" />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </fieldset>

                    <fieldset className="ym-v2-option-box ym-v2-option-box--zoom-marker">
                      <legend className="ym-v2-option-box__legend">Zoom markera</legend>
                      <div className="ym-v2-option-box__hint">Opcije ispod određuju kako se marker ponaša kada korisnik zumira mapu.</div>

                      <div className="ym-v2-field-group ym-v2-field-group--tight">
                        <label className="ym-v2-check-item">
                          <input
                            type="checkbox"
                            checked={state.smestaj_marker_zoom_disabled === true}
                            onChange={(e) => setState(s => ({
                              ...s,
                              smestaj_marker_zoom_disabled: e.target.checked,
                              smestaj_marker_zoom_follow_enabled: false,
                              smestaj_marker_zoom_step_enabled: e.target.checked ? false : (s.smestaj_marker_zoom_follow_enabled === true ? false : true),
                            }))}
                          />
                          <span className="ym-v2-check-item__label">Isključi zoom</span>
                        </label>
                      </div>

                      <div className="ym-v2-field-group ym-v2-field-group--tight">
                        <label className="ym-v2-check-item">
                          <input
                            type="checkbox"
                            checked={state.smestaj_marker_zoom_disabled !== true && state.smestaj_marker_zoom_follow_enabled !== false}
                            onChange={(e) => setState(s => ({
                              ...s,
                              smestaj_marker_zoom_follow_enabled: e.target.checked,
                              smestaj_marker_zoom_disabled: false,
                              smestaj_marker_zoom_step_enabled: e.target.checked ? false : (s.smestaj_marker_zoom_disabled === true ? false : true),
                            }))}
                          />
                          <span className="ym-v2-check-item__label">Prati zoom mape</span>
                        </label>
                      </div>

                      <div className="ym-v2-field-group ym-v2-field-group--tight">
                        <label className="ym-v2-check-item">
                          <input
                            type="checkbox"
                            checked={state.smestaj_marker_zoom_disabled !== true && state.smestaj_marker_zoom_follow_enabled !== true && state.smestaj_marker_zoom_step_enabled !== false}
                            onChange={(e) => setState(s => ({
                              ...s,
                              smestaj_marker_zoom_disabled: false,
                              smestaj_marker_zoom_follow_enabled: false,
                              smestaj_marker_zoom_step_enabled: e.target.checked,
                            }))}
                          />
                          <span className="ym-v2-check-item__label">Stepenasti zoom markera</span>
                        </label>
                      </div>
                    </fieldset>

                    <fieldset className="ym-v2-option-box ym-v2-option-box--marker-link">
                      <legend className="ym-v2-option-box__legend">Marker je link</legend>
                      <div className="ym-v2-option-box__hint">Omogući da klik na marker vodi na URL koji uneseš ispod.</div>
                      <div className="ym-v2-field-group ym-v2-field-group--marker-link">
                        <label className="ym-v2-check-item">
                          <input
                            type="checkbox"
                            checked={state.smestaj_marker_is_link === true}
                            onChange={(e) => setState(s => ({ ...s, smestaj_marker_is_link: e.target.checked }))}
                          />
                          <span className="ym-v2-check-item__label">Marker je link</span>
                        </label>

                        {state.smestaj_marker_is_link === true && (
                          <div className="ym-v2-field-group ym-v2-field-group--tight">
                            <label className="ym-v2-label">Marker URL (smestaj_marker_link_href)</label>
                            <input
                              className="ym-v2-input"
                              type="text"
                              name="smestaj_marker_link_href"
                              value={state.smestaj_marker_link_href ?? ''}
                              onChange={handleChange}
                              placeholder="https://example.com"
                            />

                            <div className="ym-v2-field-group ym-v2-field-group--tight" style={{ marginTop: 10 }}>
                              <label className="ym-v2-label">Otvori link u</label>
                              <select
                                className="ym-v2-select ym-v2-select--compact"
                                name="smestaj_marker_link_target"
                                value={state.smestaj_marker_link_target ?? '_blank'}
                                onChange={handleChange}
                              >
                                <option value="_blank">Novom tabu</option>
                                <option value="_self">Istom tabu</option>
                              </select>
                            </div>
                          </div>
                        )}
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
            </div>

            {/* ── Section C: Anchor ───────────────────────────────── */}
            <div className="ym-v2-marker-section">
              <div className="ym-v2-marker-section__header">
                <span className="ym-v2-marker-section__num">3</span>
                <span className="ym-v2-marker-section__title">Sidro (Anchor Point)</span>
              </div>
              <div className="ym-v2-anchor-explainer">
                <i className="fa fa-question-circle" aria-hidden="true" />
                <span>
                  Sidro je tačka <em>na ikoni</em> koja se poravnava sa koordinatom na mapi.
                  Za tipičnu pin ikonu izaberi <strong>↓ Dole-centar</strong>.
                  Za foto/kružnu ikonu izaberi <strong>⊙ Centar</strong>.
                </span>
              </div>
              <AnchorPresetPicker
                anchorLeft={state.smestaj_marker_img_anchor_left}
                anchorTop={state.smestaj_marker_img_anchor_top}
                markerW={state.smestaj_marker_img_w}
                markerH={state.smestaj_marker_img_h}
                onChange={handleAnchorChange}
              />
              <details className="ym-v2-advanced-details">
                <summary className="ym-v2-advanced-summary">Ručni unos koordinata sidra</summary>
                <div className="ym-v2-size-row ym-v2-size-row--mt">
                  <div className="ym-v2-field-group ym-v2-field-group--compact">
                    <label className="ym-v2-label">anchor_left (px)</label>
                    <input
                      className="ym-v2-input ym-v2-input--number"
                      type="number"
                      name="smestaj_marker_img_anchor_left"
                      value={state.smestaj_marker_img_anchor_left ?? 0}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="ym-v2-field-group ym-v2-field-group--compact">
                    <label className="ym-v2-label">anchor_top (px)</label>
                    <input
                      className="ym-v2-input ym-v2-input--number"
                      type="number"
                      name="smestaj_marker_img_anchor_top"
                      value={state.smestaj_marker_img_anchor_top ?? 0}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </details>
            </div>

          </div>
        )}
      </div>
    );
  };

  const renderStep4 = () => (
    <div className="ym-v2-step">
      <div className="ym-v2-step__intro">
        <span className="ym-v2-step__intro-icon"><i className="fa fa-check-square-o" aria-hidden="true" /></span>
        <span>Označi dostupne sadržaje i usluge.</span>
      </div>
      <div className="ym-v2-checks-grid-v2">
        {Object.keys({
          check_hotel: false, check_apartman: false, check_vila: false,
          check_wifi: false, check_klima: false, check_parking: false,
          check_garaza: false, check_dorucak: false, check_bazen: false, check_spa: false,
        }).map(key => (
          <label key={key} className="ym-v2-check-item">
            <input
              type="checkbox"
              checked={state[key] === true}
              onChange={(e) => setState(s => ({ ...s, [key]: e.target.checked }))}
            />
            <span className="ym-v2-check-item__label">{key.replace('check_', '')}</span>
          </label>
        ))}
      </div>
    </div>
  );

  const STEP_RENDERERS = [renderStep0, renderStep1, renderStep2, renderStep3, renderStep4];

  const handleSubmit = () => {
    const prepared_entbox = _zzyourmap_prepare_entbox_for_submit_smestaj(state, subformGalleryArr);
    if (editMode) {
      const payload = { of_id: state.of_id };
      cbDialogSubmit(prepared_entbox, payload);
    } else {
      cbDialogSubmit(prepared_entbox);
    }
  };

  return (
    <div className="ym-adm-form-modal ym-adm-form-modal--v2 yourmap-theme__scope-admin-panel">
      {/* ── Sticky header ─────────────────────────────────────── */}
      <div className="ym-adm-form-modal__header ym-v2-header">
        <div className="ym-v2-header__left">
          <h3 className="ym-adm-form-modal__title">
            {editMode ? 'Izmeni entitet' : 'Dodaj novi entitet'}
            <span className="ym-v2-header__subtitle"> — New UX</span>
          </h3>
        </div>
        <div className="ym-v2-header__steps">
          {STEPS.map((s, i) => (
            <WizardStepPill
              key={i}
              stepIndex={i}
              currentStep={step}
              label={s.label}
              icon={s.icon}
              onClick={setStep}
            />
          ))}
        </div>
        <button
          className="ym-adm-form-modal__close"
          type="button"
          onClick={() => cbDialogCancel()}
          aria-label="Zatvori"
        >
          <i className="fa fa-times" aria-hidden="true" />
        </button>
      </div>

      {/* ── Scrollable body ───────────────────────────────────── */}
      <div className="ym-adm-form-modal__body ym-v2-body">
        {STEP_RENDERERS[step]?.()}
      </div>

      {/* ── Sticky footer ─────────────────────────────────────── */}
      <div className="ym-adm-form-modal__footer ym-v2-footer">
        <div className="ym-v2-footer__left">
          {step > 0 && (
            <button type="button" className="ym-v2-btn ym-v2-btn--ghost" onClick={() => setStep(s => s - 1)}>
              <i className="fa fa-chevron-left" aria-hidden="true" /> Nazad
            </button>
          )}
        </div>
        <div className="ym-v2-footer__dots">
          {STEPS.map((_, i) => (
            <button
              key={i}
              type="button"
              className={'ym-v2-footer__dot' + (i === step ? ' ym-v2-footer__dot--active' : '') + (i < step ? ' ym-v2-footer__dot--done' : '')}
              onClick={() => setStep(i)}
              title={STEPS[i].label}
            />
          ))}
        </div>
        <div className="ym-v2-footer__right">
          <button type="button" className="ym-v2-btn ym-v2-btn--ghost" onClick={() => cbDialogCancel()}>
            <i className="fa fa-times" aria-hidden="true" /> Otkaži
          </button>
          {step < STEPS.length - 1 ? (
            <button type="button" className="ym-v2-btn ym-v2-btn--primary" onClick={() => setStep(s => s + 1)}>
              Dalje <i className="fa fa-chevron-right" aria-hidden="true" />
            </button>
          ) : (
            <button type="button" className="ym-v2-btn ym-v2-btn--save" onClick={handleSubmit}>
              <i className="fa fa-paper-plane" aria-hidden="true" /> Sačuvaj
            </button>
          )}
        </div>
      </div>
    </div>
  );
};


// DJUTURE
const YourmapAdminYmthingList = (props) => {
  /*
  const {
  } = props;
  */
  const {
    appState,
    route_freshness,
    setRouteFreshnesssUpdate,

    setUniModalPortableContent,
    setUniModalPortableClose,

    options_adm_parent_of_smestaj,

    fetchGetAll,
    dmd_multitable_rows,
    dmd_multitable_entities,
    current_destination_entity,
    current_smestaj_entity,
    destination_entities,
    destination_entities_fetching,
    destination_entities_adm,
    ymthing_entities,
    ymthing_entities_fetching,
    ymthing_entities_adm,
    restoran_entities,
    restoran_entities_fetching,
    restoran_entities_adm,
  } = props.appPack;
  console.log('---------ymthing_entities_adm before filtering', ymthing_entities_adm);
  //
  const [state, handleChange, setState] = useHandleInputChange({ vr_tablename: '', parent_destinacija_id: '', entity_status: 'active' }); // filter state
  //
  const ymthing_filtered_arr_1 = ymthing_entities_adm.filter((item) => {
    if (state.vr_tablename === '') {
      return true;
    } else {
      if (state.vr_tablename === item.vr_tablename) {
        return true;
      }
    }
    return false;
  });
  //
  const ymthing_filtered_arr_2 = ymthing_filtered_arr_1.filter((item) => {
    if (state.parent_destinacija_id === '' || !state.parent_destinacija_id) {
      return true;
    } else {
      if (state.parent_destinacija_id === item.parent_destinacija_id) {
        return true;
      }
    }
    return false;
  });
  //
  const ymthing_filtered_arr = ymthing_filtered_arr_2.filter((item) => {
    if (state.entity_status === '') return true;
    if (state.entity_status === 'active') return item._master_flag_deleted !== true;
    if (state.entity_status === 'inactive') return item._master_flag_deleted === true;
    return true;
  });
  const parent_destination_title_map = (Array.isArray(options_adm_parent_of_smestaj) ? options_adm_parent_of_smestaj : []).reduce((acc, o) => {
    const id = Number(o?.value);
    if (!Number.isNaN(id)) {
      acc[id] = o?.title ?? o?.label ?? String(o?.value ?? '');
    }
    return acc;
  }, {});
  const vr_tablename_title_map = _YMTHING_VR_TABLENAME_CHIPS.reduce((acc, o) => {
    if (o?.value) {
      acc[o.value] = o?.label ?? String(o.value);
    }
    return acc;
  }, {});
  const ymthing_filtered_arr_with_display_titles = ymthing_filtered_arr.map((item) => ({
    ...item,
    _vr_tablename_naziv: _ymthing_format_vr_tablename_for_display(item?.vr_tablename, vr_tablename_title_map),
    _legenda_naziv: (
      (typeof item?.smestaj_layer === 'string' && item.smestaj_layer.trim() !== '' && item.smestaj_layer.trim())
      || (typeof item?._marker_layer_title === 'string' && item._marker_layer_title.trim() !== '' && item._marker_layer_title.trim())
      || ''
    ),
    _parent_destinacija_naziv: parent_destination_title_map[item?.parent_destinacija_id] ?? item?.parent_destinacija_id,
    _marker_img_url: _zzyourmap_img_url_full_from_parts(item?.smestaj_marker_img_filename, item?.smestaj_marker_img_folder),
  }));
  //
  return (
    <>
      <div className="yourmap__admin-panel">

        <section>
          <div className="inner-admin-panel">
            <ViewGeneratorSimpleV4
              route_freshness={route_freshness}
              jsxToolbarSearchRowExtra={(
                <FilterChipGroup
                  label="Status"
                  name="entity_status"
                  value={state.entity_status}
                  onChange={(val) => setState(s => ({ ...s, entity_status: val }))}
                  options={[
                    { label: 'Active', value: 'active' },
                    { label: 'Inactive', value: 'inactive' },
                  ]}
                />
              )}
              jsxToolbarFilters={(
                <>
                  <FilterSelect
                    label="Destination"
                    name="parent_destinacija_id"
                    value={state.parent_destinacija_id}
                    onChange={(val) => setState(s => ({ ...s, parent_destinacija_id: val === '' ? '' : Number(val) }))}
                    options={options_adm_parent_of_smestaj.map(o => ({ label: o.title ?? o.label ?? String(o.value), value: o.value }))}
                    placeholder="All destinations"
                  />
                  <div className="adm-filter-divider" />
                  <FilterChipGroup
                    label="Type"
                    name="vr_tablename"
                    value={state.vr_tablename}
                    onChange={(val) => setState(s => ({ ...s, vr_tablename: val }))}
                    options={_YMTHING_VR_TABLENAME_CHIPS}
                  />
                </>
              )}
              rapidoziViewDefinition={{
                cbSubmitEntityCreate: (entbox) => {
                  window.alert('*** (Sumbit CREATE entity) ***');
                },
              }}
              viewDefinition={{
                view_key: 'TABLE_YMTHING',
                // table_additional_column_keys: ["client_id", "name", "email", "phone", "is_active"],
                table_additional_column_keys_EX: ["vr_tablename", "parent_destinacija_id", "smestaj_naslov",
                  {
                    key: "_routing_tab",
                    title: "_tab.",
                    minWidth: 96,
                  },
                  {
                    key: "_marker_layer_title",
                    title: "_layer.",
                    minWidth: 96,
                  },
                  "smestaj_marker_enabled", "_main_img_url", "websajt", "komentar", "_data_digest_valid"],
                table_additional_column_keys: [
                  {
                    key: "_vr_tablename_naziv",
                    title: "Type",
                    minWidth: 128,
                  },
                  {
                    key: "_legenda_naziv",
                    title: "Legenda",
                    minWidth: 128,
                  },
                  {
                    key: "_parent_destinacija_naziv",
                    title: "parent_destinacija",
                    minWidth: 160,
                  },
                  {
                    key: "smestaj_naslov",
                    title: "Naslov",
                  },
                  {
                    key: "smestaj_marker_enabled",
                    title: "Marker",
                    minWidth: 80,
                  },
                  {
                    key: "_marker_img_url",
                    title: "Marker img.",
                    minWidth: 96,
                    tdCb: (row) => {
                      const markerImgName = row?.smestaj_marker_img_filename || row?._marker_img_url || 'marker';
                      if (!row?._marker_img_url) {
                        return <span className="uu-opacity-05">-</span>;
                      }
                      return (
                        <img
                          src={row._marker_img_url}
                          alt={markerImgName}
                          title={markerImgName}
                          style={{
                            display: 'block',
                            width: '32px',
                            height: '32px',
                            objectFit: 'contain',
                            margin: '0 auto',
                          }}
                        />
                      );
                    },
                  },
                  {
                    key: "_main_img_url",
                    title: "Main img.",
                  },
                  "websajt", "komentar", "_data_digest_valid"],
                cbEntityKeyExtractor: (entity, index) => {
                  // console.log('cbEntityKeyExtractor', entity);
                  // return entity.id;
                  return entity.of_id;
                },
                options: {
                  entity_col_disabled: false,
                },
                cbSubmitCreate: (entbox) => {
                  console.log('SUBMIT entbox', entbox);
                  // const vr_tablename = 'ym_table_restoran';
                  const vr_tablename = entbox.vr_tablename;
                  const data_for_json = {
                    ...entbox,
                  };
                  delete data_for_json.vr_tablename; // TODO
                  const data_json = json_utils.js_to_always_json(data_for_json);
                  const entbox_j = {
                    // vr_tablename,
                    data_json,
                    note: 'proba_note ym_table_restoran',
                  };
                  console.log('entbox_j', entbox_j);
                  _zzyourmap_ajax.create(entbox_j, vr_tablename)
                    .then(response => {
                      console.log('response', response);
                      if (frfr_res_utils.is_srf(response?.data)) { // SUCCESS
                        const res_payload = frfr_res_utils.srf_extract_payload(response.data);
                        //
                        console.log('succes res_payload', res_payload);
                        // REFRESH
                        fetchGetAll();
                        // CLOSE MODAL
                        setUniModalPortableClose();
                      }
                    })
                    .catch(err => {
                      console.error('ERROR cbSubmitCreate ym_table_restoran DJUTURE', err);
                    });

                },
                cbModalCreate: (cbDialogSubmit) => {
                  setUniModalPortableContent({
                    options: {},
                    jsx: (
                      <>
                        <YourmapFormSmestajV2
                          cbDialogSubmit={cbDialogSubmit}
                          cbDialogCancel={setUniModalPortableClose}
                          appPack={props.appPack}
                        />
                      </>
                    ),
                  });
                },
                cbModalCreateAlt: (cbDialogSubmit) => {
                  setUniModalPortableContent({
                    options: {},
                    jsx: (
                      <>
                        <YourmapFormSmestajV2
                          cbDialogSubmit={cbDialogSubmit}
                          cbDialogCancel={setUniModalPortableClose}
                          appPack={props.appPack}
                        />
                      </>
                    ),
                  });
                },
                cbRefresh: () => { fetchGetAll(); },
                cbEntityActionsJsx: (entity, payload) => {
                  // return JSX action buttons
                  return (
                    <>
                      <div className="uu-text-wrap uu-gaps-m-05rem">
                        {/* <UniBtn
                          disabled={false}
                          inline
                          wide_EX
                          circle_EX
                          size={24}
                          i='fa fa-pencil'
                          title={'Edit'}
                          iconOnly
                          tooltip='Edit entity'
                          btnColor_TODO={'btn--color-mui-indigo'}
                          handleClick={() => {
                            setUniModalPortableContent({
                              options: {},
                              jsx: (
                                <YourmapFormSmestajV2
                                  cbDialogSubmit={(entbox, payload) => {
                                    console.log('SUBMIT UPDATE entbox', entbox, payload);
                                    // const vr_tablename = 'ym_table_restoran';
                                    const vr_tablename = entbox.vr_tablename;
                                    const data_for_json = {
                                      ...entbox,
                                    };
                                    delete data_for_json.vr_tablename; // TODO
                                    const data_json = json_utils.js_to_always_json(data_for_json);
                                    const entbox_j = {
                                      // vr_tablename,
                                      data_json,
                                      note: 'proba_note ym_table_restoran *',
                                    };
                                    console.log('entbox_j', entbox_j);
                                    const of_id = payload.of_id;
                                    _zzyourmap_ajax.create_new_rev(entbox_j, vr_tablename, of_id)
                                      .then(response => {
                                        console.log('response', response);
                                        if (frfr_res_utils.is_srf(response?.data)) { // SUCCESS
                                          const res_payload = frfr_res_utils.srf_extract_payload(response.data);
                                          //
                                          console.log('succes res_payload', res_payload);
                                          // REFRESH
                                          fetchGetAll();
                                          // CLOSE MODAL
                                          setUniModalPortableClose();
                                        }
                                      })
                                      .catch(err => {
                                        console.error('ERROR cbSubmitCreate ym_table_restoran *', err);
                                      });

                                    ////
                                  }}
                                  cbDialogCancel={setUniModalPortableClose}
                                  appPack={props.appPack}

                                  mode={'EDIT'}
                                  editorData={{ ...entity }}
                                />),
                            });
                          }}
                        /> */}
                        <UniBtn
                          disabled={false}
                          inline
                          wide_EX
                          circle_EX
                          size={24}
                          i='fa fa-pencil'
                          title={'New Edit'}
                          iconOnly
                          tooltip='Edit entity (New UX)'
                          themeCompoColorBlue
                          handleClick={() => {
                            setUniModalPortableContent({
                              options: {},
                              jsx: (
                                <YourmapFormSmestajV2
                                  cbDialogSubmit={(entbox, payload) => {
                                    console.log('SUBMIT UPDATE (New UX) entbox', entbox, payload);
                                    const vr_tablename = entbox.vr_tablename;
                                    const data_for_json = {
                                      ...entbox,
                                    };
                                    delete data_for_json.vr_tablename; // TODO
                                    const data_json = json_utils.js_to_always_json(data_for_json);
                                    const entbox_j = {
                                      // vr_tablename,
                                      data_json,
                                      note: 'proba_note ym_table_restoran new-ux',
                                    };
                                    console.log('entbox_j new-ux', entbox_j);
                                    const of_id = payload.of_id;
                                    _zzyourmap_ajax.create_new_rev(entbox_j, vr_tablename, of_id)
                                      .then(response => {
                                        console.log('response new-ux', response);
                                        if (frfr_res_utils.is_srf(response?.data)) { // SUCCESS
                                          const res_payload = frfr_res_utils.srf_extract_payload(response.data);
                                          //
                                          console.log('succes res_payload new-ux', res_payload);
                                          // REFRESH
                                          fetchGetAll();
                                          // CLOSE MODAL
                                          setUniModalPortableClose();
                                        }
                                      })
                                      .catch(err => {
                                        console.error('ERROR cbSubmitCreate ym_table_restoran new-ux', err);
                                      });
                                  }}
                                  cbDialogCancel={setUniModalPortableClose}
                                  appPack={props.appPack}

                                  mode={'EDIT'}
                                  editorData={{ ...entity }}
                                />),
                            });
                          }}
                        />
                        <UniBtn
                          disabled={false}
                          inline
                          wide_EX
                          circle_EX
                          size={24}
                          i='fa fa-copy'
                          title={'Duplicate'}
                          iconOnly
                          tooltip='Create duplicate with pre-filled fields'
                          themeCompoColorGreen
                          handleClick={() => {
                            setUniModalPortableContent({
                              options: {},
                              jsx: (
                                <YourmapFormSmestajV2
                                  cbDialogSubmit={(entbox, payload) => {
                                    console.log('SUBMIT DUPLICATE entbox', entbox, payload);
                                    const vr_tablename = entbox.vr_tablename;
                                    const data_for_json = {
                                      ...entbox,
                                    };
                                    delete data_for_json.vr_tablename;
                                    const data_json = json_utils.js_to_always_json(data_for_json);
                                    const entbox_j = {
                                      data_json,
                                      note: 'duplicate entity',
                                    };
                                    console.log('entbox_j duplicate', entbox_j);
                                    _zzyourmap_ajax.create(entbox_j, vr_tablename)
                                      .then(response => {
                                        console.log('response duplicate', response);
                                        if (frfr_res_utils.is_srf(response?.data)) {
                                          const res_payload = frfr_res_utils.srf_extract_payload(response.data);
                                          console.log('succes res_payload duplicate', res_payload);
                                          fetchGetAll();
                                          setUniModalPortableClose();
                                        }
                                      })
                                      .catch(err => {
                                        console.error('ERROR cbSubmitDuplicate', err);
                                      });
                                  }}
                                  cbDialogCancel={setUniModalPortableClose}
                                  appPack={props.appPack}
                                  mode={'EDIT'}
                                  editorData={{
                                    ...entity,
                                    of_id: undefined,
                                  }}
                                />),
                            });
                          }}
                        />
                        <UniBtnSoftDeleteToggle
                          flagDeleted={entity?._master_flag_deleted === true}
                          handleDeactivate={() => {
                            if (window.confirm("Da li ste sigurni da želite da deaktivirate entity?")) {
                              const item_key = entity?.of_id;
                              _zzyourmap_ajax.master_update_flagdeleted({ flag_deleted: true }, item_key)
                                .then(response => {
                                  console.log('response', response);
                                  console.log('master_update_flagdeleted successful:', response.data);
                                  if (frfr_res_utils.is_srf(response?.data)) {
                                    const res_payload = frfr_res_utils.srf_extract_payload(response.data);
                                    //
                                    console.log('res_payload', res_payload);
                                    //
                                    // refresh();
                                    fetchGetAll(); // REFRESH
                                  }
                                })
                                .catch(err => {
                                  console.error('ERROR axios master_update_flagdeleted:', err);
                                });
                            }
                          }}
                          handleActivate={() => {
                            if (window.confirm("Da li ste sigurni da želite da aktivirate entity?")) {
                              const item_key = entity?.of_id;
                              _zzyourmap_ajax.master_update_undelete({ flag_deleted: false }, item_key)
                                .then(response => {
                                  console.log('response', response);
                                  console.log('master_update_undelete successful:', response.data);
                                  if (frfr_res_utils.is_srf(response?.data)) {
                                    const res_payload = frfr_res_utils.srf_extract_payload(response.data);
                                    //
                                    console.log('res_payload', res_payload);
                                    //
                                    // refresh();
                                    fetchGetAll(); // REFRESH
                                  }
                                })
                                .catch(err => {
                                  console.error('ERROR axios master_update_undelete:', err);
                                });
                            }
                          }}
                        />
                      </div>
                    </>
                  );
                },

              }}
              viewArr={ymthing_filtered_arr_with_display_titles}
              fetching={ymthing_entities_fetching}
            />

          </div>
        </section>
      </div>
    </>
  );
};


// BLOG (ostalo_v1)
const YourmapAdminYmostaloV1List = (props) => {
  /*
  const {
  } = props;
  */
  const {
    appState,
    route_freshness,
    setRouteFreshnesssUpdate,

    setUniModalPortableContent,
    setUniModalPortableClose,

    options_adm_parent_of_smestaj,

    fetchGetAll,
    dmd_multitable_rows,
    dmd_multitable_entities,
    current_destination_entity,
    current_smestaj_entity,
    destination_entities,
    destination_entities_fetching,
    destination_entities_adm,
    restoran_entities,
    restoran_entities_fetching,
    restoran_entities_adm,
    ymostalo_v1_entities,
    ymostalo_v1_entities_fetching,
    ymostalo_v1_entities_adm,
  } = props.appPack;

  //
  const [state, handleChange, setState] = useHandleInputChange({ vr_tablename: '', parent_destinacija_id: '' }); // filter state
  //
  const ymostalo_v1_filtered_arr = ymostalo_v1_entities_adm.filter((item) => {
    if (state.parent_destinacija_id === '' || !state.parent_destinacija_id) {
      return true;
    } else {
      if (state.parent_destinacija_id === item.parent_destinacija_id) {
        return true;
      }
    }
    return false;
  });
  //
  return (
    <>
      <div className="yourmap__admin-panel">

        <section>
          <div className="inner-admin-panel">
            <ViewGeneratorSimpleV4
              route_freshness={route_freshness}
              jsxToolbarFilters={(
                <FilterSelect
                  label="Destination"
                  name="parent_destinacija_id"
                  value={state.parent_destinacija_id}
                  onChange={(val) => setState(s => ({ ...s, parent_destinacija_id: val === '' ? '' : Number(val) }))}
                  options={options_adm_parent_of_smestaj.map(o => ({ label: o.title ?? o.label ?? String(o.value), value: o.value }))}
                  placeholder="All destinations"
                />
              )}
              rapidoziViewDefinition={{
                cbSubmitEntityCreate: (entbox) => {
                  window.alert('*** (Sumbit CREATE entity) ***');
                },
              }}
              viewDefinition={{
                view_key: 'TABLE_OSTALO_V1',
                // table_additional_column_keys: ["client_id", "name", "email", "phone", "is_active"],
                table_additional_column_keys_EX: ["parent_destinacija_id", "smestaj_naslov", "smestaj_tab", "smestaj_layer", "smestaj_marker_enabled", "_main_img_url", "komentar", "_data_digest_valid"],
                table_additional_column_keys: ["parent_destinacija_id",
                  {
                    key: "smestaj_naslov",
                    title: "Naslov"
                  },
                  {
                    key: "smestaj_tab",
                    title: "Tab",
                    minWidth: 96,
                  },
                  {
                    key: "_routing_tab",
                    title: "_tab.",
                    minWidth: 96,
                  },
                  {
                    key: "_marker_layer_title",
                    title: "_layer.",
                    minWidth: 96,
                  },
                  {
                    key: "smestaj_layer",
                    title: "Layer",
                    minWidth: 96,
                  },
                  {
                    key: "smestaj_marker_enabled",
                    title: "Marker",
                    minWidth: 80,
                  },
                  {
                    key: "_marker_img_url",
                    title: "Marker img.",
                    minWidth: 96,
                    tdCb: (row) => {
                      const markerImgUrl = _zzyourmap_img_url_full_from_parts(row?.smestaj_marker_img_filename, row?.smestaj_marker_img_folder);
                      const markerImgName = row?.smestaj_marker_img_filename || markerImgUrl || 'marker';
                      if (!markerImgUrl) {
                        return <span className="uu-opacity-05">-</span>;
                      }
                      return (
                        <img
                          src={markerImgUrl}
                          alt={markerImgName}
                          title={markerImgName}
                          style={{
                            display: 'block',
                            width: '32px',
                            height: '32px',
                            objectFit: 'contain',
                            margin: '0 auto',
                          }}
                        />
                      );
                    },
                  },
                  {
                    key: "_main_img_url",
                    title: "Main img."
                  },
                  "komentar", "_data_digest_valid"],
                cbEntityKeyExtractor: (entity, index) => {
                  // console.log('cbEntityKeyExtractor', entity);
                  // return entity.id;
                  return entity.of_id;
                },
                options: {
                  entity_col_disabled: false,
                },
                cbSubmitCreate: (entbox) => {
                  console.log('SUBMIT entbox', entbox);
                  const vr_tablename = 'ym_table_ostalo_v1';
                  const data_for_json = {
                    ...entbox,
                  };
                  const data_json = json_utils.js_to_always_json(data_for_json);
                  const entbox_j = {
                    // vr_tablename,
                    data_json,
                    note: 'proba_note ym_table_ostalo_v1',
                  };
                  console.log('entbox_j', entbox_j);
                  // TODO
                  console.log('TODO submit ostalo...');
                  _zzyourmap_ajax.create(entbox_j, vr_tablename)
                    .then(response => {
                      console.log('response', response);
                      if (frfr_res_utils.is_srf(response?.data)) { // SUCCESS
                        const res_payload = frfr_res_utils.srf_extract_payload(response.data);
                        //
                        console.log('succes res_payload', res_payload);
                        // REFRESH
                        fetchGetAll();
                        // CLOSE MODAL
                        setUniModalPortableClose();
                      }
                    })
                    .catch(err => {
                      console.error('ERROR cbSubmitCreate ym_table_ostalo_v1', err);
                    });

                },
                cbModalCreate: (cbDialogSubmit) => {
                  setUniModalPortableContent({
                    options: {},
                    jsx: (
                      <>
                        <YourmapFormYmostaloV1
                          cbDialogSubmit={cbDialogSubmit}
                          cbDialogCancel={setUniModalPortableClose}
                          appPack={props.appPack}
                        />
                      </>
                    ),
                  });
                },
                cbRefresh: () => { fetchGetAll(); },
                cbEntityActionsJsx: (entity, payload) => {
                  // return JSX action buttons
                  return (
                    <>
                      <div className="uu-text-wrap uu-gaps-m-05rem">
                        <UniBtn
                          disabled={false}
                          inline
                          wide_EX
                          circle_EX
                          size={24}
                          i='fa fa-pencil'
                          title={'Edit'}
                          iconOnly
                          tooltip='Edit entity'
                          btnColor_TODO={'btn--color-mui-indigo'}
                          handleClick={() => {
                            setUniModalPortableContent({
                              options: {},
                              jsx: (
                                <YourmapFormYmostaloV1
                                  cbDialogSubmit={(entbox, payload) => {
                                    console.log('SUBMIT UPDATE entbox', entbox, payload);
                                    const vr_tablename = 'ym_table_ostalo_v1';
                                    const data_for_json = {
                                      ...entbox,
                                    };
                                    const data_json = json_utils.js_to_always_json(data_for_json);
                                    const entbox_j = {
                                      // vr_tablename,
                                      data_json,
                                      note: 'proba_note ym_table_ostalo_v1',
                                    };
                                    console.log('entbox_j', entbox_j);
                                    const of_id = payload.of_id;
                                    _zzyourmap_ajax.create_new_rev(entbox_j, vr_tablename, of_id)
                                      .then(response => {
                                        console.log('response', response);
                                        if (frfr_res_utils.is_srf(response?.data)) { // SUCCESS
                                          const res_payload = frfr_res_utils.srf_extract_payload(response.data);
                                          //
                                          console.log('succes res_payload', res_payload);
                                          // REFRESH
                                          fetchGetAll();
                                          // CLOSE MODAL
                                          setUniModalPortableClose();
                                        }
                                      })
                                      .catch(err => {
                                        console.error('ERROR cbSubmitCreate ym_table_ostalo_v1', err);
                                      });

                                    ////
                                  }}
                                  cbDialogCancel={setUniModalPortableClose}
                                  appPack={props.appPack}

                                  mode={'EDIT'}
                                  editorData={{ ...entity }}
                                />),
                            });
                          }}
                        />
                        <UniBtn
                          disabled={false}
                          inline
                          wide_EX
                          circle_EX
                          size={24}
                          i='fa fa-copy'
                          title={'Duplicate'}
                          iconOnly
                          tooltip='Create duplicate with pre-filled fields'
                          themeCompoColorGreen
                          handleClick={() => {
                            setUniModalPortableContent({
                              options: {},
                              jsx: (
                                <YourmapFormYmostaloV1
                                  cbDialogSubmit={(entbox, payload) => {
                                    console.log('SUBMIT DUPLICATE entbox', entbox, payload);
                                    const vr_tablename = 'ym_table_ostalo_v1';
                                    const data_for_json = {
                                      ...entbox,
                                    };
                                    const data_json = json_utils.js_to_always_json(data_for_json);
                                    const entbox_j = {
                                      data_json,
                                      note: 'duplicate entity',
                                    };
                                    console.log('entbox_j duplicate', entbox_j);
                                    _zzyourmap_ajax.create(entbox_j, vr_tablename)
                                      .then(response => {
                                        console.log('response duplicate', response);
                                        if (frfr_res_utils.is_srf(response?.data)) {
                                          const res_payload = frfr_res_utils.srf_extract_payload(response.data);
                                          console.log('succes res_payload duplicate', res_payload);
                                          fetchGetAll();
                                          setUniModalPortableClose();
                                        }
                                      })
                                      .catch(err => {
                                        console.error('ERROR cbSubmitDuplicate', err);
                                      });
                                  }}
                                  cbDialogCancel={setUniModalPortableClose}
                                  appPack={props.appPack}
                                  mode={'EDIT'}
                                  editorData={{
                                    ...entity,
                                    of_id: undefined,
                                  }}
                                />),
                            });
                          }}
                        />
                        <UniBtnSoftDeleteToggle
                          flagDeleted={entity?._master_flag_deleted === true}
                          handleDeactivate={() => {
                            if (window.confirm("Da li ste sigurni da želite da deaktivirate entity?")) {
                              const item_key = entity?.of_id;
                              _zzyourmap_ajax.master_update_flagdeleted({ flag_deleted: true }, item_key)
                                .then(response => {
                                  console.log('response', response);
                                  console.log('master_update_flagdeleted successful:', response.data);
                                  if (frfr_res_utils.is_srf(response?.data)) {
                                    const res_payload = frfr_res_utils.srf_extract_payload(response.data);
                                    //
                                    console.log('res_payload', res_payload);
                                    //
                                    // refresh();
                                    fetchGetAll(); // REFRESH
                                  }
                                })
                                .catch(err => {
                                  console.error('ERROR axios master_update_flagdeleted:', err);
                                });
                            }
                          }}
                          handleActivate={() => {
                            if (window.confirm("Da li ste sigurni da želite da aktivirate entity?")) {
                              const item_key = entity?.of_id;
                              _zzyourmap_ajax.master_update_undelete({ flag_deleted: false }, item_key)
                                .then(response => {
                                  console.log('response', response);
                                  console.log('master_update_undelete successful:', response.data);
                                  if (frfr_res_utils.is_srf(response?.data)) {
                                    const res_payload = frfr_res_utils.srf_extract_payload(response.data);
                                    //
                                    console.log('res_payload', res_payload);
                                    //
                                    // refresh();
                                    fetchGetAll(); // REFRESH
                                  }
                                })
                                .catch(err => {
                                  console.error('ERROR axios master_update_undelete:', err);
                                });
                            }
                          }}
                        />
                      </div>
                    </>
                  );
                },

              }}
              viewArr={ymostalo_v1_filtered_arr}
              fetching={ymostalo_v1_entities_fetching}
            />

          </div>
        </section>
      </div>
    </>
  );
};


//
const YourmapAdminPanelFormLogin = (props) => {
  // const cbDialogSubmit = props.cbDialogSubmit;
  // const cbDialogCancel = props.cbDialogCancel;
  const {
    cbDialogSubmit,
    cbDialogCancel,
  } = props;
  //
  let initialState = {
    username: "",
    password: "",
  };
  let formDefinition = _zzyourmap_formDefinition_adminLogin;
  const [state, handleChange, setState] = useHandleInputChange(initialState);
  const handleSubmit = (e) => {
    if (e && typeof e.preventDefault === 'function') {
      e.preventDefault();
    }
    cbDialogSubmit(state);
  };
  //
  return (
    <div className="unicompo-various-content">
      <h3 className="uu-mt-0">Admin Panel Login</h3>
      <form onSubmit={handleSubmit}>
        <div>
          <FormGenerator
            formDefinition={formDefinition}
            formState={state}
            formErrors={{}}
            handleChange={handleChange}
          />
        </div>
        <button type="submit" style={{ display: 'none' }} aria-hidden="true" tabIndex={-1}></button>
        <div className="uu-gap-standalone-1rem"></div>
        <div className="uu-vector uu-vector-row uu-gaps-m-1rem">
          <UniBtn
            disabled={false}
            inline
            wide
            circle_EX
            i="fa fa-sign-in"
            title="Submit"
            handleClick={handleSubmit}
          />
          <UniBtn
            disabled={false}
            inline
            wide
            outline
            circle_EX
            i="fa fa-times"
            title="Cancel"
            handleClick={() => { cbDialogCancel(); }}
          />
        </div>
        <div className="uu-gap-standalone-1rem"></div>
      </form>
    </div>
  );
};


//
const SellerCardPage = (props) => {
  const {
    disabled,
    pageRouteActive,
  } = props;
  if (disabled === true || pageRouteActive === false) {
    return (<></>);
  }
  if (pageRouteActive === true) {
    return (
      <div className="yourmap__admin-panel__heading">
        {
          props.disableHeader !== true && (props.jsxHeader)
        }
        {props.children}
      </div>
    );
  }
  // else
  return (
    <CardCollapsible extraClass={props.extraClass} small={props.small} jsxHeader={props.jsxHeader}>{props.children}</CardCollapsible>
  );
};


//
const SidebarOption = (props) => {

  let handleClick = () => { };

  let clDisabled = '';
  if (props.disabled === true) {
    clDisabled = ' option--disabled';
  } else {
    if (typeof props.handleClick === 'function') {
      handleClick = props.handleClick;
    }
  }

  let clActive = '';
  if (props.active === true) {
    clActive = ' active';
  }
  let hasIcon = false;
  let jsxFontAwsome = null;
  jsxFontAwsome = (
    <span className="icon">
      <i></i>
    </span>
  );
  if (typeof props.i === 'string' && props.i !== '') {
    hasIcon = true;
    jsxFontAwsome = (
      <span className="icon">
        <i className={props.i} aria-hidden="true"></i>
      </span>
    )
  }

  return (
    <div
      className={"option" + clActive + clDisabled}
      onClick={handleClick}
    >
      <div className="bg">{jsxFontAwsome}<span className="title">{props.title}</span></div>
    </div>
  );
};


const YourmapAdminDisplayOrderPage = (props) => {
  const {
    destination_entities_adm,
    ymthing_entities_adm,
    fetchGetAll,
  } = props.appPack;

  const destinationOptions = useMemo(() => {
    const src = Array.isArray(destination_entities_adm) ? destination_entities_adm : [];
    return src
      .filter((item) => item?.destinacija_tip === 'DESTINATION' && item?._master_flag_deleted !== true)
      .map((item) => ({
        value: Number(item?.of_id),
        label: item?.destinacija_naslov || ('Destinacija #' + item?.of_id),
      }))
      .filter((item) => Number.isFinite(item.value));
  }, [destination_entities_adm]);

  const [selectedDestinationId, setSelectedDestinationId] = useState('');
  const [selectedTab, setSelectedTab] = useState('restorani');
  const [workingOrderIds, setWorkingOrderIds] = useState([]);
  const [saving, setSaving] = useState(false);
  const [draggingId, setDraggingId] = useState(null);
  const [dragOverId, setDragOverId] = useState(null);
  const isLegendTab = selectedTab === 'map_legend';

  const getEntityTitle = (item) => {
    if (typeof item?.smestaj_naslov === 'string' && item.smestaj_naslov.trim() !== '') {
      return item.smestaj_naslov.trim();
    }
    if (typeof item?.smestaj_podnaslov === 'string' && item.smestaj_podnaslov.trim() !== '') {
      return item.smestaj_podnaslov.trim();
    }
    return 'Entitet #' + item?.of_id;
  };

  useEffect(() => {
    if (selectedDestinationId !== '') {
      return;
    }
    if (destinationOptions.length === 0) {
      return;
    }
    setSelectedDestinationId(destinationOptions[0].value);
  }, [destinationOptions, selectedDestinationId]);

  const filteredEntities = useMemo(() => {
    const src = Array.isArray(ymthing_entities_adm) ? ymthing_entities_adm : [];
    const destinationId = Number(selectedDestinationId);
    if (!Number.isFinite(destinationId) || !selectedTab) {
      return [];
    }
    return src.filter((item) => {
      if (item?._master_flag_deleted === true) {
        return false;
      }
      if (item?._routing_tab !== selectedTab) {
        return false;
      }
      const parentRealDestinationId = Number(item?._routing_parent_real_destination_id);
      if (Number.isFinite(parentRealDestinationId) && parentRealDestinationId === destinationId) {
        return true;
      }
      return Number(item?.parent_destinacija_id) === destinationId;
    });
  }, [ymthing_entities_adm, selectedDestinationId, selectedTab]);

  const selectedDestinationEntity = useMemo(() => {
    const destinationId = Number(selectedDestinationId);
    if (!Number.isFinite(destinationId)) {
      return null;
    }
    const src = Array.isArray(destination_entities_adm) ? destination_entities_adm : [];
    return src.find((item) => Number(item?.of_id) === destinationId) || null;
  }, [destination_entities_adm, selectedDestinationId]);

  const legendLayerRows = useMemo(() => {
    const destinationId = Number(selectedDestinationId);
    if (!Number.isFinite(destinationId)) {
      return [];
    }
    const src = Array.isArray(ymthing_entities_adm) ? ymthing_entities_adm : [];
    const byKey = new Map();
    src.forEach((item) => {
      if (item?._master_flag_deleted === true || item?.smestaj_marker_enabled !== true) {
        return;
      }
      const parentRealDestinationId = Number(item?._routing_parent_real_destination_id);
      const fallbackDestinationId = Number(item?.parent_destinacija_id);
      const belongs = (Number.isFinite(parentRealDestinationId) && parentRealDestinationId === destinationId)
        || fallbackDestinationId === destinationId;
      if (!belongs) {
        return;
      }
      const marker_item = _zzyourmap_extract_smestaj_map_marker_item_props(item);
      const layer_title = marker_item?.layer_title;
      if (typeof layer_title !== 'string' || layer_title.trim() === '') {
        return;
      }
      const key = _zzyourmap_convert_layer_title_to_layer_key(layer_title);
      if (typeof key !== 'string' || key.trim() === '') {
        return;
      }
      if (!byKey.has(key)) {
        byKey.set(key, {
          of_id: key,
          legend_key: key,
          legend_title: layer_title,
        });
      }
    });
    return Array.from(byKey.values());
  }, [ymthing_entities_adm, selectedDestinationId]);

  const persistedLegendOrderKeys = useMemo(() => {
    const parsed = _parse_map_legend_order_json_safe(selectedDestinationEntity?.map_legend_order_json);
    const ids = Array.isArray(parsed?.main) ? parsed.main : [];
    return ids.filter((id) => typeof id === 'string' && id.trim() !== '');
  }, [selectedDestinationEntity]);

  const persistedLegendOrderKeysNormalized = useMemo(() => {
    const allLegendKeys = legendLayerRows.map((item) => String(item?.legend_key || '')).filter((id) => id !== '');
    const allowed = new Set(allLegendKeys);
    const out = [];

    persistedLegendOrderKeys.forEach((id) => {
      const normalized = String(id);
      if (allowed.has(normalized)) {
        out.push(normalized);
        allowed.delete(normalized);
      }
    });

    allLegendKeys.forEach((id) => {
      if (allowed.has(id)) {
        out.push(id);
      }
    });

    return out;
  }, [legendLayerRows, persistedLegendOrderKeys]);

  const persistedOrderedEntities = useMemo(() => {
    const arr = [...filteredEntities];
    return arr.sort((a, b) => {
      const orderA = Number(a?.smestaj_order_index);
      const orderB = Number(b?.smestaj_order_index);
      const safeA = Number.isFinite(orderA) ? orderA : Number.MAX_SAFE_INTEGER;
      const safeB = Number.isFinite(orderB) ? orderB : Number.MAX_SAFE_INTEGER;
      if (safeA !== safeB) {
        return safeA - safeB;
      }
      return Number(a?.of_id || 0) - Number(b?.of_id || 0);
    });
  }, [filteredEntities]);

  useEffect(() => {
    if (isLegendTab) {
      setWorkingOrderIds(persistedLegendOrderKeysNormalized);
      return;
    }
    const persistedIds = persistedOrderedEntities
      .map((item) => Number(item?.of_id))
      .filter((id) => Number.isFinite(id));
    setWorkingOrderIds(persistedIds);
  }, [isLegendTab, persistedLegendOrderKeysNormalized, persistedOrderedEntities]);

  const orderedEntities = useMemo(() => {
    const byId = new Map();
    filteredEntities.forEach((item) => {
      const id = Number(item?.of_id);
      if (Number.isFinite(id)) {
        byId.set(id, item);
      }
    });

    const used = new Set();
    const out = [];

    workingOrderIds.forEach((id) => {
      const item = byId.get(id);
      if (item) {
        out.push(item);
        used.add(id);
      }
    });

    filteredEntities.forEach((item) => {
      const id = Number(item?.of_id);
      if (!Number.isFinite(id) || used.has(id)) {
        return;
      }
      out.push(item);
    });

    return out;
  }, [filteredEntities, workingOrderIds]);

  const orderedLegendRows = useMemo(() => {
    const byKey = new Map();
    legendLayerRows.forEach((item) => {
      byKey.set(String(item.legend_key), item);
    });

    const used = new Set();
    const out = [];

    workingOrderIds.forEach((id) => {
      const item = byKey.get(String(id));
      if (item) {
        out.push(item);
        used.add(String(id));
      }
    });

    legendLayerRows.forEach((item) => {
      const id = String(item.legend_key);
      if (used.has(id)) {
        return;
      }
      out.push(item);
    });

    return out;
  }, [legendLayerRows, workingOrderIds]);

  const autoSortWorkingOrder = (mode) => {
    if (isLegendTab) {
      const arr = [...orderedLegendRows];
      if (mode === 'AZ') {
        arr.sort((a, b) => String(a?.legend_title || '').localeCompare(String(b?.legend_title || ''), 'sr', { sensitivity: 'base' }));
      } else if (mode === 'ZA') {
        arr.sort((a, b) => String(b?.legend_title || '').localeCompare(String(a?.legend_title || ''), 'sr', { sensitivity: 'base' }));
      } else {
        return;
      }
      setWorkingOrderIds(arr.map((item) => String(item?.legend_key || '')).filter((id) => id !== ''));
      return;
    }
    const arr = [...orderedEntities];
    if (mode === 'AZ') {
      arr.sort((a, b) => getEntityTitle(a).localeCompare(getEntityTitle(b), 'sr', { sensitivity: 'base' }));
    } else if (mode === 'ZA') {
      arr.sort((a, b) => getEntityTitle(b).localeCompare(getEntityTitle(a), 'sr', { sensitivity: 'base' }));
    } else if (mode === 'ID_ASC') {
      arr.sort((a, b) => Number(a?.of_id || 0) - Number(b?.of_id || 0));
    } else if (mode === 'ID_DESC') {
      arr.sort((a, b) => Number(b?.of_id || 0) - Number(a?.of_id || 0));
    } else {
      return;
    }
    setWorkingOrderIds(arr.map((item) => Number(item?.of_id)).filter((id) => Number.isFinite(id)));
  };

  const isDirty = isLegendTab
    ? JSON.stringify(workingOrderIds.map((id) => String(id))) !== JSON.stringify(persistedLegendOrderKeysNormalized)
    : JSON.stringify(workingOrderIds) !== JSON.stringify(
      persistedOrderedEntities.map((item) => Number(item?.of_id)).filter((id) => Number.isFinite(id))
    );

  const moveRow = (index, direction) => {
    setWorkingOrderIds((prev) => {
      const next = [...prev];
      const targetIndex = index + direction;
      if (index < 0 || targetIndex < 0 || targetIndex >= next.length) {
        return prev;
      }
      const temp = next[index];
      next[index] = next[targetIndex];
      next[targetIndex] = temp;
      return next;
    });
  };

  const moveRowToEdge = (index, toTop) => {
    setWorkingOrderIds((prev) => {
      if (index < 0 || index >= prev.length) {
        return prev;
      }
      const targetIndex = toTop ? 0 : (prev.length - 1);
      if (index === targetIndex) {
        return prev;
      }
      const next = [...prev];
      const [picked] = next.splice(index, 1);
      next.splice(targetIndex, 0, picked);
      return next;
    });
  };

  const moveRowById = (sourceId, targetId) => {
    setWorkingOrderIds((prev) => {
      const fromIndex = prev.findIndex((item) => String(item) === String(sourceId));
      const toIndexRaw = prev.findIndex((item) => String(item) === String(targetId));
      if (fromIndex < 0 || toIndexRaw < 0 || fromIndex === toIndexRaw) {
        return prev;
      }
      const next = [...prev];
      const [picked] = next.splice(fromIndex, 1);
      const toIndex = fromIndex < toIndexRaw ? (toIndexRaw - 1) : toIndexRaw;
      next.splice(toIndex, 0, picked);
      return next;
    });
  };

  const handleDragStartRow = (e, itemId) => {
    setDraggingId(itemId);
    setDragOverId(itemId);
    e.dataTransfer.effectAllowed = 'move';
    e.dataTransfer.setData('text/plain', String(itemId));
  };

  const handleDragOverRow = (e, itemId) => {
    e.preventDefault();
    if (dragOverId !== itemId) {
      setDragOverId(itemId);
    }
    e.dataTransfer.dropEffect = 'move';
  };

  const handleDropRow = (e, targetId) => {
    e.preventDefault();
    const fallbackSourceId = e.dataTransfer.getData('text/plain');
    const sourceId = draggingId !== null ? draggingId : fallbackSourceId;
    if (sourceId !== null && sourceId !== '' && targetId !== null && targetId !== '') {
      moveRowById(sourceId, targetId);
    }
    setDraggingId(null);
    setDragOverId(null);
  };

  const handleDragEndRow = () => {
    setDraggingId(null);
    setDragOverId(null);
  };

  const handleSave = async () => {
    const destinationId = Number(selectedDestinationId);
    if (!Number.isFinite(destinationId) || !selectedTab || saving === true) {
      return;
    }

    if (isLegendTab) {
      if (!selectedDestinationEntity) {
        return;
      }
      const prepared_entbox = _zzyourmap_prepare_entbox_for_submit_destination({
        ...selectedDestinationEntity,
        map_legend_order_json: json_utils.js_to_always_json({
          main: workingOrderIds.map((id) => String(id)).filter((id) => id !== ''),
        }),
      });
      if (!prepared_entbox) {
        return;
      }
      setSaving(true);
      try {
        const data_for_json = { ...prepared_entbox };
        const data_json = json_utils.js_to_always_json(data_for_json);
        const entbox_j = {
          data_json,
          note: 'update map_legend_order_json from admin display order',
        };
        await _zzyourmap_ajax.create_new_rev(entbox_j, 'ym_table_destination', destinationId);
        fetchGetAll();
      } catch (err) {
        console.error('ERROR save legend display order', err);
      } finally {
        setSaving(false);
      }
      return;
    }

    const entityMap = new Map();
    filteredEntities.forEach((item) => {
      const id = Number(item?.of_id);
      if (Number.isFinite(id)) {
        entityMap.set(id, item);
      }
    });

    const changes = workingOrderIds.map((id, index) => {
      const entity = entityMap.get(Number(id));
      if (!entity) {
        return null;
      }
      const nextOrderIndex = (index + 1) * 10;
      const currentOrderIndex = Number(entity?.smestaj_order_index);
      if (Number.isFinite(currentOrderIndex) && currentOrderIndex === nextOrderIndex) {
        return null;
      }
      return { entity, nextOrderIndex };
    }).filter((item) => item !== null);

    if (changes.length === 0) {
      return;
    }

    setSaving(true);
    try {
      for (let i = 0; i < changes.length; i += 1) {
        const { entity, nextOrderIndex } = changes[i];
        const prepared_entbox = _zzyourmap_prepare_entbox_for_submit_smestaj(
          {
            ...entity,
            smestaj_order_index: nextOrderIndex,
          },
          Array.isArray(entity?.gallery_img_arr) ? entity.gallery_img_arr : []
        );
        const vr_tablename = prepared_entbox.vr_tablename || entity?.vr_tablename;
        const of_id = Number(entity?.of_id);
        if (!vr_tablename || !Number.isFinite(of_id)) {
          continue;
        }
        const data_for_json = { ...prepared_entbox };
        delete data_for_json.vr_tablename;
        const data_json = json_utils.js_to_always_json(data_for_json);
        const entbox_j = {
          data_json,
          note: 'update smestaj_order_index',
        };
        await _zzyourmap_ajax.create_new_rev(entbox_j, vr_tablename, of_id);
      }
      fetchGetAll();
    } catch (err) {
      console.error('ERROR save display order', err);
    } finally {
      setSaving(false);
    }
  };

  const handleResetCurrent = () => {
    if (isLegendTab) {
      setWorkingOrderIds(persistedLegendOrderKeysNormalized);
      return;
    }
    const persistedIds = persistedOrderedEntities
      .map((item) => Number(item?.of_id))
      .filter((id) => Number.isFinite(id));
    setWorkingOrderIds(persistedIds);
  };

  const selectedDestinationTitle = (destinationOptions.find((d) => Number(d.value) === Number(selectedDestinationId)) || {}).label;
  const orderedRowsLength = isLegendTab ? orderedLegendRows.length : orderedEntities.length;

  return (
    <div className="yourmap__admin-panel">
      <section>
        <div className="inner-admin-panel">
          <div className="zzsurvey__card">
            <h3>Ručni redosled prikaza</h3>
            <p>
              {isLegendTab
                ? (<>Ovde određuješ redosled stavki legende mape. Redosled se čuva globalno u destinaciji i važi za sve korisnike/uređaje.</>)
                : (<>Ovde određuješ koji entitet ide prvi, drugi, treći... Redosled se čuva u samom entitetu kao polje <b>smestaj_order_index</b> i važi za sve korisnike/uređaje.</>)}
            </p>

            <div className="uu-vector uu-vector--row uu-vector--wrap uu-gaps-m-1rem">
              <div>
                <label>Destinacija</label>
                <select
                  value={selectedDestinationId}
                  onChange={(e) => setSelectedDestinationId(e.target.value === '' ? '' : Number(e.target.value))}
                >
                  {destinationOptions.length === 0 && <option value="">(nema destinacija)</option>}
                  {destinationOptions.map((option) => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </select>
              </div>
              <div>
                <label>Tip</label>
                <select value={selectedTab} onChange={(e) => setSelectedTab(e.target.value)}>
                  {_YMTHING_TAB_OPTIONS_FOR_DISPLAY_ORDER.map((option) => (
                    <option key={option.key} value={option.key}>{option.title}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="uu-gap-standalone-1rem"></div>

            <div className="uu-vector uu-vector--row uu-vector--wrap uu-gaps-m-05rem">
              <UniBtn
                inline
                outline
                circle
                wide
                i="fa fa-sort-alpha-asc"
                title="A-Z"
                disabled={orderedRowsLength <= 1 || saving}
                handleClick={() => autoSortWorkingOrder('AZ')}
              />
              <UniBtn
                inline
                outline
                circle
                wide
                i="fa fa-sort-alpha-desc"
                title="Z-A"
                disabled={orderedRowsLength <= 1 || saving}
                handleClick={() => autoSortWorkingOrder('ZA')}
              />
              <UniBtn
                inline
                outline
                circle
                wide
                i="fa fa-sort-numeric-asc"
                title="ID rastuće"
                disabled={isLegendTab || orderedRowsLength <= 1 || saving}
                handleClick={() => autoSortWorkingOrder('ID_ASC')}
              />
              <UniBtn
                inline
                outline
                circle
                wide
                i="fa fa-sort-numeric-desc"
                title="ID opadajuće"
                disabled={isLegendTab || orderedRowsLength <= 1 || saving}
                handleClick={() => autoSortWorkingOrder('ID_DESC')}
              />
            </div>

            <div className="uu-gap-standalone-05rem"></div>

            <div className="uu-vector uu-vector--row uu-vector--wrap uu-gaps-m-05rem">
              <small>Brza akcija: automatski složi listu pa po potrebi ručno koriguj strelicama ili prevlačenjem (drag-and-drop).</small>
            </div>

            <div className="uu-gap-standalone-1rem"></div>

            <div className="uu-vector uu-vector--row uu-vector--wrap uu-gaps-m-05rem">
              <UniBtn
                inline
                circle
                wide
                i="fa fa-save"
                title="Sačuvaj redosled"
                disabled={!isDirty || saving}
                handleClick={handleSave}
              />
              <UniBtn
                inline
                outline
                circle
                wide
                i="fa fa-undo"
                title="Vrati sačuvani redosled"
                handleClick={handleResetCurrent}
              />
            </div>

            {saving === true && (
              <div className="uu-gap-standalone-05rem">Snimanje izmena redosleda...</div>
            )}

            <div className="uu-gap-standalone-1rem"></div>

            {orderedRowsLength === 0 ? (
              <p>{isLegendTab ? 'Nema marker kategorija za izabranu destinaciju.' : 'Nema aktivnih entiteta za izabranu kombinaciju.'}</p>
            ) : (
              <div>
                <p>
                  Destinacija: <b>{selectedDestinationTitle || '-'}</b> | Tip: <b>{selectedTab}</b> | Stavki: <b>{orderedRowsLength}</b>
                </p>
                <div className="uu-vector uu-vector--col uu-gaps-m-05rem">
                  {(isLegendTab ? orderedLegendRows : orderedEntities).map((item, index) => {
                    const title = isLegendTab
                      ? (item?.legend_title || String(item?.legend_key || 'Legenda'))
                      : (item?.smestaj_naslov || item?.smestaj_podnaslov || ('Entitet #' + item?.of_id));
                    const itemId = isLegendTab ? String(item?.legend_key || '') : Number(item?.of_id);
                    const isDraggingThis = draggingId !== null && String(draggingId) === String(itemId);
                    const isDragOverThis = dragOverId !== null && String(dragOverId) === String(itemId) && String(draggingId) !== String(itemId);
                    return (
                      <div
                        key={isLegendTab ? ('legend_' + String(item?.legend_key)) : item.of_id}
                        className="uu-vector uu-vector--row uu-vector--between uu-vector--items-center uu-p-8px uu-border-radius-4px"
                        draggable={saving !== true}
                        onDragStart={(e) => handleDragStartRow(e, itemId)}
                        onDragOver={(e) => handleDragOverRow(e, itemId)}
                        onDrop={(e) => handleDropRow(e, itemId)}
                        onDragEnd={handleDragEndRow}
                        style={{
                          border: isDragOverThis ? '1px solid #3b82f6' : '1px solid #ddd',
                          backgroundColor: isDragOverThis ? '#eff6ff' : '#fff',
                          opacity: isDraggingThis ? 0.6 : 1,
                          width: '40%',
                          maxWidth: '100%',
                          boxSizing: 'border-box',
                          cursor: saving === true ? 'default' : 'grab',
                        }}
                      >
                        <div style={{ flex: 1, minWidth: 0, paddingRight: '8px' }}>
                          <b>#{index + 1}</b> {title}
                        </div>
                        <div className="uu-vector uu-vector--row uu-gaps-m-025rem uu-vector--items-center" style={{ flexShrink: 0 }}>
                          <UniBtn
                            inline
                            circle
                            wide
                            size={20}
                            minWidth={40}
                            i="fa fa-arrow-up"
                            title="Gore"
                            themeCompoColorBlue
                            disabled={index === 0}
                            handleClick={() => moveRow(index, -1)}
                          />
                          <UniBtn
                            inline
                            circle
                            wide
                            size={20}
                            minWidth={40}
                            i="fa fa-arrow-down"
                            title="Dole"
                            themeCompoColorGreen
                            disabled={index === orderedRowsLength - 1}
                            handleClick={() => moveRow(index, 1)}
                          />
                          <UniBtn
                            inline
                            circle
                            wide
                            size={20}
                            minWidth={40}
                            i="fa fa-angle-double-up"
                            title="Na vrh"
                            themeCompoColorIndigo
                            disabled={index === 0}
                            handleClick={() => moveRowToEdge(index, true)}
                          />
                          <UniBtn
                            inline
                            circle
                            wide
                            size={20}
                            minWidth={40}
                            i="fa fa-angle-double-down"
                            title="Na dno"
                            themeCompoColorRed
                            disabled={index === orderedRowsLength - 1}
                            handleClick={() => moveRowToEdge(index, false)}
                          />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

const MarkerAnchorEditorPopup = (props) => {
  const {
    markerImgSrc,
    markerW,
    markerH,
    initialAnchorLeft,
    initialAnchorTop,
    title,
    onCancel,
    onConfirm,
  } = props;

  const [anchorLeft, setAnchorLeft] = useState(Number(initialAnchorLeft) || 0);
  const [anchorTop, setAnchorTop] = useState(Number(initialAnchorTop) || 0);
  const markerWidth = Math.max(1, Number(markerW) || 40);
  const markerHeight = Math.max(1, Number(markerH) || 40);
  const anchorRight = Math.max(0, markerWidth - (Number(anchorLeft) || 0));
  const anchorBottom = Math.max(0, markerHeight - (Number(anchorTop) || 0));

  const handleAnchorChange = (newLeft, newTop) => {
    setAnchorLeft(Number(newLeft) || 0);
    setAnchorTop(Number(newTop) || 0);
  };

  return (
    <div className="ym-anchor-editor-popup yourmap-theme__scope-admin-panel">
      <div className="ym-anchor-editor-popup__topbar">
        <div className="ym-anchor-editor-popup__topbar-title">
          <i className="fa fa-anchor" aria-hidden="true" />
          <span>Podesi sidro markera</span>
        </div>
        <button
          className="ym-anchor-editor-popup__close-btn"
          type="button"
          onClick={onCancel}
          title="Zatvori"
        >
          <i className="fa fa-times" aria-hidden="true" />
        </button>
      </div>

      <div className="ym-anchor-editor-popup__main">
        <div className="ym-anchor-editor-popup__section">
          <div className="ym-anchor-editor-popup__title">
              <i className="fa fa-map-marker" aria-hidden="true" /> {title || 'Marker'}
            </div>
            <p className="ym-anchor-editor-popup__desc">
              Klikni direktno na sliku markera ili unesi koordinate ručno.
            </p>

            {markerImgSrc && (
              <div className="ym-anchor-editor-popup__click-wrap">
                <div className="ym-anchor-editor-popup__sublabel">
                  <i className="fa fa-mouse-pointer" aria-hidden="true" /> Klik na ikoni
                </div>
                <ClickableAnchorPreview
                  markerImgSrc={markerImgSrc}
                  markerW={Number(markerW) || 40}
                  markerH={Number(markerH) || 40}
                  anchorLeft={anchorLeft}
                  anchorTop={anchorTop}
                  onChange={handleAnchorChange}
                />
              </div>
            )}

            <details className="ym-v2-advanced-details ym-v2-advanced-details--anchor" open>
              <summary className="ym-v2-advanced-summary">Ručni unos koordinata sidra</summary>
              <div className="ym-v2-size-row ym-v2-size-row--mt">
                <div className="ym-v2-field-group ym-v2-field-group--compact">
                  <label className="ym-v2-label">anchor_left (px)</label>
                  <input
                    className="ym-v2-input ym-v2-input--number"
                    type="number"
                    value={anchorLeft}
                    onChange={(e) => setAnchorLeft(Number(e.target.value) || 0)}
                  />
                </div>
                <div className="ym-v2-field-group ym-v2-field-group--compact">
                  <label className="ym-v2-label">anchor_top (px)</label>
                  <input
                    className="ym-v2-input ym-v2-input--number"
                    type="number"
                    value={anchorTop}
                    onChange={(e) => setAnchorTop(Number(e.target.value) || 0)}
                  />
                </div>
                <div className="ym-v2-field-group ym-v2-field-group--compact">
                  <label className="ym-v2-label">anchor_right (px)</label>
                  <input
                    className="ym-v2-input ym-v2-input--number"
                    type="number"
                    min="0"
                    value={anchorRight}
                    onChange={(e) => {
                      const nextRight = Math.max(0, Number(e.target.value) || 0);
                      setAnchorLeft(Math.max(0, markerWidth - nextRight));
                    }}
                  />
                </div>
                <div className="ym-v2-field-group ym-v2-field-group--compact">
                  <label className="ym-v2-label">anchor_bottom (px)</label>
                  <input
                    className="ym-v2-input ym-v2-input--number"
                    type="number"
                    min="0"
                    value={anchorBottom}
                    onChange={(e) => {
                      const nextBottom = Math.max(0, Number(e.target.value) || 0);
                      setAnchorTop(Math.max(0, markerHeight - nextBottom));
                    }}
                  />
                </div>
              </div>
              <div className="ym-anchor-editor-popup__desc ym-anchor-editor-popup__desc--formula">
                W: <b>{markerWidth}px</b>, H: <b>{markerHeight}px</b> | Formule: <b>anchor_right = width - anchor_left</b>, <b>anchor_bottom = height - anchor_top</b>
              </div>
            </details>
        </div>
      </div>

      <div className="ym-anchor-editor-popup__footer">
        <button className="ym-v2-btn ym-v2-btn--ghost" type="button" onClick={onCancel}>
          Otkaži
        </button>
        <button
          className="ym-v2-btn ym-v2-btn--save"
          type="button"
          onClick={() => onConfirm(anchorLeft, anchorTop)}
        >
          <i className="fa fa-paper-plane" aria-hidden="true" />
          Sačuvaj sidro
        </button>
      </div>
    </div>
  );
};

const YourmapAdminMarkerBulkEditPage = (props) => {
  const {
    destination_entities_adm,
    ymthing_entities_adm,
    fetchGetAll,
    route_freshness,
    setUniModalPortableContent,
    setUniModalPortableClose,
    setUniModalPortableContent_2,
    setUniModalPortableClose_2,
  } = props.appPack;

  const locationOptions = useMemo(() => {
    const src = Array.isArray(destination_entities_adm) ? destination_entities_adm : [];
    const out = [];

    src
      .filter((item) => item?.destinacija_tip === 'DESTINATION' && item?._master_flag_deleted !== true)
      .forEach((destinationItem) => {
        const destinationId = Number(destinationItem?.of_id);
        if (!Number.isFinite(destinationId)) {
          return;
        }
        const destinationTitle = destinationItem?.destinacija_naslov || ('Destinacija #' + destinationId);
        out.push({
          value: 'destination:' + destinationId,
          label: 'Destinacija: ' + destinationTitle,
          locationType: 'destination',
          destinationId,
          subdestinationId: null,
        });

        const subdestinations = Array.isArray(destinationItem?._subdestinations) ? destinationItem._subdestinations : [];
        subdestinations
          .filter((subItem) => subItem?._master_flag_deleted !== true)
          .forEach((subItem) => {
            const subdestinationId = Number(subItem?.of_id);
            if (!Number.isFinite(subdestinationId)) {
              return;
            }
            const subdestinationTitle = subItem?.destinacija_poddestinacija_naslov || ('Poddestinacija #' + subdestinationId);
            out.push({
              value: 'subdestination:' + subdestinationId,
              label: ' - ' + subdestinationTitle + ' (' + destinationTitle + ')',
              locationType: 'subdestination',
              destinationId,
              subdestinationId,
            });
          });
      });

    return out;
  }, [destination_entities_adm]);

  const [selectedLocationValue, setSelectedLocationValue] = useState('');
  const [selectedMarkerIds, setSelectedMarkerIds] = useState([]);
  const [markerVisibilityMode, setMarkerVisibilityMode] = useState('enabled');
  const [bulkScalePercent, setBulkScalePercent] = useState('0');
  const [bulkAnimation, setBulkAnimation] = useState('keep');
  const [bulkZoomMode, setBulkZoomMode] = useState('keep');
  const [bulkMarkerEnabled, setBulkMarkerEnabled] = useState('keep');
  const [saving, setSaving] = useState(false);
  const [statusMessage, setStatusMessage] = useState('');

  const selectedLocation = useMemo(() => {
    return locationOptions.find((item) => item.value === selectedLocationValue) || null;
  }, [locationOptions, selectedLocationValue]);

  const destinationToSubdestinationIdsMap = useMemo(() => {
    const src = Array.isArray(destination_entities_adm) ? destination_entities_adm : [];
    const out = new Map();
    src
      .filter((item) => item?.destinacija_tip === 'DESTINATION')
      .forEach((destinationItem) => {
        const destinationId = Number(destinationItem?.of_id);
        if (!Number.isFinite(destinationId)) {
          return;
        }
        const subIds = (Array.isArray(destinationItem?._subdestinations) ? destinationItem._subdestinations : [])
          .map((subItem) => Number(subItem?.of_id))
          .filter((subId) => Number.isFinite(subId));
        out.set(destinationId, subIds);
      });
    return out;
  }, [destination_entities_adm]);

  useEffect(() => {
    if (selectedLocationValue !== '') {
      return;
    }
    if (locationOptions.length > 0) {
      setSelectedLocationValue(locationOptions[0].value);
    }
  }, [locationOptions, selectedLocationValue]);

  useEffect(() => {
    setSelectedMarkerIds([]);
  }, [selectedLocationValue, markerVisibilityMode]);

  const markerRows = useMemo(() => {
    const src = Array.isArray(ymthing_entities_adm) ? ymthing_entities_adm : [];
    if (!selectedLocation) {
      return [];
    }

    return src.filter((item) => {
      if (item?._master_flag_deleted === true) {
        return false;
      }

      const parentRealDestinationId = Number(item?._routing_parent_real_destination_id);
      const fallbackDestinationId = Number(item?.parent_destinacija_id);

      if (selectedLocation.locationType === 'destination') {
        const subdestinationIds = destinationToSubdestinationIdsMap.get(Number(selectedLocation.destinationId)) || [];
        const belongsToDestination = (Number.isFinite(parentRealDestinationId) && parentRealDestinationId === selectedLocation.destinationId)
          || fallbackDestinationId === selectedLocation.destinationId
          || subdestinationIds.includes(fallbackDestinationId);
        if (!belongsToDestination) {
          return false;
        }
      } else if (selectedLocation.locationType === 'subdestination') {
        const itemSubdestinationId = Number(item?._routing_parent_subdestination_id_for_map);
        const selectedSubdestinationId = Number(selectedLocation.subdestinationId);
        if (itemSubdestinationId !== selectedSubdestinationId && fallbackDestinationId !== selectedSubdestinationId) {
          return false;
        }
      }

      if (markerVisibilityMode === 'enabled') {
        return item?.smestaj_marker_enabled === true;
      }
      if (markerVisibilityMode === 'disabled') {
        return item?.smestaj_marker_enabled === false;
      }
      return true;
    }).map((item) => ({
      ...item,
      _marker_title: item?.smestaj_naslov || item?.smestaj_podnaslov || ('Entitet #' + item?.of_id),
      _marker_anim_label: item?.smestaj_marker_animacija === 'bounce' ? 'Skok'
        : item?.smestaj_marker_animacija === 'bounce_10' ? 'Blagi skok'
        : item?.smestaj_marker_animacija === 'pulse' ? 'Pulsiranje'
        : item?.smestaj_marker_animacija === 'float' ? 'Lepršanje'
        : item?.smestaj_marker_animacija === 'wiggle' ? 'Njihanje'
        : item?.smestaj_marker_animacija === 'shake_1' ? 'Drmanje 1'
        : item?.smestaj_marker_animacija === 'shake_2' ? 'Drmanje 2'
        : 'Bez animacije',
      _marker_zoom_label: item?.smestaj_marker_zoom_disabled === true ? 'Isključen zoom'
        : item?.smestaj_marker_zoom_follow_enabled === true ? 'Prati zoom mape'
        : item?.smestaj_marker_zoom_step_enabled === true ? 'Stepenasti zoom'
        : 'Podrazumevan zoom',
    }));
  }, [ymthing_entities_adm, selectedLocation, markerVisibilityMode, destinationToSubdestinationIdsMap]);

  useEffect(() => {
    const allowed = new Set(markerRows.map((item) => Number(item?.of_id)).filter((id) => Number.isFinite(id)));
    setSelectedMarkerIds((prev) => prev.filter((id) => allowed.has(Number(id))));
  }, [markerRows]);

  const selectedRows = useMemo(() => {
    const byId = new Map();
    markerRows.forEach((item) => {
      const id = Number(item?.of_id);
      if (Number.isFinite(id)) {
        byId.set(id, item);
      }
    });
    return selectedMarkerIds
      .map((id) => byId.get(Number(id)))
      .filter(Boolean);
  }, [markerRows, selectedMarkerIds]);

  const selectedDestinationTitle = selectedLocation?.label || '';

  const handleSelectionChange = (keys) => {
    const normalized = Array.isArray(keys)
      ? keys.map((key) => Number(key)).filter((key) => Number.isFinite(key))
      : [];
    setSelectedMarkerIds(normalized);
  };

  const handleOpenAnchorEditor = (entity) => {
    const markerImgSrc = _zzyourmap_img_url_full_from_parts(entity?.smestaj_marker_img_filename, entity?.smestaj_marker_img_folder);
    const markerTitle = entity?.smestaj_naslov || entity?.smestaj_podnaslov || ('Entitet #' + entity?.of_id);

    setUniModalPortableContent({
      options: { zIndex: 9999 },
      jsx: (
        <MarkerAnchorEditorPopup
          markerImgSrc={markerImgSrc}
          markerW={entity?.smestaj_marker_img_w}
          markerH={entity?.smestaj_marker_img_h}
          initialAnchorLeft={entity?.smestaj_marker_img_anchor_left}
          initialAnchorTop={entity?.smestaj_marker_img_anchor_top}
          title={markerTitle}
          onCancel={setUniModalPortableClose}
          onConfirm={async (nextAnchorLeft, nextAnchorTop) => {
            try {
              const nextEntity = {
                ...entity,
                smestaj_marker_img_anchor_left: Math.max(0, Number(nextAnchorLeft) || 0),
                smestaj_marker_img_anchor_top: Math.max(0, Number(nextAnchorTop) || 0),
              };

              const preparedEntbox = _ymthing_import_export_prepare_entbox_for_submit(nextEntity, entity);
              if (!preparedEntbox) {
                return;
              }

              const vrTablename = preparedEntbox.vr_tablename || entity?.vr_tablename;
              const ofId = Number(entity?.of_id);
              if (!vrTablename || !Number.isFinite(ofId)) {
                return;
              }

              const dataForJson = { ...preparedEntbox };
              delete dataForJson.vr_tablename;
              const entboxJ = {
                data_json: json_utils.js_to_always_json(dataForJson),
                note: 'single marker anchor edit from admin panel',
              };

              await _zzyourmap_ajax.create_new_rev(entboxJ, vrTablename, ofId);
              fetchGetAll();
              setStatusMessage('Sačuvano sidro za marker: ' + markerTitle);
              setUniModalPortableClose();
            } catch (err) {
              console.error('ERROR save marker anchor', err);
              setStatusMessage('Snimanje sidra nije uspelo.');
            }
          }}
        />
      ),
    });
  };

  const handleOpenMapAndAnchorEditor = (entity) => {
    const markerImgSrc = _zzyourmap_img_url_full_from_parts(entity?.smestaj_marker_img_filename, entity?.smestaj_marker_img_folder);
    const markerTitle = entity?.smestaj_naslov || entity?.smestaj_podnaslov || ('Entitet #' + entity?.of_id);

    const mapOptions = {
      ..._zzyourmap_extract_map_props_1_for_smestaj_position_picker(entity, destination_entities_adm),
      enableClickLatLng: true,
      _cbClickLatLng: () => {},
    };

    const destId = Number(entity?.parent_destinacija_id);
    const contextMarkersArr = (Array.isArray(ymthing_entities_adm) ? ymthing_entities_adm : [])
      .filter((item) => Number(item?.parent_destinacija_id) === destId && item?._master_flag_deleted !== true && item?.smestaj_marker_enabled === true)
      .map((item) => _zzyourmap_extract_smestaj_map_marker_item_props(item))
      .filter(Boolean);

    setUniModalPortableContent_2({
      options: { large: true, zIndex: 9999 },
      jsx: (
        <MapPickerPopup
          options={mapOptions}
          initialLeft={entity?.smestaj_marker_img_left}
          initialBottom={entity?.smestaj_marker_img_bottom}
          initialAnchorLeft={entity?.smestaj_marker_img_anchor_left}
          initialAnchorTop={entity?.smestaj_marker_img_anchor_top}
          initialW={entity?.smestaj_marker_img_w}
          initialH={entity?.smestaj_marker_img_h}
          markerImgSrc={markerImgSrc}
          contextMarkersArr={contextMarkersArr}
          onConfirm={async (left, bottom, aLeft, aTop, w, h) => {
            try {
              const nextEntity = {
                ...entity,
                smestaj_marker_img_left: Math.max(0, Number(left) || 0),
                smestaj_marker_img_bottom: Math.max(0, Number(bottom) || 0),
                smestaj_marker_img_anchor_left: Math.max(0, Number(aLeft) || 0),
                smestaj_marker_img_anchor_top: Math.max(0, Number(aTop) || 0),
                smestaj_marker_img_w: Math.max(0, Number(w) || 0),
                smestaj_marker_img_h: Math.max(0, Number(h) || 0),
              };

              const preparedEntbox = _ymthing_import_export_prepare_entbox_for_submit(nextEntity, entity);
              if (!preparedEntbox) {
                return;
              }

              const vrTablename = preparedEntbox.vr_tablename || entity?.vr_tablename;
              const ofId = Number(entity?.of_id);
              if (!vrTablename || !Number.isFinite(ofId)) {
                return;
              }

              const dataForJson = { ...preparedEntbox };
              delete dataForJson.vr_tablename;
              const entboxJ = {
                data_json: json_utils.js_to_always_json(dataForJson),
                note: 'single marker map+anchor edit from admin panel',
              };

              await _zzyourmap_ajax.create_new_rev(entboxJ, vrTablename, ofId);
              fetchGetAll();
              setStatusMessage('Sačuvana pozicija i sidro za marker: ' + markerTitle);
              setUniModalPortableClose_2();
            } catch (err) {
              console.error('ERROR save marker map+anchor', err);
              setStatusMessage('Snimanje pozicije i sidra nije uspelo.');
            }
          }}
          onCancel={setUniModalPortableClose_2}
        />
      ),
    });
  };

  const handleApplyBulk = async () => {
    if (saving === true || selectedRows.length === 0) {
      return;
    }

    const scalePercent = Number(bulkScalePercent);
    const scaleFactor = Number.isFinite(scalePercent) ? (1 + (scalePercent / 100)) : 1;

    setSaving(true);
    setStatusMessage('');

    try {
      let savedCount = 0;

      for (let i = 0; i < selectedRows.length; i += 1) {
        const entity = selectedRows[i];
        const nextEntity = { ...entity };

        if (Number.isFinite(scalePercent) && scalePercent !== 0) {
          ['smestaj_marker_img_w', 'smestaj_marker_img_h', 'smestaj_marker_img_left', 'smestaj_marker_img_bottom', 'smestaj_marker_img_anchor_left', 'smestaj_marker_img_anchor_top'].forEach((key) => {
            const currentValue = Number(nextEntity[key]);
            if (Number.isFinite(currentValue)) {
              nextEntity[key] = Math.max(0, Math.round(currentValue * scaleFactor));
            }
          });
        }

        if (bulkAnimation !== 'keep') {
          nextEntity.smestaj_marker_animacija = bulkAnimation === 'clear' ? '' : bulkAnimation;
        }

        if (bulkZoomMode !== 'keep') {
          if (bulkZoomMode === 'disable') {
            nextEntity.smestaj_marker_zoom_disabled = true;
            nextEntity.smestaj_marker_zoom_follow_enabled = false;
            nextEntity.smestaj_marker_zoom_step_enabled = false;
          } else if (bulkZoomMode === 'follow') {
            nextEntity.smestaj_marker_zoom_disabled = false;
            nextEntity.smestaj_marker_zoom_follow_enabled = true;
            nextEntity.smestaj_marker_zoom_step_enabled = false;
          } else if (bulkZoomMode === 'step') {
            nextEntity.smestaj_marker_zoom_disabled = false;
            nextEntity.smestaj_marker_zoom_follow_enabled = false;
            nextEntity.smestaj_marker_zoom_step_enabled = true;
          }
        }

        if (bulkMarkerEnabled === 'enable') {
          nextEntity.smestaj_marker_enabled = true;
        } else if (bulkMarkerEnabled === 'disable') {
          nextEntity.smestaj_marker_enabled = false;
        }

        const preparedEntbox = _ymthing_import_export_prepare_entbox_for_submit(nextEntity, entity);
        if (!preparedEntbox) {
          continue;
        }

        const vrTablename = preparedEntbox.vr_tablename || entity?.vr_tablename;
        const ofId = Number(entity?.of_id);
        if (!vrTablename || !Number.isFinite(ofId)) {
          continue;
        }

        const dataForJson = { ...preparedEntbox };
        delete dataForJson.vr_tablename;
        const entboxJ = {
          data_json: json_utils.js_to_always_json(dataForJson),
          note: 'bulk marker edit from admin panel',
        };

        await _zzyourmap_ajax.create_new_rev(entboxJ, vrTablename, ofId);
        savedCount += 1;
      }

      if (savedCount > 0) {
        fetchGetAll();
        setSelectedMarkerIds([]);
      }

      setStatusMessage(savedCount > 0 ? ('Sačuvano ' + savedCount + ' izmena.') : 'Nema promena za čuvanje.');
    } catch (err) {
      console.error('ERROR bulk marker edit', err);
      setStatusMessage('Bulk snimanje nije uspelo.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="yourmap__admin-panel">
      <section>
        <div className="inner-admin-panel">
          <div className="zzsurvey__card">
            <h3>Izmene markera</h3>
            <p>
              Izaberi lokaciju, čekiraj markere u tabeli i primeni bulk izmene bez otvaranja svakog markera posebno.
            </p>

            <div className="uu-vector uu-vector--row uu-vector--wrap uu-gaps-m-1rem">
              <div>
                <label>Lokacija</label>
                <select
                  value={selectedLocationValue}
                  onChange={(e) => setSelectedLocationValue(e.target.value)}
                >
                  {locationOptions.length === 0 && <option value="">(nema lokacija)</option>}
                  {locationOptions.map((option) => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </select>
              </div>
              <div>
                <label>Prikaz</label>
                <select
                  value={markerVisibilityMode}
                  onChange={(e) => setMarkerVisibilityMode(e.target.value)}
                >
                  <option value="enabled">Aktivni</option>
                  <option value="all">Svi</option>
                  <option value="disabled">Isključeni</option>
                </select>
              </div>
            </div>

            <div className="uu-gap-standalone-1rem"></div>

            <div className="uu-vector uu-vector--row uu-vector--wrap uu-gaps-m-1rem">
              <div>
                <label>Promena veličine u %</label>
                <input
                  type="number"
                  min="-90"
                  max="300"
                  step="1"
                  value={bulkScalePercent}
                  onChange={(e) => setBulkScalePercent(e.target.value)}
                  style={{ width: '120px' }}
                />
              </div>
              <div>
                <label>Animacija</label>
                <select value={bulkAnimation} onChange={(e) => setBulkAnimation(e.target.value)}>
                  {_YM_MARKER_BULK_ANIMATION_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </select>
              </div>
              <div>
                <label>Zoom markera</label>
                <select value={bulkZoomMode} onChange={(e) => setBulkZoomMode(e.target.value)}>
                  {_YM_MARKER_BULK_ZOOM_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </select>
              </div>
              <div>
                <label>Marker enabled</label>
                <select value={bulkMarkerEnabled} onChange={(e) => setBulkMarkerEnabled(e.target.value)}>
                  {_YM_MARKER_BULK_ENABLED_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>{option.label}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="uu-gap-standalone-1rem"></div>

            <div className="uu-vector uu-vector--row uu-gaps-m-05rem uu-vector--wrap">
              <UniBtn
                inline
                circle
                wide
                i="fa fa-magic"
                title="Primeni bulk izmene na čekirane markere"
                disabled={saving === true || selectedRows.length === 0}
                handleClick={handleApplyBulk}
              />
              <UniBtn
                inline
                outline
                circle
                wide
                i="fa fa-undo"
                title="Očisti selekciju"
                disabled={saving === true || selectedMarkerIds.length === 0}
                handleClick={() => setSelectedMarkerIds([])}
              />
            </div>

            <div className="uu-gap-standalone-05rem"></div>

            <p>
              Lokacija: <b>{selectedDestinationTitle || '-'}</b> | Markera: <b>{markerRows.length}</b> | Obeleženo: <b>{selectedRows.length}</b>
            </p>

            {statusMessage && <p><b>{statusMessage}</b></p>}

            <ViewGeneratorSimpleV4
              key={selectedLocationValue + '_' + markerVisibilityMode}
              route_freshness={route_freshness}
              rapidoziViewDefinition={{
                cbSubmitEntityCreate: () => {},
              }}
              viewDefinition={{
                view_key: 'TABLE_YMTHING_MARKER_BULK_EDIT',
                table_additional_column_keys: [
                  { key: 'of_id', title: 'ID', minWidth: 72 },
                  { key: '_marker_title', title: 'Naziv', minWidth: 220 },
                  { key: 'vr_tablename', title: 'Tabela', minWidth: 140 },
                  { key: 'smestaj_marker_animacija', title: 'Animacija', minWidth: 120 },
                  { key: '_marker_anim_label', title: 'Animacija label', minWidth: 140 },
                  { key: '_marker_zoom_label', title: 'Zoom', minWidth: 150 },
                  { key: 'smestaj_marker_img_w', title: 'W', minWidth: 70 },
                  { key: 'smestaj_marker_img_h', title: 'H', minWidth: 70 },
                  { key: 'smestaj_marker_img_anchor_left', title: 'Anchor L', minWidth: 86 },
                  { key: 'smestaj_marker_img_anchor_top', title: 'Anchor T', minWidth: 86 },
                  { key: 'smestaj_marker_zoom_disabled', title: 'Zoom off', minWidth: 92 },
                  { key: 'smestaj_marker_zoom_follow_enabled', title: 'Zoom follow', minWidth: 110 },
                  { key: 'smestaj_marker_zoom_step_enabled', title: 'Zoom step', minWidth: 92 },
                ],
                cbEntityKeyExtractor: (entity) => entity.of_id,
                cbRefresh: () => { fetchGetAll(); },
                cbEntityActionsJsx: (entity) => {
                  return (
                    <div className="uu-vector uu-vector--row uu-gaps-m-025rem uu-vector--wrap">
                      <UniBtn
                        inline
                        circle
                        wide
                        size={20}
                        minWidth={40}
                        i="fa fa-magic"
                        title=""
                        handleClick={() => handleOpenMapAndAnchorEditor(entity)}
                      />
                      <UniBtn
                        inline
                        circle
                        wide
                        size={20}
                        minWidth={40}
                        i="fa fa-anchor"
                        title=""
                        handleClick={() => handleOpenAnchorEditor(entity)}
                      />
                    </div>
                  );
                },
                options: {
                  entity_col_disabled: true,
                  showSelectable: true,
                },
              }}
              viewArr={markerRows}
              fetching={false}
              cbOnSelectionChange={handleSelectionChange}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

const YourmapAdminImportExportPage = (props) => {
  const {
    destination_entities_adm,
    ymthing_entities_adm,
    fetchGetAll,
  } = props.appPack;

  const fileInputRef = useRef(null);
  const backupFileInputRef = useRef(null);
  const [importing, setImporting] = useState(false);
  const [importSummary, setImportSummary] = useState(null);
  const [importError, setImportError] = useState('');
  const [importPreview, setImportPreview] = useState(null);
  const [pendingImportUpdates, setPendingImportUpdates] = useState([]);
  const [backupImporting, setBackupImporting] = useState(false);
  const [backupImportError, setBackupImportError] = useState('');
  const [backupImportPreview, setBackupImportPreview] = useState(null);
  const [pendingBackupImportUpdates, setPendingBackupImportUpdates] = useState([]);
  const [backupImportSummary, setBackupImportSummary] = useState(null);

  const destinationMap = useMemo(() => {
    const out = new Map();
    const src = Array.isArray(destination_entities_adm) ? destination_entities_adm : [];
    src.forEach((item) => {
      const destinationId = Number(item?.of_id);
      if (!Number.isFinite(destinationId)) {
        return;
      }
      out.set(destinationId, {
        destinationId,
        destinationTitle: item?.destinacija_naslov || ('Destinacija #' + destinationId),
        mainSubdestinationTitle: item?.destinacija_poddestinacija_naslov || '',
      });
    });
    return out;
  }, [destination_entities_adm]);

  const activeYmthingEntities = useMemo(() => {
    const src = Array.isArray(ymthing_entities_adm) ? ymthing_entities_adm : [];
    return src.filter((item) => item?._master_flag_deleted !== true);
  }, [ymthing_entities_adm]);

  const groupedEntities = useMemo(() => {
    const groups = new Map();

    activeYmthingEntities.forEach((item) => {
      const routingDestinationId = Number(item?._routing_parent_real_destination_id);
      const fallbackDestinationId = Number(item?.parent_destinacija_id);
      const destinationId = Number.isFinite(routingDestinationId) ? routingDestinationId : fallbackDestinationId;
      const destinationInfo = destinationMap.get(destinationId) || {
        destinationId,
        destinationTitle: Number.isFinite(destinationId) ? ('Destinacija #' + destinationId) : 'Bez destinacije',
      };
      const groupKey = Number.isFinite(destinationId) ? destinationId : -1;
      if (!groups.has(groupKey)) {
        groups.set(groupKey, {
          destinationId: destinationInfo.destinationId,
          destinationTitle: destinationInfo.destinationTitle,
          items: [],
        });
      }
      groups.get(groupKey).items.push(item);
    });

    return Array.from(groups.values()).sort((a, b) => a.destinationTitle.localeCompare(b.destinationTitle, 'sr', { sensitivity: 'base' }));
  }, [activeYmthingEntities, destinationMap]);

  const getDestinationInfo = (item) => {
    const routingDestinationId = Number(item?._routing_parent_real_destination_id);
    const fallbackDestinationId = Number(item?.parent_destinacija_id);
    const destinationId = Number.isFinite(routingDestinationId) ? routingDestinationId : fallbackDestinationId;
    return destinationMap.get(destinationId) || {
      destinationId,
      destinationTitle: Number.isFinite(destinationId) ? ('Destinacija #' + destinationId) : 'Bez destinacije',
      mainSubdestinationTitle: '',
    };
  };

  const getSubdestinationInfo = (item) => {
    const subdestinationId = Number(item?._routing_parent_subdestination_id_for_map);
    if (!Number.isFinite(subdestinationId)) {
      return {
        subdestinationId: null,
        subdestinationTitle: '',
      };
    }

    const destinationInfo = getDestinationInfo(item);
    const destinationEntity = Array.isArray(destination_entities_adm)
      ? destination_entities_adm.find((destinationItem) => Number(destinationItem?.of_id) === Number(destinationInfo.destinationId))
      : null;
    const subdestination = Array.isArray(destinationEntity?._subdestinations)
      ? destinationEntity._subdestinations.find((subdestinationItem) => Number(subdestinationItem?.of_id) === subdestinationId)
      : null;

    return {
      subdestinationId,
      subdestinationTitle: subdestination?.destinacija_poddestinacija_naslov || '',
    };
  };

  const getEntityDisplayTitle = (item) => {
    if (typeof item?.smestaj_naslov === 'string' && item.smestaj_naslov.trim() !== '') {
      return item.smestaj_naslov.trim();
    }
    if (typeof item?.smestaj_podnaslov === 'string' && item.smestaj_podnaslov.trim() !== '') {
      return item.smestaj_podnaslov.trim();
    }
    return 'Entitet #' + item?.of_id;
  };

  const importPreviewGroups = useMemo(() => {
    if (!importPreview || !Array.isArray(importPreview.changes)) {
      return [];
    }
    const groups = new Map();
    importPreview.changes.forEach((change) => {
      const groupKey = String(change.destinationId || 'no-destination');
      if (!groups.has(groupKey)) {
        groups.set(groupKey, {
          destinationId: change.destinationId,
          destinationTitle: change.destinationTitle,
          changes: [],
        });
      }
      groups.get(groupKey).changes.push(change);
    });
    return Array.from(groups.values()).sort((a, b) => a.destinationTitle.localeCompare(b.destinationTitle, 'sr', { sensitivity: 'base' }));
  }, [importPreview]);

  const handleExport = () => {
    const workbook = XLSX.utils.book_new();

    const instructionsRows = [
      ['Uputstvo', ''],
      ['1', 'Menjaj samo tekstualna polja u sheet-ovima po destinacijama.'],
      ['2', 'Ne menjaj kolone of_id, destination_id, destination_title, subdestination_id, subdestination_title i tab.'],
      ['3', 'Posle izmene sačuvaj fajl kao .xlsx i importuj ga nazad na ovoj stranici.'],
      ['4', 'Import radi samo za postojeće ymthing entitete, bez backend izmena.'],
      ['5', 'Kolona subdestination_title je uvek popunjena: ako nema posebne poddestinacije, upisuje se destinacija_poddestinacija_naslov (glavna poddestinacija), a ako i to fali onda naziv glavne destinacije.'],
    ];
    const instructionsSheet = XLSX.utils.aoa_to_sheet(instructionsRows);
    instructionsSheet['!cols'] = [{ wch: 12 }, { wch: 90 }];
    XLSX.utils.book_append_sheet(workbook, instructionsSheet, 'README');

    groupedEntities.forEach((group) => {
      const rows = [
        _YMTHING_IMPORT_EXPORT_COLUMNS.map((column) => column.title),
      ];

      const sortedItems = [...group.items].sort((a, b) => {
        const orderA = Number(a?.smestaj_order_index);
        const orderB = Number(b?.smestaj_order_index);
        const safeA = Number.isFinite(orderA) ? orderA : Number.MAX_SAFE_INTEGER;
        const safeB = Number.isFinite(orderB) ? orderB : Number.MAX_SAFE_INTEGER;
        if (safeA !== safeB) {
          return safeA - safeB;
        }
        return Number(a?.of_id || 0) - Number(b?.of_id || 0);
      });

      sortedItems.forEach((item) => {
        const routingDestinationId = Number(item?._routing_parent_real_destination_id);
        const fallbackDestinationId = Number(item?.parent_destinacija_id);
        const destinationId = Number.isFinite(routingDestinationId) ? routingDestinationId : fallbackDestinationId;
        const destinationInfo = destinationMap.get(destinationId) || {
          destinationId,
          destinationTitle: Number.isFinite(destinationId) ? ('Destinacija #' + destinationId) : 'Bez destinacije',
        };
        const subdestinationInfo = getSubdestinationInfo(item);
        rows.push(_YMTHING_IMPORT_EXPORT_COLUMNS.map((column) => {
          const exportSubdestinationTitle =
            subdestinationInfo.subdestinationTitle ||
            destinationInfo.mainSubdestinationTitle ||
            destinationInfo.destinationTitle ||
            '';
          if (column.key === 'destination_id') {
            return destinationInfo.destinationId;
          }
          if (column.key === 'destination_title') {
            return destinationInfo.destinationTitle;
          }
          if (column.key === 'subdestination_id') {
            return subdestinationInfo.subdestinationId || '';
          }
          if (column.key === 'subdestination_title') {
            return exportSubdestinationTitle;
          }
          if (column.key === 'row_digest') {
            return _ymthing_import_export_make_row_digest(item);
          }
          return item?.[column.key] ?? '';
        }));
      });

      const sheet = XLSX.utils.aoa_to_sheet(rows);
      sheet['!cols'] = _YMTHING_IMPORT_EXPORT_COLUMNS.map((column) => ({ wch: column.wch }));
      if (rows.length > 1) {
        const lastColumnIndex = _YMTHING_IMPORT_EXPORT_COLUMNS.length - 1;
        sheet['!autofilter'] = {
          ref: XLSX.utils.encode_range({ s: { c: 0, r: 0 }, e: { c: lastColumnIndex, r: 0 } }),
        };
      }
      XLSX.utils.book_append_sheet(workbook, sheet, _ymthing_import_export_make_sheet_name(group.destinationTitle, group.destinationId));
    });

    XLSX.writeFile(workbook, 'yourmap-entiteti-import-export.xlsx');
  };

  const handleImportClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleImportFile = async (e) => {
    const file = e?.target?.files?.[0];
    if (!file) {
      return;
    }

    setImportError('');
    setImportSummary(null);
    setImportPreview(null);
    setPendingImportUpdates([]);
    setImporting(true);

    try {
      const buffer = await file.arrayBuffer();
      const workbook = XLSX.read(buffer, { type: 'array' });
      const entityMap = new Map();
      activeYmthingEntities.forEach((item) => {
        const entityId = Number(item?.of_id);
        if (Number.isFinite(entityId)) {
          entityMap.set(entityId, item);
        }
      });

      const pendingById = new Map();
      const warnings = [];
      let parsedRows = 0;

      workbook.SheetNames.forEach((sheetName) => {
        if (sheetName === 'README') {
          return;
        }
        const worksheet = workbook.Sheets[sheetName];
        const rows = XLSX.utils.sheet_to_json(worksheet, { defval: '' });
        rows.forEach((row, rowIndex) => {
          parsedRows += 1;
          const entityId = Number(row?.of_id);
          if (!Number.isFinite(entityId)) {
            warnings.push(sheetName + ' red ' + (rowIndex + 2) + ': nedostaje validan of_id.');
            return;
          }
          const entity = entityMap.get(entityId);
          if (!entity) {
            warnings.push(sheetName + ' red ' + (rowIndex + 2) + ': entitet #' + entityId + ' ne postoji u trenutnim podacima.');
            return;
          }

          const digestCell = _ymthing_import_export_read_value_from_row(row, 'row_digest');
          const fileDigest = _ymthing_import_export_normalize_text(digestCell.value);
          const currentDigest = _ymthing_import_export_make_row_digest(entity);
          const digestMatched = fileDigest !== '' && fileDigest === currentDigest;

          const baseNext = pendingById.get(entityId)?.nextEntity || { ...entity };
          const changedKeys = new Set(pendingById.get(entityId)?.changedKeys || []);

          _ymthing_import_export_editable_keys.forEach((key) => {
            const importedCell = _ymthing_import_export_read_value_from_row(row, key);
            if (importedCell.found !== true) {
              return;
            }
            const importedValueRaw = _ymthing_import_export_normalize_text(importedCell.value);
            const importedValueComparable = _ymthing_import_export_normalize_for_compare(importedValueRaw, key);
            const currentValueComparable = _ymthing_import_export_normalize_for_compare(baseNext[key], key);
            if (importedValueComparable !== currentValueComparable) {
              baseNext[key] = importedValueRaw;
              changedKeys.add(key);
            }
          });

          if (changedKeys.size === 0 && digestCell.found === true && digestMatched !== true) {
            warnings.push(sheetName + ' red ' + (rowIndex + 2) + ': row_digest se razlikuje, ali nema izmenjenih editable kolona.');
          }

          if (changedKeys.size > 0) {
            const destinationInfo = getDestinationInfo(entity);
            const subdestinationInfo = getSubdestinationInfo(entity);
            pendingById.set(entityId, {
              entity,
              nextEntity: baseNext,
              changedKeys: Array.from(changedKeys),
              destinationId: destinationInfo.destinationId,
              destinationTitle: destinationInfo.destinationTitle,
              subdestinationId: subdestinationInfo.subdestinationId,
              subdestinationTitle: subdestinationInfo.subdestinationTitle,
            });
          }
        });
      });

      const updates = Array.from(pendingById.values());

      const detailedChanges = updates.map((update) => {
        const fieldDiffs = update.changedKeys.map((key) => ({
          key,
          title: _ymthing_import_export_column_title_map[key] || key,
          before: _ymthing_import_export_normalize_text(update.entity?.[key]),
          after: _ymthing_import_export_normalize_text(update.nextEntity?.[key]),
        }));
        return {
          ...update,
          title: getEntityDisplayTitle(update.entity),
          fieldDiffs,
          changedFieldsDisplay: fieldDiffs.map((fieldDiff) => fieldDiff.title).join(', '),
        };
      });

      setPendingImportUpdates(updates);
      setImportPreview({
        parsedRows,
        changedEntities: updates.length,
        warnings,
        importedFileName: file.name,
        changes: detailedChanges,
      });
    } catch (err) {
      console.error('ERROR import excel', err);
      setImportError('Import nije uspeo. Proveri da li je fajl validan .xlsx export iz ovog panela.');
    } finally {
      setImporting(false);
      if (e?.target) {
        e.target.value = '';
      }
    }
  };

  const handleApplyImport = async () => {
    if (pendingImportUpdates.length === 0 || importing === true) {
      return;
    }

    setImporting(true);
    setImportError('');

    try {
      const warnings = Array.isArray(importPreview?.warnings) ? [...importPreview.warnings] : [];
      let savedEntities = 0;

      for (let i = 0; i < pendingImportUpdates.length; i += 1) {
        const { entity, nextEntity } = pendingImportUpdates[i];
        const prepared_entbox = _ymthing_import_export_prepare_entbox_for_submit(nextEntity, entity);
        const vr_tablename = prepared_entbox.vr_tablename || entity?.vr_tablename;
        const of_id = Number(entity?.of_id);
        if (!vr_tablename || !Number.isFinite(of_id)) {
          warnings.push('Preskočen entitet #' + (entity?.of_id || '?') + ' zbog nedostajućih identifikacionih podataka.');
          continue;
        }
        const data_for_json = { ...prepared_entbox };
        delete data_for_json.vr_tablename;
        const data_json = json_utils.js_to_always_json(data_for_json);
        const entbox_j = {
          data_json,
          note: 'import excel text fields',
        };
        await _zzyourmap_ajax.create_new_rev(entbox_j, vr_tablename, of_id);
        savedEntities += 1;
      }

      if (savedEntities > 0) {
        fetchGetAll();
      }

      setImportSummary({
        parsedRows: importPreview?.parsedRows || 0,
        changedEntities: pendingImportUpdates.length,
        savedEntities,
        warnings,
        importedFileName: importPreview?.importedFileName || '',
      });
      setImportPreview(null);
      setPendingImportUpdates([]);
    } catch (err) {
      console.error('ERROR apply import excel', err);
      setImportError('Snimanje importovanih izmena nije uspelo.');
    } finally {
      setImporting(false);
    }
  };

  const handleBackupExport = () => {
    const workbook = XLSX.utils.book_new();

    const instructionsRows = [
      ['Uputstvo FULL BACKUP', ''],
      ['1', 'Ovo je backup svih aktivnih entiteta sa kompletnim data_json payload-om.'],
      ['2', 'Za import svega ne menjaj kolone of_id i vr_tablename.'],
      ['3', 'Kolona backup_data_json mora ostati validan JSON string.'],
      ['4', 'Import full backup pravi nove revizije za postojece entitete, bez backend izmena.'],
    ];
    const instructionsSheet = XLSX.utils.aoa_to_sheet(instructionsRows);
    instructionsSheet['!cols'] = [{ wch: 20 }, { wch: 120 }];
    XLSX.utils.book_append_sheet(workbook, instructionsSheet, 'README');

    const rows = [
      _YMTHING_FULL_BACKUP_COLUMNS.map((column) => column.title),
    ];

    const sortedItems = [...activeYmthingEntities].sort((a, b) => {
      const destinationA = Number(a?._routing_parent_real_destination_id || a?.parent_destinacija_id || 0);
      const destinationB = Number(b?._routing_parent_real_destination_id || b?.parent_destinacija_id || 0);
      if (destinationA !== destinationB) {
        return destinationA - destinationB;
      }
      return Number(a?.of_id || 0) - Number(b?.of_id || 0);
    });

    sortedItems.forEach((item) => {
      const destinationInfo = getDestinationInfo(item);
      const subdestinationInfo = getSubdestinationInfo(item);
      const exportSubdestinationTitle =
        subdestinationInfo.subdestinationTitle ||
        destinationInfo.mainSubdestinationTitle ||
        destinationInfo.destinationTitle ||
        '';
      const backupDataJson = _ymthing_import_export_make_full_backup_data_json(item);

      rows.push(_YMTHING_FULL_BACKUP_COLUMNS.map((column) => {
        if (column.key === 'of_id') {
          return item?.of_id ?? '';
        }
        if (column.key === 'vr_tablename') {
          return item?.vr_tablename ?? '';
        }
        if (column.key === 'destination_id') {
          return destinationInfo.destinationId;
        }
        if (column.key === 'destination_title') {
          return destinationInfo.destinationTitle;
        }
        if (column.key === 'subdestination_id') {
          return subdestinationInfo.subdestinationId || '';
        }
        if (column.key === 'subdestination_title') {
          return exportSubdestinationTitle;
        }
        if (column.key === 'tab') {
          return item?._routing_tab ?? '';
        }
        if (column.key === 'backup_data_json') {
          return backupDataJson;
        }
        return '';
      }));
    });

    const sheet = XLSX.utils.aoa_to_sheet(rows);
    sheet['!cols'] = _YMTHING_FULL_BACKUP_COLUMNS.map((column) => ({ wch: column.wch }));
    if (rows.length > 1) {
      const lastColumnIndex = _YMTHING_FULL_BACKUP_COLUMNS.length - 1;
      sheet['!autofilter'] = {
        ref: XLSX.utils.encode_range({ s: { c: 0, r: 0 }, e: { c: lastColumnIndex, r: 0 } }),
      };
    }
    XLSX.utils.book_append_sheet(workbook, sheet, 'ALL_BACKUP');

    XLSX.writeFile(workbook, 'yourmap-entiteti-full-backup.xlsx');
  };

  const handleBackupImportClick = () => {
    if (backupFileInputRef.current) {
      backupFileInputRef.current.click();
    }
  };

  const handleBackupImportFile = async (e) => {
    const file = e?.target?.files?.[0];
    if (!file) {
      return;
    }

    setBackupImporting(true);
    setBackupImportError('');
    setBackupImportPreview(null);
    setPendingBackupImportUpdates([]);
    setBackupImportSummary(null);

    try {
      const buffer = await file.arrayBuffer();
      const workbook = XLSX.read(buffer, { type: 'array' });
      const entityMap = new Map();
      activeYmthingEntities.forEach((item) => {
        const entityId = Number(item?.of_id);
        if (Number.isFinite(entityId)) {
          entityMap.set(entityId, item);
        }
      });

      const pendingById = new Map();
      const warnings = [];
      let parsedRows = 0;

      workbook.SheetNames.forEach((sheetName) => {
        if (sheetName === 'README') {
          return;
        }
        const worksheet = workbook.Sheets[sheetName];
        const rows = XLSX.utils.sheet_to_json(worksheet, { defval: '' });
        rows.forEach((row, rowIndex) => {
          parsedRows += 1;
          const entityId = Number(row?.of_id);
          if (!Number.isFinite(entityId)) {
            warnings.push(sheetName + ' red ' + (rowIndex + 2) + ': nedostaje validan of_id.');
            return;
          }

          const entity = entityMap.get(entityId);
          if (!entity) {
            warnings.push(sheetName + ' red ' + (rowIndex + 2) + ': entitet #' + entityId + ' ne postoji u trenutnim podacima.');
            return;
          }

          const backupJsonRaw = _ymthing_import_export_normalize_text(row?.backup_data_json).trim();
          const backupDecoded = json_utils.decode_if_json(backupJsonRaw);
          if (backupJsonRaw === '' || typeof backupDecoded === 'undefined') {
            warnings.push(sheetName + ' red ' + (rowIndex + 2) + ': backup_data_json nije validan JSON.');
            return;
          }

          const vrTablenameFromFile = _ymthing_import_export_normalize_text(row?.vr_tablename).trim();
          const vr_tablename = vrTablenameFromFile !== '' ? vrTablenameFromFile : (entity?.vr_tablename || '');
          if (vr_tablename === '') {
            warnings.push(sheetName + ' red ' + (rowIndex + 2) + ': nedostaje vr_tablename.');
            return;
          }

          const currentPrepared = _ymthing_import_export_prepare_entbox_for_submit(entity, entity);
          const currentDataForJson = { ...currentPrepared };
          delete currentDataForJson.vr_tablename;
          const currentDataJson = json_utils.js_to_always_json(currentDataForJson);
          const nextDataJson = json_utils.js_to_always_json(backupDecoded);

          if (currentDataJson === nextDataJson && vr_tablename === entity?.vr_tablename) {
            return;
          }

          const destinationInfo = getDestinationInfo(entity);
          pendingById.set(entityId, {
            of_id: entityId,
            entity,
            title: getEntityDisplayTitle(entity),
            destinationTitle: destinationInfo.destinationTitle,
            vr_tablename,
            data_json: nextDataJson,
          });
        });
      });

      const updates = Array.from(pendingById.values());
      setPendingBackupImportUpdates(updates);
      setBackupImportPreview({
        importedFileName: file.name,
        parsedRows,
        changedEntities: updates.length,
        warnings,
        changes: updates,
      });
    } catch (err) {
      console.error('ERROR import full backup excel', err);
      setBackupImportError('Import full backup nije uspeo. Proveri da li je fajl validan .xlsx backup export.');
    } finally {
      setBackupImporting(false);
      if (e?.target) {
        e.target.value = '';
      }
    }
  };

  const handleApplyBackupImport = async () => {
    if (pendingBackupImportUpdates.length === 0 || backupImporting === true) {
      return;
    }

    setBackupImporting(true);
    setBackupImportError('');

    try {
      const warnings = Array.isArray(backupImportPreview?.warnings) ? [...backupImportPreview.warnings] : [];
      let savedEntities = 0;

      for (let i = 0; i < pendingBackupImportUpdates.length; i += 1) {
        const update = pendingBackupImportUpdates[i];
        if (!update?.vr_tablename || !Number.isFinite(Number(update?.of_id))) {
          warnings.push('Preskočen entitet #' + (update?.of_id || '?') + ' zbog nedostajućih identifikacionih podataka.');
          continue;
        }

        const entbox_j = {
          data_json: update.data_json,
          note: 'import excel full backup',
        };
        await _zzyourmap_ajax.create_new_rev(entbox_j, update.vr_tablename, Number(update.of_id));
        savedEntities += 1;
      }

      if (savedEntities > 0) {
        fetchGetAll();
      }

      setBackupImportSummary({
        importedFileName: backupImportPreview?.importedFileName || '',
        parsedRows: backupImportPreview?.parsedRows || 0,
        changedEntities: pendingBackupImportUpdates.length,
        savedEntities,
        warnings,
      });
      setBackupImportPreview(null);
      setPendingBackupImportUpdates([]);
    } catch (err) {
      console.error('ERROR apply full backup import excel', err);
      setBackupImportError('Snimanje full backup import izmena nije uspelo.');
    } finally {
      setBackupImporting(false);
    }
  };

  return (
    <div className="yourmap__admin-panel">
      <section>
        <div className="inner-admin-panel">
          <div className="zzsurvey__card">
            <h3>Import / Export entiteta</h3>
            <p>Export pravi Excel fajl sa svim postojećim <b>djuture</b> entitetima grupisanim po destinacijama. U Excel-u možeš da menjaš tekstualna polja, a zatim isti fajl importuješ nazad bez backend izmena.</p>

            <div className="uu-vector uu-vector--row uu-vector--wrap uu-gaps-m-05rem">
              <UniBtn
                inline
                wide
                circle
                i="fa fa-download"
                title="Download Excel"
                disabled={groupedEntities.length === 0 || importing}
                handleClick={handleExport}
              />
              <UniBtn
                inline
                wide
                circle
                outline
                i="fa fa-upload"
                title={importing ? 'Import u toku...' : 'Import Excel'}
                disabled={importing}
                handleClick={handleImportClick}
              />
              <input
                ref={fileInputRef}
                type="file"
                accept=".xlsx,.xls"
                style={{ display: 'none' }}
                onChange={handleImportFile}
              />
            </div>

            <div className="uu-gap-standalone-1rem"></div>

            <Komentar>
              <p>Editable kolone u importu: <b>{_ymthing_import_export_editable_keys.join(', ')}</b>.</p>
              <p>Ne menjaj kolone <b>of_id</b>, <b>destination_id</b>, <b>destination_title</b>, <b>subdestination_id</b>, <b>subdestination_title</b> i <b>tab</b> jer služe za mapiranje postojećih entiteta.</p>
              <p>Kolona <b>subdestination_title</b> je u exportu uvek popunjena: ako nema posebne poddestinacije, upisuje se <b>destinacija_poddestinacija_naslov</b> (glavna poddestinacija), a ako i to fali onda naziv glavne destinacije.</p>
              <p>Import radi samo za postojeće entitete. Ne pravi nove i ne briše postojeće.</p>
            </Komentar>

            <div className="uu-gap-standalone-1rem"></div>

            <p>Destinacija sheet-ova za export: <b>{groupedEntities.length}</b> | Ukupno aktivnih entiteta: <b>{activeYmthingEntities.length}</b></p>

            {importError !== '' && (
              <div style={{ marginTop: '0.5rem' }}>
                <b>{importError}</b>
              </div>
            )}

            {importPreview && (
              <div style={{ marginTop: '0.5rem', width: '100%', maxWidth: '100%' }}>
                <p style={{ width: '100%' }}>
                  Preview fajla: <b>{importPreview.importedFileName}</b> | Pročitano redova: <b>{importPreview.parsedRows}</b> | Entiteta za izmenu: <b>{importPreview.changedEntities}</b>
                </p>
                <div className="uu-vector uu-vector--row uu-vector--wrap uu-gaps-m-05rem" style={{ width: '100%' }}>
                  <UniBtn
                    inline
                    circle
                    wide
                    i="fa fa-check"
                    title={importing ? 'Snimanje...' : 'Primeni import'}
                    disabled={importPreview.changedEntities === 0 || importing}
                    handleClick={handleApplyImport}
                  />
                  <UniBtn
                    inline
                    outline
                    circle
                    wide
                    i="fa fa-times"
                    title="Odbaci preview"
                    disabled={importing}
                    handleClick={() => {
                      setImportPreview(null);
                      setPendingImportUpdates([]);
                    }}
                  />
                </div>

                {importPreviewGroups.length > 0 && (
                  <div style={{ marginTop: '1rem', width: '100%', maxWidth: '100%' }}>
                    <p style={{ width: '100%' }}><b>Preview po destinaciji i po polju koje se menja:</b></p>
                    <div className="uu-vector uu-vector--col uu-vector--items-stretch uu-gaps-m-1rem" style={{ width: '100%' }}>
                      {importPreviewGroups.map((group) => (
                        <div key={String(group.destinationId || group.destinationTitle)} className="uu-p-8px uu-border-radius-4px" style={{ border: '1px solid #d6d3d1', backgroundColor: '#fcfcfb', width: '100%', maxWidth: '100%', boxSizing: 'border-box' }}>
                          <p>
                            <b>{group.destinationTitle}</b>
                            {group.changes.some((change) => change.subdestinationTitle) ? ' | Uključene poddestinacije' : ''}
                            {' | '}Entiteta za izmenu: <b>{group.changes.length}</b>
                          </p>
                          <div style={{ width: '100%', maxWidth: '100%', overflowX: 'auto' }}>
                            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px', tableLayout: 'fixed' }}>
                              <thead>
                                <tr style={{ backgroundColor: '#e7eef8' }}>
                                  <th style={{ textAlign: 'left', padding: '8px', border: '1px solid #dbe4f0' }}>ID</th>
                                  <th style={{ textAlign: 'left', padding: '8px', border: '1px solid #dbe4f0' }}>Entitet</th>
                                  <th style={{ textAlign: 'left', padding: '8px', border: '1px solid #dbe4f0' }}>Poddestinacija</th>
                                  <th style={{ textAlign: 'left', padding: '8px', border: '1px solid #dbe4f0' }}>Polja</th>
                                  <th style={{ textAlign: 'left', padding: '8px', border: '1px solid #dbe4f0' }}>Promene</th>
                                </tr>
                              </thead>
                              <tbody>
                                {group.changes.map((change) => (
                                  <tr key={change.entity.of_id} style={{ backgroundColor: '#ffffff' }}>
                                    <td style={{ verticalAlign: 'top', padding: '8px', border: '1px solid #e5e7eb', whiteSpace: 'nowrap' }}><b>#{change.entity.of_id}</b></td>
                                    <td style={{ verticalAlign: 'top', padding: '8px', border: '1px solid #e5e7eb', wordBreak: 'break-word', overflowWrap: 'anywhere', whiteSpace: 'pre-wrap' }}>{change.title}</td>
                                    <td style={{ verticalAlign: 'top', padding: '8px', border: '1px solid #e5e7eb', wordBreak: 'break-word', overflowWrap: 'anywhere', whiteSpace: 'pre-wrap' }}>{change.subdestinationTitle || '-'}</td>
                                    <td style={{ verticalAlign: 'top', padding: '8px', border: '1px solid #e5e7eb', color: '#1d4ed8', wordBreak: 'break-word', overflowWrap: 'anywhere', whiteSpace: 'pre-wrap' }}>{change.changedFieldsDisplay}</td>
                                    <td style={{ verticalAlign: 'top', padding: '8px', border: '1px solid #e5e7eb', wordBreak: 'break-word', overflowWrap: 'anywhere', whiteSpace: 'pre-wrap' }}>
                                      <div className="uu-vector uu-vector--col uu-vector--items-stretch uu-gaps-m-025rem" style={{ width: '100%' }}>
                                        {change.fieldDiffs.map((fieldDiff) => (
                                          <div key={fieldDiff.key} style={{ padding: '6px 8px', borderRadius: '6px', backgroundColor: '#f8fafc', borderLeft: '4px solid #2563eb', wordBreak: 'break-word', overflowWrap: 'anywhere' }}>
                                            <div><b>{fieldDiff.title}</b></div>
                                            <div style={{ color: '#9f1239', backgroundColor: '#fff1f2', padding: '2px 4px', borderRadius: '4px' }}>{fieldDiff.before === '' ? '(prazno)' : fieldDiff.before}</div>
                                            <div style={{ color: '#047857', backgroundColor: '#ecfdf5', padding: '2px 4px', borderRadius: '4px' }}>{fieldDiff.after === '' ? '(prazno)' : fieldDiff.after}</div>
                                          </div>
                                        ))}
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {importPreview.warnings.length > 0 && (
                  <div>
                    <p><b>Napomene iz preview-a:</b></p>
                    <div className="uu-vector uu-vector--col uu-gaps-m-025rem">
                      {importPreview.warnings.slice(0, 20).map((warning, index) => (
                        <small key={index}>{warning}</small>
                      ))}
                      {importPreview.warnings.length > 20 && (
                        <small>...i još {importPreview.warnings.length - 20} napomena.</small>
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}

            {importSummary && (
              <div style={{ marginTop: '0.5rem' }}>
                <p>
                  Fajl: <b>{importSummary.importedFileName}</b> | Pročitano redova: <b>{importSummary.parsedRows}</b> | Izmenjenih entiteta: <b>{importSummary.changedEntities}</b> | Uspešno snimljeno: <b>{importSummary.savedEntities}</b>
                </p>
                {importSummary.warnings.length > 0 && (
                  <div>
                    <p><b>Napomene:</b></p>
                    <div className="uu-vector uu-vector--col uu-gaps-m-025rem">
                      {importSummary.warnings.slice(0, 20).map((warning, index) => (
                        <small key={index}>{warning}</small>
                      ))}
                      {importSummary.warnings.length > 20 && (
                        <small>...i još {importSummary.warnings.length - 20} napomena.</small>
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}

            <div style={{ marginTop: '1.5rem', borderTop: '1px dashed #d6d3d1', paddingTop: '1rem' }}>
              <h4>Backup opcija: Export svega / Import svega</h4>
              <p>Ova opcija radi full backup preko kolone <b>backup_data_json</b> i služi za vraćanje kompletnih podataka entiteta bez backend izmena.</p>

              <div className="uu-vector uu-vector--row uu-vector--wrap uu-gaps-m-05rem">
                <UniBtn
                  inline
                  wide
                  circle
                  i="fa fa-download"
                  title="Download Full Backup"
                  disabled={activeYmthingEntities.length === 0 || importing || backupImporting}
                  handleClick={handleBackupExport}
                />
                <UniBtn
                  inline
                  wide
                  circle
                  outline
                  i="fa fa-upload"
                  title={backupImporting ? 'Import full backup u toku...' : 'Import Full Backup'}
                  disabled={importing || backupImporting}
                  handleClick={handleBackupImportClick}
                />
                <input
                  ref={backupFileInputRef}
                  type="file"
                  accept=".xlsx,.xls"
                  style={{ display: 'none' }}
                  onChange={handleBackupImportFile}
                />
              </div>

              <div style={{ marginTop: '0.5rem' }}>
                <small>Za full restore nemoj menjati <b>of_id</b> i <b>vr_tablename</b>. Polje <b>backup_data_json</b> mora biti validan JSON.</small>
              </div>

              {backupImportError !== '' && (
                <div style={{ marginTop: '0.5rem' }}>
                  <b>{backupImportError}</b>
                </div>
              )}

              {backupImportPreview && (
                <div style={{ marginTop: '0.5rem' }}>
                  <p>
                    Full backup preview: <b>{backupImportPreview.importedFileName}</b> | Pročitano redova: <b>{backupImportPreview.parsedRows}</b> | Entiteta za restore: <b>{backupImportPreview.changedEntities}</b>
                  </p>

                  <div className="uu-vector uu-vector--row uu-vector--wrap uu-gaps-m-05rem">
                    <UniBtn
                      inline
                      circle
                      wide
                      i="fa fa-check"
                      title={backupImporting ? 'Snimanje full backup...' : 'Primeni Full Backup Import'}
                      disabled={backupImportPreview.changedEntities === 0 || backupImporting || importing}
                      handleClick={handleApplyBackupImport}
                    />
                    <UniBtn
                      inline
                      outline
                      circle
                      wide
                      i="fa fa-times"
                      title="Odbaci full backup preview"
                      disabled={backupImporting}
                      handleClick={() => {
                        setBackupImportPreview(null);
                        setPendingBackupImportUpdates([]);
                      }}
                    />
                  </div>

                  {backupImportPreview.changes.length > 0 && (
                    <div style={{ marginTop: '0.5rem' }}>
                      <p><b>Prvih 30 entiteta za restore:</b></p>
                      <div className="uu-vector uu-vector--col uu-gaps-m-025rem">
                        {backupImportPreview.changes.slice(0, 30).map((change) => (
                          <small key={change.of_id}>#{change.of_id} | {change.destinationTitle || '-'} | {change.title} | {change.vr_tablename}</small>
                        ))}
                        {backupImportPreview.changes.length > 30 && (
                          <small>...i još {backupImportPreview.changes.length - 30} entiteta.</small>
                        )}
                      </div>
                    </div>
                  )}

                  {backupImportPreview.warnings.length > 0 && (
                    <div style={{ marginTop: '0.5rem' }}>
                      <p><b>Napomene full backup preview-a:</b></p>
                      <div className="uu-vector uu-vector--col uu-gaps-m-025rem">
                        {backupImportPreview.warnings.slice(0, 20).map((warning, index) => (
                          <small key={index}>{warning}</small>
                        ))}
                        {backupImportPreview.warnings.length > 20 && (
                          <small>...i još {backupImportPreview.warnings.length - 20} napomena.</small>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              )}

              {backupImportSummary && (
                <div style={{ marginTop: '0.5rem' }}>
                  <p>
                    Full backup fajl: <b>{backupImportSummary.importedFileName}</b> | Pročitano redova: <b>{backupImportSummary.parsedRows}</b> | Entiteta za restore: <b>{backupImportSummary.changedEntities}</b> | Uspešno snimljeno: <b>{backupImportSummary.savedEntities}</b>
                  </p>
                  {backupImportSummary.warnings.length > 0 && (
                    <div>
                      <p><b>Napomene:</b></p>
                      <div className="uu-vector uu-vector--col uu-gaps-m-025rem">
                        {backupImportSummary.warnings.slice(0, 20).map((warning, index) => (
                          <small key={index}>{warning}</small>
                        ))}
                        {backupImportSummary.warnings.length > 20 && (
                          <small>...i još {backupImportSummary.warnings.length - 20} napomena.</small>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};


//
const YourmapAdminPanelLayoutV2 = (props) => {
  const {
    route_freshness,
    setRouteFreshnesssUpdate,
    appState,
    lookup_pack,
  } = props.appPack;
  //
  const detected_env = _zzyourmap_config.ENV_EXTERNAL;
  const [sidebarOpened, setSidebarOpened] = useState(true);
  // let seller_route = 'HOME';
  // const setSellerRoute = () => { };
  const [adminPanelRoute1, setAdminPanelRoute1] = useState('HOME');
  const seller_route = adminPanelRoute1;
  const setSellerRoute = (href_admin_panel) => {
    setAdminPanelRoute1(href_admin_panel);
    setRouteFreshnesssUpdate();
  }
  //
  return (
    <>
      {
        props.adminPanelDebugOpened === true && (
          <>
            <div className="yourmap__admin-panel-debug-section-wrapper-v2">
              <CardCollapsible jsxHeader={<h2>* DEBUG</h2>}>
                <CardCollapsible fullWidth jsxHeader={<h2>* lookup_pack</h2>}>
                  lookup_pack:
                  <div>
                    <JSDisplayValue val={lookup_pack} />
                  </div>
                </CardCollapsible>
                <CardCollapsible fullWidth jsxHeader={<h2>* DEBUG state</h2>}>
                  state:
                  <div>
                    <JSDisplayValue val={appState} />
                  </div>
                </CardCollapsible>
              </CardCollapsible>
            </div>
          </>
        )
      }
      <div className="zzsurvey-app yourmap-theme__scope-admin-panel">
        <div className="zzsurvey__layout">

          <div className={"zzsurvey__layout-drawer" + (sidebarOpened ? " zzsurvey__layout-drawer--opened" : "")}>
            <div className="zzsurvey-app__menu-icon" onClick={() => { setSidebarOpened(false); }}><i className="fa fa-times" aria-hidden="true"></i></div>
            <div className="zzsurvey__layout__fix-header-push"></div>
            <div className="zzsurvey__layout-drawer__pad">
              <div className="sidebar-menu">
                <h3 className="">Yourmap Admin Panel</h3>
                <div className="options-group">
                  <SidebarOption
                    title={'Home/Dashboard'}
                    active={seller_route === 'HOME'}
                    handleClick={() => { setSellerRoute('HOME') }}
                    i="fa fa-home"
                  />
                  <SidebarOption
                    title={'Dokumentacija'}
                    active={seller_route === 'ADMIN_DOCS'}
                    handleClick={() => { setSellerRoute('ADMIN_DOCS') }}
                    i="fa fa-question-circle"
                  />
                  <SidebarOption
                    title={'Image library'}
                    active={seller_route === 'ADMIN_IMAGE_LIBRARY'}
                    handleClick={() => { setSellerRoute('ADMIN_IMAGE_LIBRARY') }}
                    i="fa fa-picture-o"
                  />
                  <SidebarOption
                    title={'Destinacije'}
                    active={seller_route === 'ADMIN_DESTINACIJE'}
                    handleClick={() => { setSellerRoute('ADMIN_DESTINACIJE') }}
                    i="fa fa-map-o"
                  />
                  <SidebarOption
                    disabled
                    title={'Smeštaji'}
                    active={seller_route === 'ADMIN_SMESTAJI'}
                    handleClick={() => { /* setSellerRoute('ADMIN_SMESTAJI') */ }}
                    i="fa fa fa-bed"
                  />
                  <SidebarOption
                    disabled
                    title={'Restorani'}
                    active={seller_route === 'ADMIN_RESTORANI'}
                    handleClick={() => { /* setSellerRoute('ADMIN_RESTORANI') */ }}
                    i="fa fa fa-cutlery"
                  />
                  <SidebarOption
                    title={'Djuture'}
                    active={seller_route === 'ADMIN_DJUTURE'}
                    handleClick={() => { setSellerRoute('ADMIN_DJUTURE') }}
                    i="fa fa-map-marker"
                  />
                  <SidebarOption
                    title={'Blog'}
                    active={seller_route === 'ADMIN_BLOG'}
                    handleClick={() => { setSellerRoute('ADMIN_BLOG') }}
                    i="fa fa-sticky-note-o"
                  />
                  <SidebarOption
                    title={'Redosled prikaza'}
                    active={seller_route === 'ADMIN_DISPLAY_ORDER'}
                    handleClick={() => { setSellerRoute('ADMIN_DISPLAY_ORDER') }}
                    i="fa fa-sort-amount-desc"
                  />
                  <SidebarOption
                    title={'Import / Export'}
                    active={seller_route === 'ADMIN_IMPORT_EXPORT'}
                    handleClick={() => { setSellerRoute('ADMIN_IMPORT_EXPORT') }}
                    i="fa fa-exchange"
                  />
                  <SidebarOption
                    title={'Izmene markera'}
                    active={seller_route === 'ADMIN_MARKER_BULK_EDIT'}
                    handleClick={() => { setSellerRoute('ADMIN_MARKER_BULK_EDIT') }}
                    i="fa fa-map-marker"
                  />
                </div>
                <h3 className="zzsurvey-temp-hide222">*</h3>
                <div className="options-group">
                  <SidebarOption
                    title={'* v1'}
                    active={seller_route === 'ADMIN_V1'}
                    handleClick={() => { setSellerRoute('ADMIN_V1') }}
                    i="fa fa-shield"
                  />
                  <SidebarOption
                    title={'* Open debug'}
                    active={props}
                    handleClick={() => { props.setAdminPanelDebugOpened(true) }}
                    i="fa fa fa-code"
                  />
                </div>
                <h3>Log out</h3>
                <div className="options-group">
                  <SidebarOption
                    title={'Logout'}
                    active={false}
                    handleClick={() => {
                      // open root route in browser
                      window.location.href = '/'; // This triggers a full page load from the server, discarding any client-side state like form data.
                    }}
                    i="fa fa-sign-out"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="zzsurvey__layout-main">
            <div className="zzsurvey__layout-page-wrapper">
              {
                /*
                <div className="zzsurvey-app__env">{detected_env}</div>
                {
                  detected_env === 'LOCALHOST' && (
                    <div className="zzsurvey-app__env">LOCALHOST ENVIRONMENT</div>
                  )
                }
                {
                  detected_env === 'DEMO' && (
                    <div className="zzsurvey-app__env">STG ENVIRONMENT FOR TESTING</div>
                  )
                }
                */
              }

              <div className="zzsurvey__layout-page-header">
                <div className="zzsurvey-app__menu-icon" onClick={() => { setSidebarOpened(true); }}><i className="fa fa-bars" aria-hidden="true"></i></div>
                <div className="zzsurvey__layout-page-header__bar">

                </div>
              </div>

              <div className="zzsurvey__layout__fix-header-push"></div>
              {/*<div className="zzsurvey__layout-page-body-section-dev">
              
              </div>
              */}


              <div className="zzsurvey__layout-page-body">
                <div className="zzsurvey-app__version">Version: {app_build_version_id_zzyourmap}</div>


                <SellerCardPage pageRouteActive={true} disableHeader={true} jsxHeader={<h2>Seller Dashboard</h2>} >
                  <SellerCardPage pageRouteActive={seller_route === 'HOME'} jsxHeader={<h1>Yourmap ADMIN PANEL v2</h1>}>
                    <div className="zzsurvey__dashboard-cards">
                      <div className="xi">
                        <div className="zzsurvey__card">
                          <SidebarOption
                            title={'Dokumentacija'}
                            active={seller_route === 'ADMIN_DOCS'}
                            handleClick={() => { setSellerRoute('ADMIN_DOCS') }}
                            i="fa fa-question-circle"
                          />
                          <p>Pomoć, uputstva, dokumentacija...</p>
                        </div>
                      </div>
                      <div className="xi">
                        <div className="zzsurvey__card">
                          <SidebarOption
                            title={'Image library'}
                            active={seller_route === 'ADMIN_IMAGE_LIBRARY'}
                            handleClick={() => { setSellerRoute('ADMIN_IMAGE_LIBRARY') }}
                            i="fa fa-picture-o"
                          />
                          <p>Pregled i baratanje svim slikama</p>
                        </div>
                      </div>
                      <div className="xi">
                        <div className="zzsurvey__card">
                          <SidebarOption
                            title={'Destinacije'}
                            active={seller_route === 'ADMIN_DESTINACIJE'}
                            handleClick={() => { setSellerRoute('ADMIN_DESTINACIJE') }}
                            i="fa fa-map-o"
                          />
                          <p>Turističke destinacije i poddestiancije</p>
                        </div>
                      </div>
                      <div className="xi">
                        <div className="zzsurvey__card">
                          <SidebarOption
                            disabled
                            title={'Smeštaji'}
                            active={seller_route === 'ADMIN_SMESTAJI'}
                            handleClick={() => { /* setSellerRoute('ADMIN_SMESTAJI') */ }}
                            i="fa fa fa-bed"
                          />
                          <p>Smeštaji</p>
                        </div>
                      </div>
                      <div className="xi">
                        <div className="zzsurvey__card">
                          <SidebarOption
                            disabled
                            title={'Restorani'}
                            active={seller_route === 'ADMIN_RESTORANI'}
                            handleClick={() => { /* setSellerRoute('ADMIN_RESTORANI') */ }}
                            i="fa fa fa-cutlery"
                          />
                          <p>Restorani, kafići...</p>
                        </div>
                      </div>
                      <div className="xi">
                        <div className="zzsurvey__card">
                          <SidebarOption
                            title={'Djuture'}
                            active={seller_route === 'ADMIN_DJUTURE'}
                            handleClick={() => { setSellerRoute('ADMIN_DJUTURE') }}
                            i="fa fa-map-marker"
                          />
                          <p>Djuture restorani, smestaji, prodavnice, servisi...</p>
                        </div>
                      </div>
                      <div className="xi">
                        <div className="zzsurvey__card">
                          <SidebarOption
                            title={'Blog'}
                            active={seller_route === 'ADMIN_BLOG'}
                            handleClick={() => { setSellerRoute('ADMIN_BLOG') }}
                            i="fa fa-sticky-note-o"
                          />
                          <p>Blog (Ostalo v1 ...ostalo i elementi koji imaju samo marker)</p>
                        </div>
                      </div>
                      <div className="xi">
                        <div className="zzsurvey__card">
                          <SidebarOption
                            title={'Redosled prikaza'}
                            active={seller_route === 'ADMIN_DISPLAY_ORDER'}
                            handleClick={() => { setSellerRoute('ADMIN_DISPLAY_ORDER') }}
                            i="fa fa-sort-amount-desc"
                          />
                          <p>Ručno poređaj redosled prikaza po destinaciji i tipu entiteta.</p>
                        </div>
                      </div>
                      <div className="xi">
                        <div className="zzsurvey__card">
                          <SidebarOption
                            title={'Import / Export'}
                            active={seller_route === 'ADMIN_IMPORT_EXPORT'}
                            handleClick={() => { setSellerRoute('ADMIN_IMPORT_EXPORT') }}
                            i="fa fa-exchange"
                          />
                          <p>Excel export i import tekstualnih polja za postojeće entitete po destinacijama.</p>
                        </div>
                      </div>
                      <div className="xi">
                        <div className="zzsurvey__card">
                          <SidebarOption
                            title={'Izmene markera'}
                            active={seller_route === 'ADMIN_MARKER_BULK_EDIT'}
                            handleClick={() => { setSellerRoute('ADMIN_MARKER_BULK_EDIT') }}
                            i="fa fa-map-marker"
                          />
                          <p>Bulk izmena markera po lokaciji: izbor više stavki i primena zajedničkih opcija.</p>
                        </div>
                      </div>
                      <div className="xi">
                        <div className="zzsurvey__card">
                          <SidebarOption
                            title={'* v1'}
                            active={seller_route === 'ADMIN_V1'}
                            handleClick={() => { setSellerRoute('ADMIN_V1') }}
                            i_EX="fa fa-check-square-o"
                            i="fa fa-shield"
                          />
                          <p>Admin panel v1, DEMO-i, eksperimentalne stvari...</p>
                        </div>
                      </div>
                      <div className="xi">
                        <div className="zzsurvey__card">
                          <SidebarOption
                            title={'* Open debug'}
                            active={false}
                            handleClick={() => { props.setAdminPanelDebugOpened(true) }}
                            i="fa fa fa-code"
                          />
                          <p>Otvori debug sekciju</p>
                        </div>
                      </div>
                      <div className="xi zzsurvey-temp-hide">
                      </div>
                    </div>
                  </SellerCardPage>

                  <SellerCardPage pageRouteActive={seller_route === 'ADMIN_DOCS'} jsxHeader={<h1>Dokumentacija</h1>} >
                    <YourmapDocs />
                  </SellerCardPage>

                  <SellerCardPage pageRouteActive={seller_route === 'ADMIN_IMAGE_LIBRARY'} jsxHeader={<h1>Image library</h1>} >
                    <YourmapImageLibraryV4
                      appPack={props.appPack}
                      enableAdminFunc={true}
                    />
                  </SellerCardPage>

                  <SellerCardPage pageRouteActive={seller_route === 'ADMIN_DESTINACIJE'} jsxHeader={<h1>Destinacije</h1>} >
                    <YourmapAdminDestinationList appPack={props.appPack} />
                  </SellerCardPage>

                  <SellerCardPage pageRouteActive={seller_route === 'ADMIN_SMESTAJI'} jsxHeader={<h1>Smeštaji</h1>} >
                    <p>* Premešteno u admin panel v2 djuture.</p>
                  </SellerCardPage>

                  <SellerCardPage pageRouteActive={seller_route === 'ADMIN_RESTORANI'} jsxHeader={<h1>Restorani</h1>} >
                    <p>* Premešteno u admin panel v2 djuture.</p>
                  </SellerCardPage>

                  <SellerCardPage pageRouteActive={seller_route === 'ADMIN_DJUTURE'} jsxHeader={<h1>Djuture</h1>} >
                    <YourmapAdminYmthingList appPack={props.appPack} />
                  </SellerCardPage>

                  <SellerCardPage pageRouteActive={seller_route === 'ADMIN_BLOG'} jsxHeader={<h1>Blog (Ostalo v1)</h1>} >
                    <Komentar>
                      <p>UNDER CONSTRUCTION</p>
                      <p>Napomena: ovo nije finalno, trba isprobati pa da se donesu odluke, pa ćemo korigovati.</p>
                      <p>Napomena: postoji privremeni <b>bug</b> da ove entitete neće da sortira po istom principu kao ostale, tako da obratiš pažnju za sada...</p>
                    </Komentar>
                    <YourmapAdminYmostaloV1List appPack={props.appPack} />
                  </SellerCardPage>

                  <SellerCardPage pageRouteActive={seller_route === 'ADMIN_DISPLAY_ORDER'} jsxHeader={<h1>Redosled prikaza entiteta</h1>} >
                    <YourmapAdminDisplayOrderPage appPack={props.appPack} />
                  </SellerCardPage>

                  <SellerCardPage pageRouteActive={seller_route === 'ADMIN_IMPORT_EXPORT'} jsxHeader={<h1>Import / Export</h1>} >
                    <YourmapAdminImportExportPage appPack={props.appPack} />
                  </SellerCardPage>

                  <SellerCardPage pageRouteActive={seller_route === 'ADMIN_MARKER_BULK_EDIT'} jsxHeader={<h1>Izmene markera</h1>} >
                    <YourmapAdminMarkerBulkEditPage appPack={props.appPack} />
                  </SellerCardPage>

                  <SellerCardPage pageRouteActive={seller_route === 'ADMIN_V1'} jsxHeader={<h1>* v1</h1>} >
                    <YourmapAdminPanelLayoutV1 appPack={props.appPack} />
                  </SellerCardPage>
                </SellerCardPage>


              </div>

              <div className="zzsurvey__layout-page-footer">Copyright © 2026 Žarko Turićanin, Dušan Mitrović</div>

            </div>
          </div>

        </div>
      </div>
    </>
  );
};


//
const YourmapAdminPanelLayoutV1 = (props) => {
  const {
    appState,
    show_admin_panel_login,
    lookup_pack,
    setUniModalPortableContent,
    setUniModalPortableClose,
  } = props.appPack;
  //
  return (
    <>
      <div className="yourmap yourmap__wrapper yourmap__admin-panel-wrapper-v1">
        <CardCollapsible fullWidth jsxHeader={<h1>Yourmap ADMIN PANEL v1</h1>}>
          <section>
            <div className="inner-admin-panel">

              <CardCollapsible jsxHeader={<h2>* DEBUG</h2>}>
                <CardCollapsible fullWidth jsxHeader={<h2>* lookup_pack</h2>}>
                  lookup_pack:
                  <div>
                    <JSDisplayValue val={lookup_pack} />
                  </div>
                </CardCollapsible>
                <CardCollapsible fullWidth jsxHeader={<h2>* DEBUG state</h2>}>
                  state:
                  <div>
                    <JSDisplayValue val={appState} />
                  </div>
                </CardCollapsible>

                <CardCollapsible jsxHeader={<h2>* Admin panel *C</h2>}>
                  *C
                </CardCollapsible>

                <CardCollapsible jsxHeader={<h2>* Admin panel *D</h2>}>
                  *D
                  <div>
                    <UniSpinnerClassic />
                    <UniSpinnerClassic />
                    MMMmmm<UniSpinnerClassic inline />MMmmm
                    INLSMmmm<UniSpinnerClassic inlineSmall />MMmmm
                    IN-S-mmm<UniSpinnerClassic inline s />MMmmm
                    XSmmm<UniSpinnerClassic inline xs /><UniSpinnerClassic inline xs />MMmmm
                    XXSmmm<UniSpinnerClassic inline xxs /><UniSpinnerClassic inline xxs />MMmmm
                    XXXSmmm<UniSpinnerClassic inline xxxs /><UniSpinnerClassic inline xxxs />MMmmm
                    MMMmmm<UniSpinnerClassic xs />MMmmm
                    <UniSpinnerClassic xs />
                    <UniSpinnerClassic xs />
                    <UniSpinnerClassic xxs />
                    <UniSpinnerClassic xxs />
                    <UniSpinnerClassic xxxs />
                    <UniSpinnerClassic xxxs />
                  </div>
                </CardCollapsible>
              </CardCollapsible>

              <CardCollapsible jsxHeader={<h2>Dokumentacija</h2>}>
                <YourmapDocs />
              </CardCollapsible>

              <CardCollapsible jsxHeader={<h2>Admin Panel IMAGE LIBRARY</h2>}>
                <YourmapImageLibraryV4
                  appPack={props.appPack}
                  enableAdminFunc={true}
                />
              </CardCollapsible>

              <CardCollapsible jsxHeader={<h2>Admin Panel DESTINACIJE</h2>}>
                <YourmapAdminDestinationList appPack={props.appPack} />
              </CardCollapsible>

              <CardCollapsible jsxHeader={<h2>Admin Panel SMEŠTAJI</h2>}>
                <p>* Premešteno u admin panel v2 djuture.</p>
              </CardCollapsible>

              <CardCollapsible jsxHeader={<h2>Admin Panel RESTORANI</h2>}>
                <p>* Premešteno u admin panel v2 djuture.</p>
              </CardCollapsible>

              <CardCollapsible jsxHeader={<h2>Admin Panel * OSTALO v1</h2>}>
                <Komentar>
                  <p>UNDER CONSTRUCTION</p>
                  <p>Napomena: ovo nije finalno, trba isprobati pa da se donesu odluke, pa ćemo korigovati.</p>
                  <p>Napomena: postoji privremeni <b>bug</b> da ove entitete neće da sortira po istom principu kao ostale, tako da obratiš pažnju za sada...</p>
                </Komentar>
                <YourmapAdminYmostaloV1List appPack={props.appPack} />
              </CardCollapsible>

              <CardCollapsible jsxHeader={<h2>* DEMO BLOG EDITOR Editor.js</h2>}>
                <YourmapEditorjsDemoV1 />
              </CardCollapsible>

              <CardCollapsible fullWidth jsxHeader={<h2>* DEMO Admin Panel mapa</h2>}>
                <YourmapAdminMapDemoV1 appPack={props.appPack} />
              </CardCollapsible>

            </div>
          </section>
        </CardCollapsible>
      </div>
    </>
  );
};



//
export const YourmapAdminPanel = (props) => {
  const {
    appState,
    show_admin_panel_login,
    lookup_pack,
    setUniModalPortableContent,
    setUniModalPortableClose,
  } = props.appPack;

  const [adminPanelOpened, setAdminPanelOpened] = useState(false);
  const [adminPanelDebugOpened, setAdminPanelDebugOpened] = useState(false);

  if (show_admin_panel_login === true) {
    // continue showing admin panel
  } else { // show nothing
    return (
      <></>
    );
  }

  if (adminPanelOpened === false) {
    const cbDialogSubmit = (loginFormState) => {
      // console.log('SUBMIT LOGIN', loginFormState);
      if (loginFormState && loginFormState.username === "admin" && loginFormState.password === "admin") {
        // LOGIN SUCCESS
        setAdminPanelOpened(true);
        setUniModalPortableClose();
      }
    };
    // const cbDialogCancel = ()=>{ };
    return (
      <>
        <div className="yourmap__admin-panel-temp-enter"><div onClick={() => {
          // setAdminPanelOpened(true);
          setUniModalPortableContent({
            options: {
              large: true,
            },
            jsx: (
              <>
                <YourmapAdminPanelFormLogin
                  cbDialogSubmit={cbDialogSubmit}
                  cbDialogCancel={() => { setUniModalPortableClose(); }}
                />
              </>
            ),
          });
        }}><span>ADMIN PANEL</span></div></div>
      </>
    );
  }
  //
  return (
    <>
      <div className="yourmap__admin-panel-wrapper-v2">
        <YourmapAdminPanelLayoutV2
          appPack={props.appPack}
          adminPanelDebugOpened={adminPanelDebugOpened}
          setAdminPanelDebugOpened={setAdminPanelDebugOpened}
        />
      </div>
    </>
  );
};

